// src/Address/index.ts
var State = /* @__PURE__ */ ((State2) => {
  State2["AA"] = "AA";
  State2["AE"] = "AE";
  State2["AP"] = "AP";
  State2["AK"] = "AK";
  State2["AL"] = "AL";
  State2["AR"] = "AR";
  State2["AZ"] = "AZ";
  State2["CA"] = "CA";
  State2["CO"] = "CO";
  State2["CT"] = "CT";
  State2["DC"] = "DC";
  State2["DE"] = "DE";
  State2["FL"] = "FL";
  State2["GA"] = "GA";
  State2["HI"] = "HI";
  State2["IA"] = "IA";
  State2["ID"] = "ID";
  State2["IL"] = "IL";
  State2["IN"] = "IN";
  State2["KS"] = "KS";
  State2["KY"] = "KY";
  State2["LA"] = "LA";
  State2["MA"] = "MA";
  State2["MD"] = "MD";
  State2["ME"] = "ME";
  State2["MI"] = "MI";
  State2["MN"] = "MN";
  State2["MO"] = "MO";
  State2["MS"] = "MS";
  State2["MT"] = "MT";
  State2["NC"] = "NC";
  State2["ND"] = "ND";
  State2["NE"] = "NE";
  State2["NH"] = "NH";
  State2["NJ"] = "NJ";
  State2["NM"] = "NM";
  State2["NV"] = "NV";
  State2["NY"] = "NY";
  State2["OH"] = "OH";
  State2["OK"] = "OK";
  State2["OR"] = "OR";
  State2["PA"] = "PA";
  State2["PR"] = "PR";
  State2["RI"] = "RI";
  State2["SC"] = "SC";
  State2["SD"] = "SD";
  State2["TN"] = "TN";
  State2["TX"] = "TX";
  State2["UT"] = "UT";
  State2["VA"] = "VA";
  State2["VT"] = "VT";
  State2["WA"] = "WA";
  State2["WI"] = "WI";
  State2["WV"] = "WV";
  State2["WY"] = "WY";
  State2["AS"] = "AS";
  State2["FM"] = "FM";
  State2["GU"] = "GU";
  State2["MH"] = "MH";
  State2["MP"] = "MP";
  State2["PW"] = "PW";
  State2["VI"] = "VI";
  return State2;
})(State || {});
var StateMap = {
  "armed forces the americas": "AA" /* AA */,
  "armed forces europe": "AE" /* AE */,
  "armed forces pacific": "AP" /* AP */,
  alabama: "AL" /* AL */,
  alaska: "AK" /* AK */,
  arizona: "AZ" /* AZ */,
  arkansas: "AR" /* AR */,
  california: "CA" /* CA */,
  colorado: "CO" /* CO */,
  connecticut: "CT" /* CT */,
  delaware: "DE" /* DE */,
  "district of columbia": "DC" /* DC */,
  florida: "FL" /* FL */,
  georgia: "GA" /* GA */,
  hawaii: "HI" /* HI */,
  idaho: "ID" /* ID */,
  illinois: "IL" /* IL */,
  indiana: "IN" /* IN */,
  iowa: "IA" /* IA */,
  kansas: "KS" /* KS */,
  kentucky: "KY" /* KY */,
  louisiana: "LA" /* LA */,
  maine: "ME" /* ME */,
  maryland: "MD" /* MD */,
  massachusetts: "MA" /* MA */,
  michigan: "MI" /* MI */,
  minnesota: "MN" /* MN */,
  mississippi: "MS" /* MS */,
  missouri: "MO" /* MO */,
  montana: "MT" /* MT */,
  nebraska: "NE" /* NE */,
  nevada: "NV" /* NV */,
  "new hampshire": "NH" /* NH */,
  "new jersey": "NJ" /* NJ */,
  "new mexico": "NM" /* NM */,
  "new york": "NY" /* NY */,
  "north carolina": "NC" /* NC */,
  "north dakota": "ND" /* ND */,
  ohio: "OH" /* OH */,
  oklahoma: "OK" /* OK */,
  oregon: "OR" /* OR */,
  pennsylvania: "PA" /* PA */,
  "puerto rico": "PR" /* PR */,
  "rhode island": "RI" /* RI */,
  "south carolina": "SC" /* SC */,
  "south dakota": "SD" /* SD */,
  tennessee: "TN" /* TN */,
  texas: "TX" /* TX */,
  utah: "UT" /* UT */,
  vermont: "VT" /* VT */,
  virginia: "VA" /* VA */,
  washington: "WA" /* WA */,
  "west virginia": "WV" /* WV */,
  wisconsin: "WI" /* WI */,
  wyoming: "WY" /* WY */,
  "american samoa": "AS" /* AS */,
  micronesia: "FM" /* FM */,
  guam: "GU" /* GU */,
  "marshall islands": "MH" /* MH */,
  "northern mariana islands": "MP" /* MP */,
  palau: "PW" /* PW */,
  "u.s. virgin islands": "VI" /* VI */
};
var AbbrevToNameMap = {
  AA: "Armed Forces the Americas",
  AE: "Armed Forces Europe",
  AP: "Armed Forces Pacific",
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
  AS: "American Samoa",
  FM: "Micronesia",
  GU: "Guam",
  MH: "Marshall Islands",
  MP: "Northern Mariana Islands",
  PW: "Palau",
  VI: "U.S. Virgin Islands"
};

// src/Document/index.ts
var DocumentType = /* @__PURE__ */ ((DocumentType2) => {
  DocumentType2["ADMINISTRATIVE_CLAIM_DENIAL_LETTER"] = "Administrative Claim Denial Letter";
  DocumentType2["AFFF_PLAINTIFF_FACT_SHEET"] = "AFFF Plaintiff Fact Sheet";
  DocumentType2["AGING_DOCUMENT_REQUEST"] = "aging-document-request";
  DocumentType2["ALTERNATIVE_LIVING_ARRANGEMENTS"] = "Alternative Living Arrangements";
  DocumentType2["ALTERNATIVE_LIVING_EXPENSES"] = "Alternative Living Expenses";
  DocumentType2["AMENITIES"] = "Amenities";
  DocumentType2["ATTACHMENT"] = "attachment";
  DocumentType2["AUTOPSY_REPORT"] = "Autopsy Report";
  DocumentType2["BABY_PICTURES"] = "Baby/Birth Pictures";
  DocumentType2["BANK_STATEMENT"] = "Bank Statement";
  DocumentType2["BILLING_RECORDS"] = "Billing Records";
  DocumentType2["BRUSH_CLEARANCE"] = "Brush Clearance";
  DocumentType2["BUILDING_PERMITS"] = "Building Permits";
  DocumentType2["BUSINESS_LOSSES"] = "Business Losses";
  DocumentType2["CERTIFIED_MEDICAL_RECORDS"] = "Certified Medical Records";
  DocumentType2["CIVIL_CASE_COVER_SHEET_ADDENDUM"] = "Civil Case Cover Sheet Addendum";
  DocumentType2["CIVIL_COVER_SHEET"] = "Civil Cover Sheet";
  DocumentType2["CLAIMANT_CORRESPONDENCE"] = "Claimant Correspondence";
  DocumentType2["CLAIMANT_REP_DOCUMENT"] = "Claimant Rep Document";
  DocumentType2["CRASH_REPORT"] = "Crash Report";
  DocumentType2["CLAIMANT_SEARCH_REPORT"] = "Claimant Search Report";
  DocumentType2["CLIENT_CALL_NOTES"] = "Client Call Notes";
  DocumentType2["CLIENT_PRESERVATION_NOTICE"] = "Client Preservation Notice";
  DocumentType2["CLJA_ClAIMS_FORM"] = "CLJA Claims Form";
  DocumentType2["COMMERCIAL_EQUIPMENT_LIST"] = "Commercial Equipment List";
  DocumentType2["COMMERCIAL_INVENTORY_LIST"] = "Commercial Inventory List";
  DocumentType2["CONFIRMED_QUESTIONNAIRE"] = "Confirmed Questionnaire";
  DocumentType2["CUSTOM_FACILITY_RELEASE"] = "Custom Facility Release";
  DocumentType2["CUSTOM_MEDICAL_RELEASE"] = "Custom Medical Release";
  DocumentType2["CUSTOM_RELEASE_OF_INFORMATION_FORM"] = "Custom Release of Information Form";
  DocumentType2["DD_214"] = "DD-214";
  DocumentType2["DEATH_CERTIFICATE"] = "Death Certificate";
  DocumentType2["DECLINATION_LETTER"] = "Declination Letter";
  DocumentType2["DEMANDS"] = "Demands";
  DocumentType2["DIRECTORY"] = "Directory";
  DocumentType2["DISCOVERY_DOC_TEMPLATE"] = "Discovery Doc Template";
  DocumentType2["DISCOVERY_DOCUMENT"] = "Discovery Document";
  DocumentType2["DMA_IMPORT_MEDICAL_RECORDS"] = "DMA-IMPORT Medical Records";
  DocumentType2["DMA_IMPORT_MEDICAL_RELEASE"] = "DMA IMPORT Medical Release";
  DocumentType2["DMA_IMPORT_PACKET"] = "DMA-IMPORT Packet";
  DocumentType2["DMA_IMPORT_QUESTIONNAIRE"] = "DMA-IMPORT Questionnaire";
  DocumentType2["DMA_IMPORT_RETAINER"] = "DMA-IMPORT Retainer";
  DocumentType2["DMA_IMPORT_UNKNOWN"] = "DMA-IMPORT Unknown";
  DocumentType2["DOCUMENT_CONSOLIDATION"] = "Document Consolidation";
  DocumentType2["DOCUMENT_CHECKLIST"] = "Document Checklist";
  DocumentType2["DOCUMENT_REQUEST"] = "document-request";
  DocumentType2["DOCUMENT_REQUEST_CANCELLATION"] = "Document Request Cancellation";
  DocumentType2["DOCX_TEMPLATE"] = "DOCX Template";
  DocumentType2["DRONE"] = "Drone";
  DocumentType2["DRONE_PHOTO_DATA"] = "Drone Photo Data";
  DocumentType2["E_SIGNATURE_AUDIT_TRAIL"] = "eSignature Audit Trail";
  DocumentType2["ELECTRONIC_COMMUNICATION_CONSENT_FORM"] = "Electronic Communication Consent Form";
  DocumentType2["EMAIL_LEAD_IMPORT_DOCUMENT"] = "Email Lead Import Document";
  DocumentType2["ENGAGEMENT_LETTER"] = "Engagement Letter";
  DocumentType2["EROSION"] = "Erosion";
  DocumentType2["EVACUATION_NOTICE"] = "Evacuation Notice";
  DocumentType2["FACILITY_CORRESPONDENCE"] = "Facility Correspondence";
  DocumentType2["FLAGGED_DMA_PACKET"] = "FLAGGED - DMA Packet";
  DocumentType2["FLAGGED_MEDICAL_RELEASE"] = "FLAGGED - Medical Release";
  DocumentType2["FOIA"] = "FOIA";
  DocumentType2["FUNDS_DISBURSEMENT"] = "Funds disbursement";
  DocumentType2["GUARDIAN_AD_LITEM_APPLICATION"] = "Guardian Ad Litem Application";
  DocumentType2["GUARDIAN_AD_LITEM_ORDER"] = "Guardian Ad Litem Order";
  DocumentType2["HOUSEHOLD_INVENTORY_FORM"] = "Household Inventory Form";
  DocumentType2["IMAGING_RECORDS"] = "Imaging Records";
  DocumentType2["IMMEDIATE_ACTION_LETTER"] = "Immediate Action Letter";
  DocumentType2["IMPROVEMENT_UPGRADES"] = "Improvement/Upgrades";
  DocumentType2["INCOME_TAX_RETURNS"] = "Income Tax Returns";
  DocumentType2["INCIDENT_REPORT"] = "Incident Report";
  DocumentType2["INITIALS"] = "Initials";
  DocumentType2["INSPECTIONS"] = "Inspections";
  DocumentType2["INTAKE_FORM"] = "Intake Form";
  DocumentType2["INSURANCE"] = "Insurance";
  DocumentType2["INSURANCE_CLAIM_FILE"] = "Insurance Claim File";
  DocumentType2["INSURANCE_CLAIM_FILE_FIRM_PRODUCED"] = "Insurance Claim File (Firm Produced)";
  DocumentType2["INSURANCE_PAYMENT_RECORD"] = "Insurance Payment Record";
  DocumentType2["INSURANCE_RELEASE"] = "Insurance Release";
  DocumentType2["INVESTIGATION"] = "Investigation";
  DocumentType2["INVOICE"] = "Invoice";
  DocumentType2["INVOICE_RECEIPT"] = "Invoice Receipt";
  DocumentType2["JUVENILE_DETENTION_RECORDS"] = "Juvenile Detention Records";
  DocumentType2["LAW_FIRM_ATTESTATION"] = "Law Firm Attestation";
  DocumentType2["LAW_FIRM_CORRESPONDENCE"] = "Law Firm Correspondence";
  DocumentType2["LAW_FIRM_LETTER_OF_REPRESENTATION"] = "Law Firm Letter of Representation";
  DocumentType2["LAW_FIRM_NOTES"] = "Law Firm Notes";
  DocumentType2["LANDSCAPING"] = "Landscaping";
  DocumentType2["LEASE_AGREEMENT_CANCELED_RENT_CHECKS"] = "Lease Agreement/Canceled Rent Checks";
  DocumentType2["LEGACY"] = "legacy";
  DocumentType2["LETTER_OF_PROTECTION"] = "Letter of Protection";
  DocumentType2["LETTER_OF_REPRESENTATION"] = "Letter of Representation";
  DocumentType2["LIEN"] = "Lien";
  DocumentType2["LOAN_APPLICATIONS_MORTGAGE"] = "Loan Applications/Mortgage";
  DocumentType2["LOAN_DOCUMENTS"] = "Loan Documents";
  DocumentType2["MAIL_MEDICAL_RELEASE"] = "mail medical release";
  DocumentType2["MANUAL_DOCUMENT_REQUEST"] = "Manual Document Request";
  DocumentType2["MARKED_FOR_DELETION"] = "Marked For Deletion";
  DocumentType2["MEDICAID_RECOVERY_FORM"] = "Medicaid Recovery Form";
  DocumentType2["MEDICAL_CHRONOLOGY"] = "Medical Chronology";
  DocumentType2["MEDICAL_RECORDS"] = "Medical Records";
  DocumentType2["MEDICAL_RECORDS_CERTIFICATION"] = "Medical Records Certification";
  DocumentType2["MEDICAL_RELEASE"] = "Medical Release";
  DocumentType2["MEDICARE_LETTER_OF_REPRESENTATION_FORM"] = "Medicare Letter of Representation Form";
  DocumentType2["NOTICE_OF_ACKNOWLEDGEMENT_OF_RECEIPT"] = "Notice of Acknowledgement of Receipt";
  DocumentType2["NOTICE_OF_ADOPTION_OF_MASTER_COMPLAINT"] = "Notice of Adoption of Master Complaint";
  DocumentType2["NOTICE_OF_RELATED_CASE"] = "Notice of Related Case";
  DocumentType2["MISCELLANEOUS_DAMAGES"] = "Miscellaneous Damages";
  DocumentType2["MILITARY_RECORDS_DOCS"] = "Military Records/Docs";
  DocumentType2["OBJECTION_TO_INSURANCE_CLAIM_FILE_PRODUCTION"] = "Objection to Insurance Claim File Production";
  DocumentType2["OBITUARY"] = "Obituary";
  DocumentType2["ONDER_IMPORT"] = "onder-import";
  DocumentType2["ONDER_QUESTIONNAIRE"] = "Onder Questionnaire";
  DocumentType2["ORIGINAL_FLOOR_PLANS"] = "Original Floor Plans";
  DocumentType2["OTHER"] = "Other";
  DocumentType2["OTHER_REPAIRS"] = "Other Repairs";
  DocumentType2["OTHER_STRUCTURES"] = "Other Structures";
  DocumentType2["OUTBOUND_MAIL_PACKET"] = "Outbound Mail Packet";
  DocumentType2["PACKET"] = "Packet";
  DocumentType2["PARTIAL_MEDICAL_RECORDS"] = "Partial Medical Records";
  DocumentType2["PASSWORD"] = "Password";
  DocumentType2["PAYCHECK_STUBS"] = "Paycheck Stubs";
  DocumentType2["PAYROLL_RECORDS"] = "Payroll Records";
  DocumentType2["PENDING_MAILROOM"] = "pending-mailroom";
  DocumentType2["PERSONAL_PROPERTY"] = "Personal Property";
  DocumentType2["PERSONAL_PROPERTY_APPRAISAL"] = "Personal Property Appraisal";
  DocumentType2["PHOTO_ID"] = "Photo ID";
  DocumentType2["PHOTOS"] = "Photos";
  DocumentType2["PI_INTAKE_QUESTIONNAIRE"] = "PI Intake Questionnaire";
  DocumentType2["POLICE_REPORT"] = "Police report";
  DocumentType2["PORTAL_PENDING_SCREENING"] = "Portal Pending Screening";
  DocumentType2["POSTAGE_TRACKING"] = "Postage/Tracking";
  DocumentType2["PRESERVATION_OF_EVIDENCE"] = "Preservation of Evidence";
  DocumentType2["PROOF_OF_EMPLOYMENT"] = "Proof of Employment";
  DocumentType2["PROOF_OF_EXPOSURE"] = "Proof of Exposure";
  DocumentType2["PROOF_OF_OWNERSHIP"] = "Proof of Ownership";
  DocumentType2["PROOF_OF_USE_AFFIDAVIT"] = "Proof of Use Affidavit";
  DocumentType2["PROOF_OF_SERVICE"] = "Proof of Service";
  DocumentType2["PROOF_OF_USE_CERTIFICATION"] = "Proof of Use Certification";
  DocumentType2["PROPERTY_DAMAGE"] = "Property Damage";
  DocumentType2["PUBLIC_RECORD_REQUEST"] = "Public Record Request";
  DocumentType2["PURCHASE_OR_SALE_RECORD"] = "Purchase or Sale Record";
  DocumentType2["PROPERTY_VERIFICATION_DOCUMENTS"] = "Property Verification Documents";
  DocumentType2["QE_ORIGINAL_PERSONAL_CLAIMS_FORM"] = "QE (Original) Personal Claims Form";
  DocumentType2["QE_ORIGINAL_PROPERTY_CLAIMS_FORM"] = "QE (Original) Property Claims Form";
  DocumentType2["QUESTIONNAIRE"] = "Questionnaire";
  DocumentType2["REAL_ESTATE_APPRAISAL"] = "Real Estate Appraisal";
  DocumentType2["REAL_ESTATE_TAX_RECORD"] = "Real Estate Tax Record";
  DocumentType2["REBUILD_ESTIMATE"] = "Rebuild Estimate";
  DocumentType2["RECEIPTS"] = "Receipts";
  DocumentType2["REJECTION"] = "Rejection";
  DocumentType2["REMEDIATION_DEBRIS_REMOVAL_EXPENSE"] = "Remediation/Debris Removal Expense";
  DocumentType2["REPRESENTATIVE_DOCUMENT"] = "Representative Document";
  DocumentType2["REQUEST_CONFIRMATION"] = "Request Confirmation";
  DocumentType2["REQUEST_FOR_SETTLEMENT"] = "Request for settlement";
  DocumentType2["RETAINER"] = "retainer";
  DocumentType2["RETURNED_CHECK"] = "Returned Check";
  DocumentType2["RETURNED_MAIL"] = "Returned Mail";
  DocumentType2["REVIEW_SUMMARY"] = "review-summary";
  DocumentType2["SALES_RECORDS"] = "Sales Records";
  DocumentType2["SCHOOL_RECORDS"] = "School Records";
  DocumentType2["SETTLEMENT_DOCUMENTS"] = "Settlement documents";
  DocumentType2["SETTLEMENT_PACKET"] = "Settlement Packet";
  DocumentType2["SETTLEMENT_PREP_FORM"] = "Settlement Prep Form";
  DocumentType2["SHORT_FORM_COMPLAINT"] = "Short Form Complaint";
  DocumentType2["SUMMONS"] = "Summons";
  DocumentType2["SHORT_FORM_MEMO"] = "Short Form Memo";
  DocumentType2["SIGN_UP_SHEET"] = "Sign Up Sheet";
  DocumentType2["SIGNATURE"] = "Signature";
  DocumentType2["SIGNATURE_RELEASE_AGREEMENT"] = "Signature Release Agreement";
  DocumentType2["SOIL_TESTING"] = "Soil Testing";
  DocumentType2["TAX_IDENTIFICATION_DOCUMENTS"] = "Tax Identification Documents";
  DocumentType2["TITLE_DEED"] = "Title/Deed";
  DocumentType2["TOLLING_DOCUMENTS"] = "Tolling Documents";
  DocumentType2["TOXICITY_REMEDIATION_REPORT"] = "Toxicity/Remediation Report";
  DocumentType2["TREATMENT_REFERRALS"] = "Treatment Referrals";
  DocumentType2["TRUST_DOCUMENTS"] = "Trust Documents";
  DocumentType2["TURNOVER_LETTER"] = "Turnover Letter";
  DocumentType2["UNCATEGORIZED"] = "Uncategorized";
  DocumentType2["UNKNOWN"] = "UNKNOWN";
  DocumentType2["UNKNOWN_IMAGE"] = "UNKNOWN IMAGE";
  DocumentType2["UNREDACTED_MEDICAL_RECORDS"] = "Unredacted Medical Records";
  DocumentType2["UNSPLIT_RETAINER"] = "unsplit-retainer";
  DocumentType2["USDA_APPLICATION"] = "USDA Application";
  DocumentType2["VEGETATION_LANDSCAPING"] = "Vegetation/Landscaping";
  DocumentType2["VETERINARY_RECORDS"] = "Veterinary Records";
  DocumentType2["VA_BENEFITS_SUMMARY"] = "VA Benefits Summary";
  DocumentType2["VA_RATINGS_DECISION"] = "VA Ratings Decision";
  DocumentType2["W_9"] = "W-9";
  DocumentType2["ZIPLIENS"] = "ZipLiens";
  DocumentType2["ZIPLIENS_CORRESPONDENCE"] = "ZipLiens Correspondence";
  DocumentType2["ZIPLIENS_ITEMIZATIONS"] = "ZipLiens Itemizations";
  DocumentType2["ZIPLIENS_OTHER_MISC"] = "ZipLiens Other / Misc";
  DocumentType2["ZIPLIENS_REDUCTIONS_COUNTERS"] = "ZipLiens Reductions/Counters";
  DocumentType2["PARTIAL_BILLING_RECORDS"] = "Partial Billing Records";
  DocumentType2["CERTIFIED_BILLING_RECORDS"] = "Certified Billing Records";
  DocumentType2["BILLING_RECORD_CERTIFICATE"] = "Billing Record Certificate";
  DocumentType2["FEE_REDUCTION"] = "Fee Reduction";
  DocumentType2["BILLING_REDUCTION"] = "Billing Reduction";
  DocumentType2["VIDEO"] = "Video";
  DocumentType2["WRONGFUL_DEATH"] = "Wrongful Death";
  return DocumentType2;
})(DocumentType || {});
var DocumentSubType = /* @__PURE__ */ ((DocumentSubType2) => {
  DocumentSubType2["ACCEPTANCE_LETTER"] = "Acceptance Letter";
  DocumentSubType2["ADDENDUM"] = `Addendum`;
  DocumentSubType2["ADDRESS_CONFIRMATION"] = "Address Confirmation";
  DocumentSubType2["ADOPTION_DOCUMENT"] = `Adoption Document`;
  DocumentSubType2["AFFIDAVIT"] = "Affidavit";
  DocumentSubType2["AFFIDAVIT_OF_HEIRSHIP"] = "Affidavit of Heirship";
  DocumentSubType2["AT_FAULTS_VEHICLE"] = "At Fault's Vehicle";
  DocumentSubType2["AUTHORIZATIONS"] = `Authorizations`;
  DocumentSubType2["AUTOMATICALLY_LIFTED_SIGNATURE"] = "Automatically Lifted Signature";
  DocumentSubType2["BANKRUPTCY_DOCUMENT"] = `Bankruptcy Document`;
  DocumentSubType2["BELLWETHER_SUPPLEMENT"] = `Bellwether Supplement`;
  DocumentSubType2["BI_ACKNOWLEDGEMENT_LETTER"] = "BI Acknowledgement Letter";
  DocumentSubType2["BI_CORRESPONDENCE"] = "BI Correspondence";
  DocumentSubType2["BI_DECLARATION_PAGE"] = "BI Declaration Page";
  DocumentSubType2["BI_DENIAL_LETTER"] = "BI Denial Letter";
  DocumentSubType2["BIRTH_CERTIFICATE"] = `Birth Certificate`;
  DocumentSubType2["BODILY_INJURY"] = "Bodily Injury";
  DocumentSubType2["CANCELLATION_INVOICE"] = "Cancellation Invoice";
  DocumentSubType2["CARD"] = "Card";
  DocumentSubType2["CARS_NURSE_REVIEW"] = `CARS Nurse Review`;
  DocumentSubType2["CASE_FILING"] = `Case Filing`;
  DocumentSubType2["CENSUS_CERTIFICATION"] = `Census Certification`;
  DocumentSubType2["CENSUS_FORM"] = `Census Form`;
  DocumentSubType2["CERTIFICATE_OF_NO_RECORDS"] = "Certificate of No Records";
  DocumentSubType2["CLAIMANTS_VEHICLE"] = "Claimant's Vehicle";
  DocumentSubType2["CLAIMS_FORM"] = `Claims Form`;
  DocumentSubType2["CLIENT_DECEASED"] = `Client Deceased`;
  DocumentSubType2["CLIENT_INTAKE"] = `Client Intake`;
  DocumentSubType2["CLIENT_NOTE"] = `Client Note`;
  DocumentSubType2["CO_COUNSEL_AUTHORIZATION"] = `Co-Counsel Authorization`;
  DocumentSubType2["CO_COUNSEL_COMMUNICATION"] = `Co-Counsel Communication`;
  DocumentSubType2["CO_COUNSEL_COMPLAINT_FILED"] = `Co-Counsel Complaint Filed`;
  DocumentSubType2["CONTRACT"] = "Contract";
  DocumentSubType2["COUNTER_OFFER_LETTER"] = "Counter-offer Letter";
  DocumentSubType2["CRASH"] = "Crash";
  DocumentSubType2["CRASH_REPORT"] = "Crash Report";
  DocumentSubType2["DAMAGES_QUESTIONNAIRE"] = "Damages Questionnaire";
  DocumentSubType2["DEATH_CERTIFICATE"] = `Death Certificate`;
  DocumentSubType2["DECLARATION"] = "Declaration";
  DocumentSubType2["DECLARATION_PAGE"] = "Declaration page";
  DocumentSubType2["DECLINATION_LETTER"] = `Declination Letter`;
  DocumentSubType2["DEED"] = "Deed";
  DocumentSubType2["DEFECT"] = "Defect";
  DocumentSubType2["DENIAL_LETTER"] = "Denial Letter";
  DocumentSubType2["DIVORCE_CERTIFICATE"] = `Divorce Certificate`;
  DocumentSubType2["DMA_OPIOID"] = `dma-opioid`;
  DocumentSubType2["DMA_OPIOID_TEXAS_AUTH"] = `dma-opioid-texas-auth`;
  DocumentSubType2["DOG"] = "Dog";
  DocumentSubType2["DOG_BITE"] = "Dog Bite";
  DocumentSubType2["DRIVER_S_LICENSE"] = `Driver's License`;
  DocumentSubType2["DRIVERS_LICENSE"] = `Drivers License`;
  DocumentSubType2["DURABLE_POWER_OF_ATTORNEY"] = "Durable Power of Attorney";
  DocumentSubType2["E_SIGNATURE"] = `eSignature`;
  DocumentSubType2["EXHIBIT"] = "Exhibit";
  DocumentSubType2["EXPOSURE_QUESTIONNAIRE"] = "Exposure Questionnaire";
  DocumentSubType2["EXTERNAL_INVOICE"] = `External Invoice`;
  DocumentSubType2["FAX"] = `fax`;
  DocumentSubType2["FIRE"] = "Fire";
  DocumentSubType2["FOIA"] = "FOIA";
  DocumentSubType2["FORENSIC_INTERVIEW"] = "Forensic Interview";
  DocumentSubType2["FSA_LOAN"] = "FSA Loan";
  DocumentSubType2["FTP"] = `ftp`;
  DocumentSubType2["FULL_EVALUATION_PACKET_PREP_FORM"] = `Full Evaluation Packet Prep Form`;
  DocumentSubType2["FULL_POLICY"] = "Full policy";
  DocumentSubType2["GUARDIANSHIP_DOCUMENT"] = `Guardianship Document`;
  DocumentSubType2["HANDBOOK_PROCEDURES"] = "Handbook/Procedures";
  DocumentSubType2["HEALTH_INSURANCE_CARD"] = `Health Insurance Card`;
  DocumentSubType2["HEALTH_INSURANCE_CORRESPONDENCE"] = "Health Insurance Correspondence";
  DocumentSubType2["HIPAA"] = "HIPAA";
  DocumentSubType2["HIPAA_WET"] = `HIPAA \u2013 Wet`;
  DocumentSubType2["HITECH_WET"] = `HITECH \u2013 Wet `;
  DocumentSubType2["HOMEOWNERS_ACKNOWLEDGEMENT_LETTER"] = "Homeowners Acknowledgement Letter";
  DocumentSubType2["HOMEOWNERS_CORRESPONDENCE"] = "Homeowners Correspondence";
  DocumentSubType2["HOMEOWNERS_DECLARATIONS_PAGE"] = "Homeowners Declarations Page";
  DocumentSubType2["HOMEOWNERS_DENIAL_LETTER"] = "Homeowners Denial Letter";
  DocumentSubType2["HOMEOWNERS_FULL_POLICY"] = "Homeowners Full Policy";
  DocumentSubType2["IME_NOTICE_LETTER"] = "IME Notice Letter";
  DocumentSubType2["INCIDENT_LOCATION"] = "Incident Location";
  DocumentSubType2["INJURIES"] = "Injuries";
  DocumentSubType2["INSURANCE_CORRESPONDENCE"] = `Insurance Correspondence`;
  DocumentSubType2["INSURANCE_EXPLANATION_OF_BENEFITS"] = `Insurance Explanation of Benefits`;
  DocumentSubType2["ITEMIZATION"] = "Itemization";
  DocumentSubType2["LAST_WILL_TESTAMENT"] = `Last Will & Testament`;
  DocumentSubType2["LAW_FIRM_AUTHORIZATION"] = `Law firm authorization`;
  DocumentSubType2["LAW_FIRM_LIEN"] = `Law Firm Lien`;
  DocumentSubType2["LEAD_CANCELATION"] = `Lead Cancelation`;
  DocumentSubType2["LEASE_AGREEMENT"] = "Lease Agreement";
  DocumentSubType2["LETTER_TO_CLIENT"] = `Letter to Client`;
  DocumentSubType2["LETTERS_OF_ADMINISTRATION"] = "Letters of Administration";
  DocumentSubType2["LETTERS_OF_APPOINTMENT"] = `Letters of Appointment`;
  DocumentSubType2["LETTERS_OF_TESTAMENTARY"] = `Letters of Testamentary`;
  DocumentSubType2["LIABILITY_QUESTIONNAIRE"] = "Liability Questionnaire";
  DocumentSubType2["LIEN_FILE"] = `Lien File`;
  DocumentSubType2["LIEN_HOLDER_FILE_MISC_INFO"] = "Lien holder file misc info";
  DocumentSubType2["LIFESTYLE"] = "Lifestyle";
  DocumentSubType2["MACP_CORRESPONDENCE"] = "MACP Correspondence";
  DocumentSubType2["MAINTENANCE_RECORDS"] = "Maintenance Records";
  DocumentSubType2["MARRIAGE_CERTIFICATE"] = `Marriage Certificate`;
  DocumentSubType2["MEDICAL"] = `Medical`;
  DocumentSubType2["MEDICARE_REPRESENTATION"] = "Medicare Representation";
  DocumentSubType2["MILITARY_ID"] = `Military ID`;
  DocumentSubType2["MISCELLANEOUS_REPAIR_COST"] = "Miscellaneous Repair Cost";
  DocumentSubType2["MOTION_TO_DISMISS_WITH_PREJUDICE"] = `Motion to Dismiss with Prejudice`;
  DocumentSubType2["MOTION_TO_DISMISS_WITHOUT_PREJUDICE"] = `Motion to Dismiss without Prejudice`;
  DocumentSubType2["NEXT_OF_KIN_AFFIDAVIT"] = "Next of Kin Affidavit";
  DocumentSubType2["NO_CONTACT_LETTER"] = "No Contact Letter";
  DocumentSubType2["NOTICE_LETTER"] = "Notice letter";
  DocumentSubType2["NOTICE_OF_COURT_APPEARANCE"] = `Notice of Court Appearance`;
  DocumentSubType2["OTHER"] = "Other";
  DocumentSubType2["OTHER_GOVERNMENT_ID"] = `Other Government ID`;
  DocumentSubType2["PAID_BY_CLAIMANT"] = "Paid by Claimant";
  DocumentSubType2["PAID_BY_TORTICITY"] = "Paid by Torticity";
  DocumentSubType2["PASSPORT"] = `Passport`;
  DocumentSubType2["PAYMENT_INSTRUCTIONS"] = `Payment Instructions`;
  DocumentSubType2["PERSONAL_PROPERTY"] = "Personal Property";
  DocumentSubType2["PIP_CORRESPONDENCE"] = "PIP Correspondence";
  DocumentSubType2["PIP_DECLARATIONS_PAGE"] = `PIP Declarations Page`;
  DocumentSubType2["PLAINTIFF_ASSESSMENT_QUESTIONNAIRE"] = "Plaintiff Assessment Questionnaire (PAQ)";
  DocumentSubType2["PLAINTIFF_FACT_SHEET"] = `Plaintiff Fact Sheet`;
  DocumentSubType2["PLAINTIFF_INFORMATION_SHEET"] = "Plaintiff Information Sheet";
  DocumentSubType2["PLAINTIFF_PROFILE_FORM"] = `Plaintiff Profile Form`;
  DocumentSubType2["PLAINTIFFS"] = "Plaintiffs";
  DocumentSubType2["POA_DOCUMENTATION_REQUIRED"] = "POA documentation required";
  DocumentSubType2["POLICE_REPORT"] = "Police Report";
  DocumentSubType2["POSTAL_MAIL"] = "Postal Mail";
  DocumentSubType2["POWER_OF_ATTORNEY_FINANCIAL"] = `Power of Attorney (Financial)`;
  DocumentSubType2["POWER_OF_ATTORNEY_HEALTHCARE"] = `Power of Attorney (Healthcare)`;
  DocumentSubType2["PROBATE_DOCUMENT"] = `Probate Document`;
  DocumentSubType2["PRODUCER_FARM_REPORT"] = "Producer Farm Report";
  DocumentSubType2["PROMISSORY_NOTE"] = "Promissory Note";
  DocumentSubType2["PROOF_OF_RESIDENCY"] = `Proof of residency`;
  DocumentSubType2["PROOF_OF_USE"] = `Proof of Use`;
  DocumentSubType2["PROPERTY_TAX_RECORDS"] = "Property Tax Records";
  DocumentSubType2["REAL_PROPERTY_EXTERIOR_OF_HOME_AFTER"] = "Real Property - Exterior of Home (After)";
  DocumentSubType2["REAL_PROPERTY_EXTERIOR_OF_HOME_BEFORE"] = "Real Property - Exterior of Home (Before)";
  DocumentSubType2["REAL_PROPERTY_INTERIOR_OF_HOME_AFTER"] = "Real Property - Interior of Home (After)";
  DocumentSubType2["REAL_PROPERTY_INTERIOR_OF_HOME_BEFORE"] = "Real Property - Interior of Home (Before)";
  DocumentSubType2["RECORDS"] = "Records";
  DocumentSubType2["REQUEST"] = "Request";
  DocumentSubType2["REPRESENTATIVE_DOCUMENT_NEEDED"] = "Representative document needed";
  DocumentSubType2["RESPONSE"] = "Response";
  DocumentSubType2["SERVICE_CONTRACT"] = "Service Contract";
  DocumentSubType2["SETTLED"] = `Settled`;
  DocumentSubType2["SETTLEMENT_RELEASE"] = "Settlement Release";
  DocumentSubType2["SF_180_FORM"] = `SF-180 Form`;
  DocumentSubType2["SFC_QUESTIONNAIRE"] = "SFC Questionnaire";
  DocumentSubType2["SHORT_CERTIFICATE"] = "Short Certificate";
  DocumentSubType2["SHORT_FORM_COMPLAINT"] = "Short Form Complaint";
  DocumentSubType2["SOCIAL_SECURITY_CARD"] = `Social Security Card`;
  DocumentSubType2["SUPPLEMENT"] = "Supplement";
  DocumentSubType2["TAX_ASSESSOR_SEARCH"] = "Tax Assessor Search";
  DocumentSubType2["TEN_DAY_OR_CLOSE_LETTER"] = "10 Day or close letter";
  DocumentSubType2["TO_BE_DELETED"] = `TO BE DELETED`;
  DocumentSubType2["TOG_PLAINTIFF_FACT_SHEET"] = "TOG Plaintiff Fact Sheet";
  DocumentSubType2["TOW_COMPANY_CORRESPONDENCE"] = "Tow Company Correspondence";
  DocumentSubType2["TURN_BACK_LETTER"] = "Turn back letter";
  DocumentSubType2["UM_UIM_ACKNOWLEDGEMENT_LETTER"] = "UM/UIM Acknowledgement Letter";
  DocumentSubType2["UM_UIM_CORRESPONDENCE"] = "UM/UIM Correspondence";
  DocumentSubType2["UM_UIM_DECLARATION_PAGE"] = "UM/UIM Declaration Page";
  DocumentSubType2["UM_UIM_DENIAL_LETTER"] = "UM/UIM Denial Letter";
  DocumentSubType2["UNINSURED_MOTORIST_UNDERINSURED_MOTORIST"] = "Uninsured Motorist/Underinsured Motorist";
  DocumentSubType2["UNKNOWN"] = "UNKNOWN";
  DocumentSubType2["VA_10_5345_HIPAA"] = `VA 10-5345 HIPAA`;
  DocumentSubType2["VA_WET_SIGNATURE"] = `VA wet signature`;
  DocumentSubType2["VERIFICATION"] = "Verification";
  DocumentSubType2["VEHICLE_REPAIR_COST"] = "Vehicle Repair Cost";
  DocumentSubType2["WAGE_LOSS_SERVICE_STATEMENT_DOCUMENTS"] = "Wage Loss Service Statement Documents";
  DocumentSubType2["WET_SIGNATURE"] = `wet signature`;
  DocumentSubType2["WET_SIGNATURE_REFORMATTED"] = `wet signature - reformatted`;
  DocumentSubType2["WORKERS_COMPENSATION_CORRESPONDENCE"] = "Workers Compensation Correspondence";
  return DocumentSubType2;
})(DocumentSubType || {});
var NotarizationType = /* @__PURE__ */ ((NotarizationType2) => {
  NotarizationType2["POU"] = "Proof of Use Affidavit";
  NotarizationType2["NOK"] = "Next of Kin Affidavit";
  NotarizationType2["POA"] = "Power of Attorney";
  return NotarizationType2;
})(NotarizationType || {});
var DocumentScreeningRejectionReason = /* @__PURE__ */ ((DocumentScreeningRejectionReason2) => {
  DocumentScreeningRejectionReason2["OTHER"] = "Other";
  DocumentScreeningRejectionReason2["POOR_IMAGE_QUALITY"] = "Poor Image Quality";
  DocumentScreeningRejectionReason2["WRONG_DOCUMENT"] = "Wrong Document";
  DocumentScreeningRejectionReason2["INCOMPLETE_SIGNATURE"] = "Incomplete signature";
  return DocumentScreeningRejectionReason2;
})(DocumentScreeningRejectionReason || {});
var DocumentSource = /* @__PURE__ */ ((DocumentSource2) => {
  DocumentSource2["BRIEF_LAW_FIRM_COMMUNICATIONS"] = "brief-law-firm-communications";
  DocumentSource2["CLAIMANT"] = "claimant";
  DocumentSource2["CLAIMANT_PORTAL"] = "claimant-portal";
  DocumentSource2["FACILITY"] = "facility";
  DocumentSource2["FAX"] = "fax";
  DocumentSource2["FTP"] = "ftp";
  DocumentSource2["LAW_FIRM"] = "law firm";
  DocumentSource2["SCANNER"] = "scanner";
  DocumentSource2["TEMPLATE"] = "template";
  DocumentSource2["TORTICITY"] = "torticity";
  DocumentSource2["ZIPLIENS"] = "zipliens";
  DocumentSource2["CONDUIT"] = "conduit";
  DocumentSource2["NRR"] = "nrr";
  return DocumentSource2;
})(DocumentSource || {});
var DocumentSendMethod = /* @__PURE__ */ ((DocumentSendMethod2) => {
  DocumentSendMethod2["EMAIL"] = "email";
  DocumentSendMethod2["FAX"] = "fax";
  DocumentSendMethod2["POSTAL"] = "postal";
  return DocumentSendMethod2;
})(DocumentSendMethod || {});
var DocumentSendStatus = /* @__PURE__ */ ((DocumentSendStatus2) => {
  DocumentSendStatus2["AWAITING_PRODUCTION"] = "awaiting production";
  DocumentSendStatus2["ERROR"] = "error";
  DocumentSendStatus2["FAILED"] = "failed";
  DocumentSendStatus2["IN_ERROR"] = "in error";
  DocumentSendStatus2["IN_CART"] = "in cart";
  DocumentSendStatus2["IN_PRODUCTION"] = "in production";
  DocumentSendStatus2["MAILED"] = "mailed";
  DocumentSendStatus2["ON_HOLD"] = "on hold";
  DocumentSendStatus2["ORDER_SUBMITTED"] = "order submitted";
  DocumentSendStatus2["PENDING"] = "pending";
  DocumentSendStatus2["SUCCESS"] = "success";
  return DocumentSendStatus2;
})(DocumentSendStatus || {});
var defaultAddress = {
  address1: "7700 Griffin Way",
  address2: "Ste B",
  city: "Willowbrook",
  state: "IL" /* IL */,
  zipCode: "60527-5688"
};
var defaultReturnTo = {
  name: "Torticity LLC",
  address: defaultAddress
};
var DocumentStatus = /* @__PURE__ */ ((DocumentStatus2) => {
  DocumentStatus2["DRAFT"] = "draft";
  DocumentStatus2["FINAL"] = "final";
  return DocumentStatus2;
})(DocumentStatus || {});

// src/ActionRequests/wildfire-documents.ts
var WILDFIRE_DOCUMENT_GROUP_CONFIGS = [
  {
    subType: "Wildfire Document Group Property Photos Exterior" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_EXTERIOR */,
    documentType: "Photos" /* PHOTOS */,
    documentSubType: "Real Property - Exterior of Home (After)" /* REAL_PROPERTY_EXTERIOR_OF_HOME_AFTER */
  },
  {
    subType: "Wildfire Document Group Property Photos Interior" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_INTERIOR */,
    documentType: "Photos" /* PHOTOS */,
    documentSubType: "Real Property - Interior of Home (After)" /* REAL_PROPERTY_INTERIOR_OF_HOME_AFTER */
  },
  {
    subType: "Wildfire Document Group Property Photos Structural" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_STRUCTURAL */,
    documentType: "Photos" /* PHOTOS */,
    documentSubType: "Real Property - Exterior of Home (After)" /* REAL_PROPERTY_EXTERIOR_OF_HOME_AFTER */
  },
  {
    subType: "Wildfire Document Group Property Photos Personal Belongings" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_PERSONAL_BELONGINGS */,
    documentType: "Photos" /* PHOTOS */,
    documentSubType: "Personal Property" /* PERSONAL_PROPERTY */
  },
  {
    subType: "Wildfire Document Group Property Photos Landscaping" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_LANDSCAPING */,
    documentType: "Landscaping" /* LANDSCAPING */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Property Photos Vehicles" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_VEHICLES */,
    documentType: "Photos" /* PHOTOS */,
    documentSubType: "Claimant's Vehicle" /* CLAIMANTS_VEHICLE */
  },
  {
    subType: "Wildfire Document Group Property Photos Before" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_BEFORE */,
    documentType: "Photos" /* PHOTOS */,
    documentSubType: "Real Property - Exterior of Home (Before)" /* REAL_PROPERTY_EXTERIOR_OF_HOME_BEFORE */
  },
  {
    subType: "Wildfire Document Group Insurance Policy" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_POLICY */,
    documentType: "Insurance" /* INSURANCE */,
    documentSubType: "Homeowners Full Policy" /* HOMEOWNERS_FULL_POLICY */
  },
  {
    subType: "Wildfire Document Group Insurance Claim Forms" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_CLAIM_FORMS */,
    documentType: "Insurance Claim File" /* INSURANCE_CLAIM_FILE */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Insurance Correspondence" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_CORRESPONDENCE */,
    documentType: "Insurance" /* INSURANCE */,
    documentSubType: "Homeowners Correspondence" /* HOMEOWNERS_CORRESPONDENCE */
  },
  {
    subType: "Wildfire Document Group Insurance Denial Letters" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_DENIAL_LETTERS */,
    documentType: "Insurance" /* INSURANCE */,
    documentSubType: "Homeowners Denial Letter" /* HOMEOWNERS_DENIAL_LETTER */
  },
  {
    subType: "Wildfire Document Group Insurance Settlement Offers" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_SETTLEMENT_OFFERS */,
    documentType: "Insurance" /* INSURANCE */,
    documentSubType: "Homeowners Correspondence" /* HOMEOWNERS_CORRESPONDENCE */
  },
  {
    subType: "Wildfire Document Group Receipts Temporary Housing" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_TEMPORARY_HOUSING */,
    documentType: "Alternative Living Expenses" /* ALTERNATIVE_LIVING_EXPENSES */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Receipts Food Meals" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_FOOD_MEALS */,
    documentType: "Alternative Living Expenses" /* ALTERNATIVE_LIVING_EXPENSES */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Receipts Clothing Personal" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_CLOTHING_PERSONAL */,
    documentType: "Alternative Living Expenses" /* ALTERNATIVE_LIVING_EXPENSES */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Receipts Medical" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_MEDICAL */,
    documentType: "Invoice" /* INVOICE */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Receipts Property Repairs" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_PROPERTY_REPAIRS */,
    documentType: "Other Repairs" /* OTHER_REPAIRS */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Receipts Cleanup Debris" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_CLEANUP_DEBRIS */,
    documentType: "Remediation/Debris Removal Expense" /* REMEDIATION_DEBRIS_REMOVAL_EXPENSE */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Medical Records Emergency" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_EMERGENCY */,
    documentType: "Medical Records" /* MEDICAL_RECORDS */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Medical Records Ongoing" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_ONGOING */,
    documentType: "Medical Records" /* MEDICAL_RECORDS */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Medical Records Mental Health" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_MENTAL_HEALTH */,
    documentType: "Medical Records" /* MEDICAL_RECORDS */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Medical Records Respiratory" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_RESPIRATORY */,
    documentType: "Medical Records" /* MEDICAL_RECORDS */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Medical Bills" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_BILLS */,
    documentType: "Invoice" /* INVOICE */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Proof Of Ownership Property" /* WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_PROPERTY */,
    documentType: "Proof of Ownership" /* PROOF_OF_OWNERSHIP */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Proof Of Ownership Belongings" /* WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_BELONGINGS */,
    documentType: "Proof of Ownership" /* PROOF_OF_OWNERSHIP */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Proof Of Ownership Vehicles" /* WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_VEHICLES */,
    documentType: "Proof of Ownership" /* PROOF_OF_OWNERSHIP */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Household Inventory" /* WILDFIRE_DOCUMENT_GROUP_HOUSEHOLD_INVENTORY */,
    documentType: "Household Inventory Form" /* HOUSEHOLD_INVENTORY_FORM */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Property Appraisal" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_APPRAISAL */,
    documentType: "Real Estate Appraisal" /* REAL_ESTATE_APPRAISAL */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Contractor Estimates" /* WILDFIRE_DOCUMENT_GROUP_CONTRACTOR_ESTIMATES */,
    documentType: "Rebuild Estimate" /* REBUILD_ESTIMATE */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Contractor Invoices" /* WILDFIRE_DOCUMENT_GROUP_CONTRACTOR_INVOICES */,
    documentType: "Invoice" /* INVOICE */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Drone Imaging" /* WILDFIRE_DOCUMENT_GROUP_DRONE_IMAGING */,
    documentType: "Drone Photo Data" /* DRONE_PHOTO_DATA */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Video Evidence" /* WILDFIRE_DOCUMENT_GROUP_VIDEO_EVIDENCE */,
    documentType: "Video" /* VIDEO */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Witness Statements" /* WILDFIRE_DOCUMENT_GROUP_WITNESS_STATEMENTS */,
    documentType: "Investigation" /* INVESTIGATION */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Evacuation Orders" /* WILDFIRE_DOCUMENT_GROUP_EVACUATION_ORDERS */,
    documentType: "Evacuation Notice" /* EVACUATION_NOTICE */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Fire Department Reports" /* WILDFIRE_DOCUMENT_GROUP_FIRE_DEPARTMENT_REPORTS */,
    documentType: "Incident Report" /* INCIDENT_REPORT */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Police Reports" /* WILDFIRE_DOCUMENT_GROUP_POLICE_REPORTS */,
    documentType: "Incident Report" /* INCIDENT_REPORT */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Government Communications" /* WILDFIRE_DOCUMENT_GROUP_GOVERNMENT_COMMUNICATIONS */,
    documentType: "Public Record Request" /* PUBLIC_RECORD_REQUEST */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Utility Reports" /* WILDFIRE_DOCUMENT_GROUP_UTILITY_REPORTS */,
    documentType: "Claimant Correspondence" /* CLAIMANT_CORRESPONDENCE */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Employment Lost Wages" /* WILDFIRE_DOCUMENT_GROUP_EMPLOYMENT_LOST_WAGES */,
    documentType: "Payroll Records" /* PAYROLL_RECORDS */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Business Lost Income" /* WILDFIRE_DOCUMENT_GROUP_BUSINESS_LOST_INCOME */,
    documentType: "Business Losses" /* BUSINESS_LOSSES */,
    documentSubType: void 0
  },
  {
    subType: "Wildfire Document Group Additional Documentation" /* WILDFIRE_DOCUMENT_GROUP_ADDITIONAL_DOCUMENTATION */,
    documentType: void 0,
    documentSubType: void 0
  }
];

// src/ActionRequests/index.ts
var ActionRequestType = /* @__PURE__ */ ((ActionRequestType2) => {
  ActionRequestType2["FILE_UPLOAD"] = "File upload";
  ActionRequestType2["CLAIMANT_INFORMATION"] = "Claimant information";
  ActionRequestType2["SIGNATURE_REQUEST"] = "Signature request";
  ActionRequestType2["SIGNATURE_RELEASE"] = "Signature release agreement";
  ActionRequestType2["APPOINTMENT"] = "Appointment";
  return ActionRequestType2;
})(ActionRequestType || {});
var ActionRequestSubType = /* @__PURE__ */ ((ActionRequestSubType2) => {
  ActionRequestSubType2["CUSTOM"] = "Custom";
  ActionRequestSubType2["INJURY_PHOTOS"] = "Injury Photos";
  ActionRequestSubType2["CRASH_PHOTOS"] = "Crash Photos";
  ActionRequestSubType2["LIFE_STYLE_PHOTOS"] = "Life Style Photos";
  ActionRequestSubType2["MEDICAL_INSURANCE_CARD"] = "Medical Insurance Card";
  ActionRequestSubType2["AUTO_INSURANCE_DECLARATION_PAGE"] = "Auto Insurance Declaration Page";
  ActionRequestSubType2["PHOTO_ID"] = "Photo ID";
  ActionRequestSubType2["DIRECT_DEPOSIT"] = "Direct Deposit";
  ActionRequestSubType2["MEDICAL_RECORDS"] = "Medical Records";
  ActionRequestSubType2["POLICE_REPORT"] = "Police Report";
  ActionRequestSubType2["CRASH_REPORT"] = "Crash Report";
  ActionRequestSubType2["MENTAL_HEALTH_RECORDS"] = "Mental Health Records";
  ActionRequestSubType2["MEDICAL_FORENSIC_EXAM_RECORDS"] = "Medical Forensic Exam Records";
  ActionRequestSubType2["OTHER_MEDICAL_RECORDS"] = "Other Medical Records";
  ActionRequestSubType2["WELCOME_CALL"] = "Welcome call";
  ActionRequestSubType2["CUSTOM_APPOINTMENT"] = "Custom appointment";
  ActionRequestSubType2["WILDFIRE_DOCUMENTS_UPLOAD"] = "Wildfire Documents Upload";
  ActionRequestSubType2["VEHICLE_DAMAGE_PHOTOS"] = "Vehicle Damage Photos";
  ActionRequestSubType2["CUSTOM_PERPETUAL"] = "Custom Perpetual";
  ActionRequestSubType2["WILDFIRE_DOCUMENTS_UPLOAD_GROUP"] = "Wildfire Documents Upload Group";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_EXTERIOR"] = "Wildfire Document Group Property Photos Exterior";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_INTERIOR"] = "Wildfire Document Group Property Photos Interior";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_STRUCTURAL"] = "Wildfire Document Group Property Photos Structural";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_PERSONAL_BELONGINGS"] = "Wildfire Document Group Property Photos Personal Belongings";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_LANDSCAPING"] = "Wildfire Document Group Property Photos Landscaping";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_VEHICLES"] = "Wildfire Document Group Property Photos Vehicles";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_BEFORE"] = "Wildfire Document Group Property Photos Before";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_INSURANCE_POLICY"] = "Wildfire Document Group Insurance Policy";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_INSURANCE_CLAIM_FORMS"] = "Wildfire Document Group Insurance Claim Forms";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_INSURANCE_CORRESPONDENCE"] = "Wildfire Document Group Insurance Correspondence";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_INSURANCE_DENIAL_LETTERS"] = "Wildfire Document Group Insurance Denial Letters";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_INSURANCE_SETTLEMENT_OFFERS"] = "Wildfire Document Group Insurance Settlement Offers";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_RECEIPTS_TEMPORARY_HOUSING"] = "Wildfire Document Group Receipts Temporary Housing";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_RECEIPTS_FOOD_MEALS"] = "Wildfire Document Group Receipts Food Meals";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_RECEIPTS_CLOTHING_PERSONAL"] = "Wildfire Document Group Receipts Clothing Personal";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_RECEIPTS_MEDICAL"] = "Wildfire Document Group Receipts Medical";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_RECEIPTS_PROPERTY_REPAIRS"] = "Wildfire Document Group Receipts Property Repairs";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_RECEIPTS_CLEANUP_DEBRIS"] = "Wildfire Document Group Receipts Cleanup Debris";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_EMERGENCY"] = "Wildfire Document Group Medical Records Emergency";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_ONGOING"] = "Wildfire Document Group Medical Records Ongoing";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_MENTAL_HEALTH"] = "Wildfire Document Group Medical Records Mental Health";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_RESPIRATORY"] = "Wildfire Document Group Medical Records Respiratory";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_MEDICAL_BILLS"] = "Wildfire Document Group Medical Bills";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_PROPERTY"] = "Wildfire Document Group Proof Of Ownership Property";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_BELONGINGS"] = "Wildfire Document Group Proof Of Ownership Belongings";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_VEHICLES"] = "Wildfire Document Group Proof Of Ownership Vehicles";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_HOUSEHOLD_INVENTORY"] = "Wildfire Document Group Household Inventory";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_PROPERTY_APPRAISAL"] = "Wildfire Document Group Property Appraisal";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_CONTRACTOR_ESTIMATES"] = "Wildfire Document Group Contractor Estimates";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_CONTRACTOR_INVOICES"] = "Wildfire Document Group Contractor Invoices";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_DRONE_IMAGING"] = "Wildfire Document Group Drone Imaging";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_VIDEO_EVIDENCE"] = "Wildfire Document Group Video Evidence";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_WITNESS_STATEMENTS"] = "Wildfire Document Group Witness Statements";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_EVACUATION_ORDERS"] = "Wildfire Document Group Evacuation Orders";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_FIRE_DEPARTMENT_REPORTS"] = "Wildfire Document Group Fire Department Reports";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_POLICE_REPORTS"] = "Wildfire Document Group Police Reports";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_GOVERNMENT_COMMUNICATIONS"] = "Wildfire Document Group Government Communications";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_UTILITY_REPORTS"] = "Wildfire Document Group Utility Reports";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_EMPLOYMENT_LOST_WAGES"] = "Wildfire Document Group Employment Lost Wages";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_BUSINESS_LOST_INCOME"] = "Wildfire Document Group Business Lost Income";
  ActionRequestSubType2["WILDFIRE_DOCUMENT_GROUP_ADDITIONAL_DOCUMENTATION"] = "Wildfire Document Group Additional Documentation";
  ActionRequestSubType2["UNCATEGORIZED_DOCUMENT"] = "Uncategorized Document";
  return ActionRequestSubType2;
})(ActionRequestSubType || {});
var ActionRequestStatus = /* @__PURE__ */ ((ActionRequestStatus2) => {
  ActionRequestStatus2["PENDING_USER_ACTION"] = "Pending user action";
  ActionRequestStatus2["NEEDS_SCREENING"] = "Needs screening";
  ActionRequestStatus2["SCREENED"] = "Screened";
  ActionRequestStatus2["SIGNATURE_DECLINED"] = "Signature declined";
  ActionRequestStatus2["PROCESSING"] = "Processing";
  ActionRequestStatus2["ERROR"] = "Error";
  ActionRequestStatus2["DISMISSED_BY_USER"] = "Dismissed by user";
  return ActionRequestStatus2;
})(ActionRequestStatus || {});
var SignatureReleaseActionRequestStatus = /* @__PURE__ */ ((SignatureReleaseActionRequestStatus2) => {
  SignatureReleaseActionRequestStatus2["CANCELED"] = "canceled";
  SignatureReleaseActionRequestStatus2["FAILED"] = "failed";
  SignatureReleaseActionRequestStatus2["SENT"] = "sent";
  SignatureReleaseActionRequestStatus2["RECEIVED"] = "received";
  return SignatureReleaseActionRequestStatus2;
})(SignatureReleaseActionRequestStatus || {});
var ActionRequestScreeningStatus = /* @__PURE__ */ ((ActionRequestScreeningStatus2) => {
  ActionRequestScreeningStatus2["APPROVED"] = "Approved";
  ActionRequestScreeningStatus2["REJECTED"] = "Rejected";
  return ActionRequestScreeningStatus2;
})(ActionRequestScreeningStatus || {});
var actionRequestMap = {
  ["Medical Insurance Card" /* MEDICAL_INSURANCE_CARD */]: {
    title: "Medical insurance card",
    description: "Please upload the front and back of your medical insurance card",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Medical Insurance Card" /* MEDICAL_INSURANCE_CARD */
  },
  ["Crash Photos" /* CRASH_PHOTOS */]: {
    title: "Crash photos",
    description: "Please provide images of any internal or external damage to the vehicles involved, including any damage to objects, buildings, signs, and skid marks on the pavement. This documentation can be in the form of photographs taken by yourself, traffic cameras, or pictures taken by a witnesses.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Crash Photos" /* CRASH_PHOTOS */
  },
  ["Injury Photos" /* INJURY_PHOTOS */]: {
    title: "Injury photos",
    description: "We understand that uploading case injury photos can be emotionally impactful. Your privacy is important to us, and we want to assure you that these photos will only be used to build your case. Take photos of your injuries as soon as you notice them, and be observant - some injuries take time to show up.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Injury Photos" /* INJURY_PHOTOS */
  },
  ["Life Style Photos" /* LIFE_STYLE_PHOTOS */]: {
    title: "Lifestyle photos",
    description: "When injuries significantly impact your quality of life, it is crucial to document the effects. Take photographs that clearly depict the limitations and challenges you face due to the injuries. This visual evidence will help in communicating the extent of the impact on your daily activities, mobility, and overall well-being.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Life Style Photos" /* LIFE_STYLE_PHOTOS */
  },
  ["Photo ID" /* PHOTO_ID */]: {
    title: "Photo ID",
    description: "Please upload the front and back of your Photo ID",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Photo ID" /* PHOTO_ID */
  },
  ["Medical Records" /* MEDICAL_RECORDS */]: {
    title: "Medical records",
    description: `Obtaining medical records is a critical step in helping prove your case. We will request records on your behalf but by providing your own records you can help expedite the process and strengthen your case. Please upload all records records related to your case. This could include hospital records, diagnostic reports, treatment records, or medical history records.`,
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Medical Records" /* MEDICAL_RECORDS */
  },
  ["Police Report" /* POLICE_REPORT */]: {
    title: "Police report",
    description: `Please upload any police reports you may have filed as related to your assault. We can request police reports on your behalf but by providing your own records you can help expedite the process and strengthen your case.`,
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Police Report" /* POLICE_REPORT */
  },
  ["Mental Health Records" /* MENTAL_HEALTH_RECORDS */]: {
    title: "Mental health records",
    description: `Please upload any mental health records you may have related to your assault. These could include records regarding depression, anxiety, PTSD, etc. We can request records on your behalf but by providing your own records you can help expedite the process and strengthen your case.`,
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Mental Health Records" /* MENTAL_HEALTH_RECORDS */
  },
  ["Crash Report" /* CRASH_REPORT */]: {
    title: "Crash report",
    description: `Please upload any crash reports you may have filed as related to your accident. We can request crash reports on your behalf but by providing your own records you can help expedite the process and strengthen your case.`,
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Crash Report" /* CRASH_REPORT */
  },
  ["Medical Forensic Exam Records" /* MEDICAL_FORENSIC_EXAM_RECORDS */]: {
    title: "MFE/SANE Exam Records",
    description: `These exams could also be called a SART, SANE, or a Rape Kit and are exams that occur within a week of the assault that can check for injuries and collect potential fluid from the offender for forensic evidence in a criminal case. We can request records on your behalf but by providing your own records you can help expedite the process and strengthen your case.`,
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Medical Forensic Exam Records" /* MEDICAL_FORENSIC_EXAM_RECORDS */
  },
  ["Other Medical Records" /* OTHER_MEDICAL_RECORDS */]: {
    title: "Other Medical Records",
    description: `Please upload any other medical records for injuries originating or exacerbated by your assault. The records could include STI testing, treatment for bruising, etc. We can request records on your behalf but by providing your own records you can help expedite the process and strengthen your case.`,
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Other Medical Records" /* OTHER_MEDICAL_RECORDS */
  },
  ["Auto Insurance Declaration Page" /* AUTO_INSURANCE_DECLARATION_PAGE */]: {
    title: "Auto insurance declaration page",
    description: "Search for the declaration pages specific to your auto insurance policy. These pages typically summarize the key information about your coverage, including your name, vehicle details, coverage limits, and deductible amounts.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Auto Insurance Declaration Page" /* AUTO_INSURANCE_DECLARATION_PAGE */
  },
  ["Wildfire Documents Upload" /* WILDFIRE_DOCUMENTS_UPLOAD */]: {
    title: "Wildfire documentation",
    description: "Please upload all documentation related to your wildfire case here in one step. This could include property damage photos, insurance documents, receipts, and any other relevant materials.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Documents Upload" /* WILDFIRE_DOCUMENTS_UPLOAD */
  },
  ["Wildfire Document Group Property Photos Exterior" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_EXTERIOR */]: {
    title: "Property Damage Photos - Exterior",
    description: "Please upload photos showing exterior damage to your property caused by the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Property Photos Exterior" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_EXTERIOR */
  },
  ["Wildfire Document Group Property Photos Interior" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_INTERIOR */]: {
    title: "Property Damage Photos - Interior",
    description: "Please upload photos showing interior damage to your property caused by the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Property Photos Interior" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_INTERIOR */
  },
  ["Wildfire Document Group Property Photos Structural" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_STRUCTURAL */]: {
    title: "Property Damage Photos - Structural",
    description: "Please upload photos showing structural damage to your property caused by the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Property Photos Structural" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_STRUCTURAL */
  },
  ["Wildfire Document Group Property Photos Personal Belongings" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_PERSONAL_BELONGINGS */]: {
    title: "Property Damage Photos - Personal Belongings",
    description: "Please upload photos of damaged personal belongings.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Property Photos Personal Belongings" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_PERSONAL_BELONGINGS */
  },
  ["Wildfire Document Group Property Photos Landscaping" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_LANDSCAPING */]: {
    title: "Property Damage Photos - Landscaping",
    description: "Please upload photos showing damage to landscaping, trees, and outdoor areas.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Property Photos Landscaping" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_LANDSCAPING */
  },
  ["Wildfire Document Group Property Photos Vehicles" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_VEHICLES */]: {
    title: "Property Damage Photos - Vehicles",
    description: "Please upload photos of any vehicle damage caused by the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Property Photos Vehicles" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_VEHICLES */
  },
  ["Wildfire Document Group Property Photos Before" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_BEFORE */]: {
    title: "Property Damage Photos - Before",
    description: "Please upload pictures of your property before damage was caused by the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Property Photos Before" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_PHOTOS_BEFORE */
  },
  ["Wildfire Document Group Insurance Policy" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_POLICY */]: {
    title: "Insurance Policy Documents",
    description: "Please upload copies of your insurance policy documents related to the wildfire claim.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Insurance Policy" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_POLICY */
  },
  ["Wildfire Document Group Insurance Claim Forms" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_CLAIM_FORMS */]: {
    title: "Insurance Claim Forms",
    description: "Please upload any insurance claim forms you have submitted or received.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Insurance Claim Forms" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_CLAIM_FORMS */
  },
  ["Wildfire Document Group Insurance Correspondence" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_CORRESPONDENCE */]: {
    title: "Insurance Correspondence",
    description: "Please upload any correspondence with your insurance company regarding the wildfire claim.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Insurance Correspondence" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_CORRESPONDENCE */
  },
  ["Wildfire Document Group Insurance Denial Letters" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_DENIAL_LETTERS */]: {
    title: "Insurance Denial Letters",
    description: "Please upload any denial letters or communications from your insurance company.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Insurance Denial Letters" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_DENIAL_LETTERS */
  },
  ["Wildfire Document Group Insurance Settlement Offers" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_SETTLEMENT_OFFERS */]: {
    title: "Insurance Settlement Offers",
    description: "Please upload any settlement offers or communications from your insurance company.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Insurance Settlement Offers" /* WILDFIRE_DOCUMENT_GROUP_INSURANCE_SETTLEMENT_OFFERS */
  },
  ["Wildfire Document Group Receipts Temporary Housing" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_TEMPORARY_HOUSING */]: {
    title: "Receipts - Temporary Housing",
    description: "Please upload receipts for temporary housing or alternative living expenses.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Receipts Temporary Housing" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_TEMPORARY_HOUSING */
  },
  ["Wildfire Document Group Receipts Food Meals" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_FOOD_MEALS */]: {
    title: "Receipts - Food and Meals",
    description: "Please upload receipts for food and meals during displacement.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Receipts Food Meals" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_FOOD_MEALS */
  },
  ["Wildfire Document Group Receipts Clothing Personal" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_CLOTHING_PERSONAL */]: {
    title: "Receipts - Clothing and Personal Items",
    description: "Please upload receipts for replacement clothing and personal items.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Receipts Clothing Personal" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_CLOTHING_PERSONAL */
  },
  ["Wildfire Document Group Receipts Medical" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_MEDICAL */]: {
    title: "Receipts - Medical Expenses",
    description: "Please upload receipts for any medical expenses related to the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Receipts Medical" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_MEDICAL */
  },
  ["Wildfire Document Group Receipts Property Repairs" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_PROPERTY_REPAIRS */]: {
    title: "Receipts - Property Repairs",
    description: "Please upload receipts for any property repairs or restoration work.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Receipts Property Repairs" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_PROPERTY_REPAIRS */
  },
  ["Wildfire Document Group Receipts Cleanup Debris" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_CLEANUP_DEBRIS */]: {
    title: "Receipts - Cleanup and Debris Removal",
    description: "Please upload receipts for cleanup services and debris removal.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Receipts Cleanup Debris" /* WILDFIRE_DOCUMENT_GROUP_RECEIPTS_CLEANUP_DEBRIS */
  },
  ["Wildfire Document Group Medical Records Emergency" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_EMERGENCY */]: {
    title: "Medical Records - Emergency Treatment",
    description: "Please upload medical records from emergency treatment related to the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Medical Records Emergency" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_EMERGENCY */
  },
  ["Wildfire Document Group Medical Records Ongoing" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_ONGOING */]: {
    title: "Medical Records - Ongoing Treatment",
    description: "Please upload medical records for ongoing treatment related to the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Medical Records Ongoing" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_ONGOING */
  },
  ["Wildfire Document Group Medical Records Mental Health" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_MENTAL_HEALTH */]: {
    title: "Medical Records - Mental Health",
    description: "Please upload mental health records related to emotional distress from the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Medical Records Mental Health" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_MENTAL_HEALTH */
  },
  ["Wildfire Document Group Medical Records Respiratory" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_RESPIRATORY */]: {
    title: "Medical Records - Respiratory Issues",
    description: "Please upload medical records for any respiratory issues caused by smoke inhalation.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Medical Records Respiratory" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_RECORDS_RESPIRATORY */
  },
  ["Wildfire Document Group Medical Bills" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_BILLS */]: {
    title: "Medical Bills",
    description: "Please upload medical bills related to treatment for wildfire-related injuries.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Medical Bills" /* WILDFIRE_DOCUMENT_GROUP_MEDICAL_BILLS */
  },
  ["Wildfire Document Group Proof Of Ownership Property" /* WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_PROPERTY */]: {
    title: "Proof of Ownership - Property",
    description: "Please upload documents proving ownership of the damaged property.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Proof Of Ownership Property" /* WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_PROPERTY */
  },
  ["Wildfire Document Group Proof Of Ownership Belongings" /* WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_BELONGINGS */]: {
    title: "Proof of Ownership - Personal Belongings",
    description: "Please upload documents, receipts, or photos proving ownership of damaged personal belongings.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Proof Of Ownership Belongings" /* WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_BELONGINGS */
  },
  ["Wildfire Document Group Proof Of Ownership Vehicles" /* WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_VEHICLES */]: {
    title: "Proof of Ownership - Vehicles",
    description: "Please upload vehicle registration and proof of ownership for damaged vehicles.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Proof Of Ownership Vehicles" /* WILDFIRE_DOCUMENT_GROUP_PROOF_OF_OWNERSHIP_VEHICLES */
  },
  ["Wildfire Document Group Household Inventory" /* WILDFIRE_DOCUMENT_GROUP_HOUSEHOLD_INVENTORY */]: {
    title: "Household Inventory List",
    description: "Please upload a detailed inventory list of items lost or damaged in the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Household Inventory" /* WILDFIRE_DOCUMENT_GROUP_HOUSEHOLD_INVENTORY */
  },
  ["Wildfire Document Group Property Appraisal" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_APPRAISAL */]: {
    title: "Property Appraisal Documents",
    description: "Please upload property appraisal documents showing the value before and after the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Property Appraisal" /* WILDFIRE_DOCUMENT_GROUP_PROPERTY_APPRAISAL */
  },
  ["Wildfire Document Group Contractor Estimates" /* WILDFIRE_DOCUMENT_GROUP_CONTRACTOR_ESTIMATES */]: {
    title: "Contractor Estimates",
    description: "Please upload estimates from contractors for repair and restoration work.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Contractor Estimates" /* WILDFIRE_DOCUMENT_GROUP_CONTRACTOR_ESTIMATES */
  },
  ["Wildfire Document Group Contractor Invoices" /* WILDFIRE_DOCUMENT_GROUP_CONTRACTOR_INVOICES */]: {
    title: "Contractor Invoices",
    description: "Please upload invoices from contractors for completed work.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Contractor Invoices" /* WILDFIRE_DOCUMENT_GROUP_CONTRACTOR_INVOICES */
  },
  ["Wildfire Document Group Drone Imaging" /* WILDFIRE_DOCUMENT_GROUP_DRONE_IMAGING */]: {
    title: "Drone Imaging",
    description: "Please upload any drone imaging or aerial photos of the property damage.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Drone Imaging" /* WILDFIRE_DOCUMENT_GROUP_DRONE_IMAGING */
  },
  ["Wildfire Document Group Video Evidence" /* WILDFIRE_DOCUMENT_GROUP_VIDEO_EVIDENCE */]: {
    title: "Video Evidence",
    description: "Please upload any video evidence showing the damage or the wildfire event.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Video Evidence" /* WILDFIRE_DOCUMENT_GROUP_VIDEO_EVIDENCE */
  },
  ["Wildfire Document Group Witness Statements" /* WILDFIRE_DOCUMENT_GROUP_WITNESS_STATEMENTS */]: {
    title: "Witness Statements",
    description: "Please upload any witness statements regarding the wildfire and its impact.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Witness Statements" /* WILDFIRE_DOCUMENT_GROUP_WITNESS_STATEMENTS */
  },
  ["Wildfire Document Group Evacuation Orders" /* WILDFIRE_DOCUMENT_GROUP_EVACUATION_ORDERS */]: {
    title: "Evacuation Orders",
    description: "Please upload any evacuation orders or official notices you received.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Evacuation Orders" /* WILDFIRE_DOCUMENT_GROUP_EVACUATION_ORDERS */
  },
  ["Wildfire Document Group Fire Department Reports" /* WILDFIRE_DOCUMENT_GROUP_FIRE_DEPARTMENT_REPORTS */]: {
    title: "Fire Department Reports",
    description: "Please upload any fire department reports related to the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Fire Department Reports" /* WILDFIRE_DOCUMENT_GROUP_FIRE_DEPARTMENT_REPORTS */
  },
  ["Wildfire Document Group Police Reports" /* WILDFIRE_DOCUMENT_GROUP_POLICE_REPORTS */]: {
    title: "Police Reports",
    description: "Please upload any police reports related to the wildfire incident.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Police Reports" /* WILDFIRE_DOCUMENT_GROUP_POLICE_REPORTS */
  },
  ["Wildfire Document Group Government Communications" /* WILDFIRE_DOCUMENT_GROUP_GOVERNMENT_COMMUNICATIONS */]: {
    title: "Government Agency Communications",
    description: "Please upload any communications from government agencies regarding the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Government Communications" /* WILDFIRE_DOCUMENT_GROUP_GOVERNMENT_COMMUNICATIONS */
  },
  ["Wildfire Document Group Utility Reports" /* WILDFIRE_DOCUMENT_GROUP_UTILITY_REPORTS */]: {
    title: "Utility Company Reports",
    description: "Please upload any reports or communications from utility companies.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Utility Reports" /* WILDFIRE_DOCUMENT_GROUP_UTILITY_REPORTS */
  },
  ["Wildfire Document Group Employment Lost Wages" /* WILDFIRE_DOCUMENT_GROUP_EMPLOYMENT_LOST_WAGES */]: {
    title: "Employment Records - Lost Wages",
    description: "Please upload employment records showing lost wages due to the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Employment Lost Wages" /* WILDFIRE_DOCUMENT_GROUP_EMPLOYMENT_LOST_WAGES */
  },
  ["Wildfire Document Group Business Lost Income" /* WILDFIRE_DOCUMENT_GROUP_BUSINESS_LOST_INCOME */]: {
    title: "Business Records - Lost Income",
    description: "Please upload business records showing lost income due to the wildfire.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Business Lost Income" /* WILDFIRE_DOCUMENT_GROUP_BUSINESS_LOST_INCOME */
  },
  ["Wildfire Document Group Additional Documentation" /* WILDFIRE_DOCUMENT_GROUP_ADDITIONAL_DOCUMENTATION */]: {
    title: "Additional Documentation",
    description: "Please upload any additional documentation related to your wildfire claim that has not been covered above.",
    type: "File upload" /* FILE_UPLOAD */,
    subType: "Wildfire Document Group Additional Documentation" /* WILDFIRE_DOCUMENT_GROUP_ADDITIONAL_DOCUMENTATION */
  },
  ["Direct Deposit" /* DIRECT_DEPOSIT */]: {
    title: "Secure direct deposit",
    description: `We'll safely send your payment to your bank account. Please enter the account holder information. Ensure the name matches your bank account to avoid payment rejection.`,
    type: "Claimant information" /* CLAIMANT_INFORMATION */,
    subType: "Direct Deposit" /* DIRECT_DEPOSIT */
  },
  ["Welcome call" /* WELCOME_CALL */]: {
    title: "Scheduled call",
    description: "Book a case call using our secure scheduler.",
    type: "Appointment" /* APPOINTMENT */,
    subType: "Welcome call" /* WELCOME_CALL */
  },
  ["Custom appointment" /* CUSTOM_APPOINTMENT */]: {
    title: "Scheduled call",
    description: "Book a case call using our secure scheduler.",
    type: "Appointment" /* APPOINTMENT */,
    subType: "Custom appointment" /* CUSTOM_APPOINTMENT */
  }
};
var SIGNATURE_RESEND_FEATURE_RELEASE_DATE = "2025-04-01";

// src/Activity/index.ts
var ActivityType = /* @__PURE__ */ ((ActivityType2) => {
  ActivityType2["ATTORNEY_CHANGE"] = "attorneyChange";
  ActivityType2["BLOCKER_CREATED"] = "blockerCreated";
  ActivityType2["BLOCKER_RESOLVED"] = "blockerResolved";
  ActivityType2["BRIEF_COMMS_SUMMARY_DOWNLOAD"] = "brief-comms-summary-download";
  ActivityType2["CALL"] = "call";
  ActivityType2["CANCELED_LEAD"] = "canceled-lead";
  ActivityType2["CLAIMANT_ADDRESS_UPDATE"] = "claimant-address-update";
  ActivityType2["CLAIM_STATUS_CHANGED"] = "claimStatusChanged";
  ActivityType2["CLAIMANT_DEMOGRAPHIC_UPDATE"] = "claimant-demographic-update";
  ActivityType2["CLAIMANT_EMAIL_ADDRESS_UPDATE"] = "claimant-email-address-update";
  ActivityType2["CLAIMANT_OUTREACH"] = "claimantOutreach";
  ActivityType2["CLAIMANT_PHONE_NUMBER_UPDATED"] = "claimant-phone-number-update";
  ActivityType2["CLAIMANT_PORTAL_INVITE_CANCELED"] = "claimant portal invite canceled";
  ActivityType2["CLAIMANT_PORTAL_INVITE_RESENT"] = "claimant portal invite resent";
  ActivityType2["CLAIMANT_PORTAL_INVITE_SENT"] = "claimant portal invite sent";
  ActivityType2["CLAIMANT_REPRESENTATIVE_UPDATE"] = "claimant-representative-update";
  ActivityType2["CLOSED_REASON"] = "closedReason";
  ActivityType2["COMMENT"] = "comment";
  ActivityType2["CREATED"] = "created";
  ActivityType2["DISCOVERY_DOCUMENT_DETAIL_STATUS_CHANGE"] = "discovery-document-detail-status-change";
  ActivityType2["DOCUMENT"] = "document";
  ActivityType2["DOCUMENT_DELETED"] = "documentDeleted";
  ActivityType2["DOCUMENT_REQUEST_CREATED"] = "documentRequestCreated";
  ActivityType2["DOCUMENT_REQUEST_RESENT"] = "documentRequestResent";
  ActivityType2["DOCUMENT_TYPE_CHANGE"] = "documentTypeChange";
  ActivityType2["FOLLOW_UP_DATE"] = "followUpDate";
  ActivityType2["LAW_FIRM_COMMUNICATION"] = "law-firm-communication";
  ActivityType2["LAW_FIRM_REVIEW_STATUS_CHANGE"] = "lawFirmReviewStatusChange";
  ActivityType2["LEGAL_PREPARATION_OWNER_CHANGE"] = "legalPreparationOwnerChange";
  ActivityType2["LEGAL_QC_OWNER_CHANGE"] = "legalQCOwnerChange";
  ActivityType2["MEDICAL_EVENT_READINESS_CHANGE"] = "medicalEventReadinessChange";
  ActivityType2["MILESTONE_COMPLETED"] = "milestone-completed";
  ActivityType2["NEXT_ACTION_CHANGE"] = "nextActionChange";
  ActivityType2["NOTE"] = "note";
  ActivityType2["OBJECTIVE_STATUS"] = "objective-status";
  ActivityType2["ONDER_CPAP_NOTE"] = "onderCpapNote";
  ActivityType2["OUTREACH_REQUEST"] = "outreach_request";
  ActivityType2["OUTREACH_REQUEST_APPROVED"] = "outreach_request_approved";
  ActivityType2["OUTREACH_REQUEST_COMPLETED"] = "outreach_request_completed";
  ActivityType2["OUTREACH_REQUEST_CREATED"] = "outreach_request_created";
  ActivityType2["OUTREACH_REQUEST_REJECTED"] = "outreach_request_rejected";
  ActivityType2["OWNER_CHANGE"] = "ownerChange";
  ActivityType2["PARTNER_LEAD_CREATED"] = "partnerLeadCreated";
  ActivityType2["PRE_RETRIEVAL"] = "pre-retrieval";
  ActivityType2["QUALIFIED_UPDATE"] = "qualified-update";
  ActivityType2["REJECTED_REASON"] = "rejectedReason";
  ActivityType2["RETRIEVAL"] = "retrieval";
  ActivityType2["RETRIEVAL_TASK_REQUEST_DISPOSITIONED"] = "retrievalTaskRequestDispositioned";
  ActivityType2["STATUS"] = "status";
  ActivityType2["STATUS_REASON_CHANGE"] = "statusReasonChange";
  ActivityType2["SUB_OWNER_CHANGE"] = "subOwnerChange";
  ActivityType2["TASK_COPIED"] = "task-copied";
  ActivityType2["TASK_CREATED"] = "task-created";
  ActivityType2["TASK_NOTE"] = "task-note";
  ActivityType2["TASK_OWNER_CHANGE"] = "task-owner-change";
  ActivityType2["TASK_STATUS"] = "task-status";
  ActivityType2["TASK_TEAM_CHANGE"] = "task-team-change";
  ActivityType2["TOUCH"] = "touch";
  ActivityType2["UNVIEWABLE"] = "unviewable";
  ActivityType2["USER"] = "user";
  ActivityType2["VERIFICATION_STATUS_CHANGES"] = "verificationstatuschanges";
  ActivityType2["VIEWABLE"] = "viewable";
  return ActivityType2;
})(ActivityType || {});
var SecondaryRelationshipType = /* @__PURE__ */ ((SecondaryRelationshipType2) => {
  SecondaryRelationshipType2["AUTOMATIC_STATUTE_OF_LIMITATION"] = "automatic_statute_of_limitation";
  SecondaryRelationshipType2["BLOCKER"] = "task_blocker";
  SecondaryRelationshipType2["CLAIMANT"] = "claimant";
  SecondaryRelationshipType2["CLAIMANT_ADDRESS"] = "claimant_address";
  SecondaryRelationshipType2["CLAIMANT_EMAIL_ADDRESS"] = "claimant_email_address";
  SecondaryRelationshipType2["CLAIMANT_PHONE_NUMBER"] = "claimant_phone_number";
  SecondaryRelationshipType2["CLAIMANT_PORTAL_INVITE"] = "claimant_portal_invite";
  SecondaryRelationshipType2["CLAIMANT_REPRESENTATIVE"] = "claimant_representative";
  SecondaryRelationshipType2["DISCOVERY_DOCUMENT_DETAIL"] = "discovery_document_detail";
  SecondaryRelationshipType2["DOCUMENT"] = "document";
  SecondaryRelationshipType2["DOCUMENT_REQUEST"] = "document_request";
  SecondaryRelationshipType2["FINDING"] = "finding";
  SecondaryRelationshipType2["FIVE9_CALL"] = "five9_call";
  SecondaryRelationshipType2["LAW_FIRM_COMMUNICATION"] = "law_firm_communication";
  SecondaryRelationshipType2["LEAD_MILESTONE"] = "lead_milestone";
  SecondaryRelationshipType2["LEAD_MILESTONE_OBJECTIVE"] = "lead_milestone_objective";
  SecondaryRelationshipType2["MEDICAL_EVENT"] = "medical_event";
  SecondaryRelationshipType2["OUTREACH_REQUEST"] = "outreach_request";
  SecondaryRelationshipType2["SIGNATURE_REQUEST"] = "signature_request";
  SecondaryRelationshipType2["SMART_CASE_TOUCH"] = "smart_case_touch";
  SecondaryRelationshipType2["TASK"] = "task";
  return SecondaryRelationshipType2;
})(SecondaryRelationshipType || {});
var ActivityNoteDetailType = /* @__PURE__ */ ((ActivityNoteDetailType2) => {
  ActivityNoteDetailType2["CLAIMANT_INBOUND"] = "Claimant inbound note";
  ActivityNoteDetailType2["CLAIMANT_OUTREACH"] = "Claimant outreach";
  ActivityNoteDetailType2["DIGITAL_CLAIMANT_ENGAGEMENT"] = "Digital claimant engagement";
  ActivityNoteDetailType2["DISCOVERY_DOCUMENT"] = "Discovery Document";
  ActivityNoteDetailType2["DISCOVERY_DOCUMENT_QC"] = "Discovery Document QC";
  ActivityNoteDetailType2["DOCUMENTS"] = "Documents";
  ActivityNoteDetailType2["EXTERNAL_LAW_FIRM_NOTE"] = "Law Firm Review Note";
  ActivityNoteDetailType2["INTAKE_VERIFICATION_ATTEMPT"] = "Intake verification attempt";
  ActivityNoteDetailType2["INTAKE_VERIFICATION_COMPLETE"] = "Intake verification complete";
  ActivityNoteDetailType2["LAW_FIRM_FEEDBACK"] = "Law firm feedback";
  ActivityNoteDetailType2["MEDICAL_EVENT_CREATED_NOT_SENT"] = "Medical event created - not sent";
  ActivityNoteDetailType2["OTHER"] = "Other";
  ActivityNoteDetailType2["QC"] = "QC";
  ActivityNoteDetailType2["REVIEW"] = "Review";
  ActivityNoteDetailType2["REWORKED_MILESTONE"] = "Reworked Milestone";
  ActivityNoteDetailType2["STATUS_CHANGE"] = "Status change";
  return ActivityNoteDetailType2;
})(ActivityNoteDetailType || {});
var ActivityNoteDetailTypePI = /* @__PURE__ */ ((ActivityNoteDetailTypePI2) => {
  ActivityNoteDetailTypePI2["CLAIMANT_INBOUND"] = "Claimant inbound note";
  ActivityNoteDetailTypePI2["CLAIMANT_OUTREACH"] = "Claimant outreach";
  ActivityNoteDetailTypePI2["EXTERNAL_LAW_FIRM_NOTE"] = "Law Firm Review Note";
  ActivityNoteDetailTypePI2["INTAKE_VERIFICATION_ATTEMPT"] = "Intake verification attempt";
  ActivityNoteDetailTypePI2["INTAKE_VERIFICATION_COMPLETE"] = "Intake verification complete";
  ActivityNoteDetailTypePI2["MANAGER_REVIEW"] = "Manager review";
  ActivityNoteDetailTypePI2["MEDICAL_EVENT_CREATED_NOT_SENT"] = "Medical event created - not sent";
  ActivityNoteDetailTypePI2["MONTHLY_CASE_REVIEW"] = "Monthly case review";
  ActivityNoteDetailTypePI2["INSURANCE_COMMUNICATION"] = "Insurance communication";
  ActivityNoteDetailTypePI2["LAW_FIRM_COMMUNICATION"] = "Law firm communication";
  ActivityNoteDetailTypePI2["ZIPLIENS"] = "Zipliens";
  ActivityNoteDetailTypePI2["POLICE_DEPARTMENT_OUTREACH"] = "Police department Outreach";
  ActivityNoteDetailTypePI2["TREATMENT_UPDATE_COMMUNICATION"] = "Treatment update communication";
  ActivityNoteDetailTypePI2["TURNOVER_LETTER"] = "Turnover Letter";
  ActivityNoteDetailTypePI2["OTHER"] = "Other";
  return ActivityNoteDetailTypePI2;
})(ActivityNoteDetailTypePI || {});

// src/Appointments/index.ts
var AppointmentStatus = /* @__PURE__ */ ((AppointmentStatus2) => {
  AppointmentStatus2["PENDING"] = "pending";
  AppointmentStatus2["SCHEDULED"] = "scheduled";
  AppointmentStatus2["CANCELED"] = "canceled";
  AppointmentStatus2["RESCHEDULED"] = "rescheduled";
  AppointmentStatus2["NO_SHOW"] = "no_show";
  return AppointmentStatus2;
})(AppointmentStatus || {});
var AppointmentType = /* @__PURE__ */ ((AppointmentType2) => {
  AppointmentType2["WELCOME_CALL"] = "welcome_call";
  AppointmentType2["CUSTOM"] = "custom";
  return AppointmentType2;
})(AppointmentType || {});

// src/AuditTrail/index.ts
var AuditTrailType = /* @__PURE__ */ ((AuditTrailType2) => {
  AuditTrailType2["Created"] = "created";
  AuditTrailType2["Updated"] = "updated";
  AuditTrailType2["Removed"] = "removed";
  return AuditTrailType2;
})(AuditTrailType || {});

// src/AutomatedAging/index.ts
var IneligibleReason = /* @__PURE__ */ ((IneligibleReason2) => {
  IneligibleReason2["FACILITY_MISSING_PREFERRED_METHOD"] = "Facility is missing a preferred method";
  IneligibleReason2["FACILITY_MISSING_CONTACT_INFO"] = "Facility does have a preferred method but is missing contact info";
  IneligibleReason2["FACILITY_NOT_VERIFIED"] = "Facility is not verified";
  IneligibleReason2["FACILITY_CLOSED"] = "Facility is closed";
  IneligibleReason2["FACILITY_ARCHIVED"] = "Facility is archived";
  IneligibleReason2["FACILITY_PREFERRED_METHOD_MAIL"] = "Facility's preferred method cannot be mail";
  IneligibleReason2["FACILITY_HAS_COPY_SERVICE"] = "Facility has copy service";
  return IneligibleReason2;
})(IneligibleReason || {});

// src/Branding/index.ts
var BrandingExperience = /* @__PURE__ */ ((BrandingExperience2) => {
  BrandingExperience2["COBRAND"] = "cobrand";
  BrandingExperience2["WHITE_LABEL"] = "white_label";
  return BrandingExperience2;
})(BrandingExperience || {});
var BrandingTheme = /* @__PURE__ */ ((BrandingTheme2) => {
  BrandingTheme2["VIOLET"] = "violet";
  BrandingTheme2["ROSE"] = "rose";
  BrandingTheme2["EMERALD"] = "emerald";
  BrandingTheme2["SLATE"] = "slate";
  BrandingTheme2["BLUE"] = "blue";
  BrandingTheme2["AMBER"] = "amber";
  BrandingTheme2["TEAL"] = "teal";
  return BrandingTheme2;
})(BrandingTheme || {});
var TORTICITY_BRANDING_ID = "1";

// src/BriefNotification/index.ts
var NotificationFrequency = /* @__PURE__ */ ((NotificationFrequency2) => {
  NotificationFrequency2["Instantaneous"] = "Instantaneous";
  NotificationFrequency2["Daily"] = "Daily";
  NotificationFrequency2["Weekly"] = "Weekly";
  NotificationFrequency2["Never"] = "Never";
  return NotificationFrequency2;
})(NotificationFrequency || {});

// src/BriefUserPermissions/index.ts
var BriefUserPermission = /* @__PURE__ */ ((BriefUserPermission2) => {
  BriefUserPermission2["SENSITIVE_DOCUMENT"] = "sensitive_document";
  BriefUserPermission2["DIRECT_DEPOSIT"] = "direct_deposit";
  return BriefUserPermission2;
})(BriefUserPermission || {});

// src/Calls/index.ts
var CallService = /* @__PURE__ */ ((CallService2) => {
  CallService2["FIVE_9"] = "five_9";
  return CallService2;
})(CallService || {});
var CASE_COORDINATOR_CAMPAIGN_PREFIXES = ["CO_", "PI_", "SA_"];
var LEGAL_SPECIALIST_CAMPAIGN_PREFIXES = ["DD_"];
var CLIENT_SPECIALIST_CAMPAIGN_PREFIXES = ["Intake_"];
var ALLOWED_FIVE9_CAMPAIGN_PREFIXES = [
  ...CASE_COORDINATOR_CAMPAIGN_PREFIXES,
  ...LEGAL_SPECIALIST_CAMPAIGN_PREFIXES,
  ...CLIENT_SPECIALIST_CAMPAIGN_PREFIXES
];
var FIVE9_TEAM_NAME_MAPPING = {
  ...Object.fromEntries(CASE_COORDINATOR_CAMPAIGN_PREFIXES.map((p) => [p, "Case coordinators"])),
  ...Object.fromEntries(LEGAL_SPECIALIST_CAMPAIGN_PREFIXES.map((p) => [p, "Legal specialists"])),
  ...Object.fromEntries(CLIENT_SPECIALIST_CAMPAIGN_PREFIXES.map((p) => [p, "Client specialists"]))
};

// src/Claimant/index.ts
var MilitaryStatus = /* @__PURE__ */ ((MilitaryStatus2) => {
  MilitaryStatus2["CIVILIAN"] = "Civilian";
  MilitaryStatus2["CIVIL_SERVICE_EMPLOYEE"] = "Civil service employee";
  MilitaryStatus2["MEMBER_OF_ARMED_FORCES"] = "Member of the armed forces";
  MilitaryStatus2["CIVILIAN_MILITARY_DEPENDENT"] = "Civilian military dependent";
  MilitaryStatus2["CIVILIAN_EMPLOYEE_WORKING_FOR_PRIVATE_COMPANY"] = "Civilian employee working for private company on base";
  return MilitaryStatus2;
})(MilitaryStatus || {});

// src/ClaimantRepresentative/index.ts
var ClaimantRepresentativeType = /* @__PURE__ */ ((ClaimantRepresentativeType2) => {
  ClaimantRepresentativeType2["GUARDIAN"] = "guardian";
  ClaimantRepresentativeType2["EXECUTOROFESTATE"] = "executor of estate";
  ClaimantRepresentativeType2["POWEROFATTORNEY"] = "power of attorney";
  ClaimantRepresentativeType2["NEXTOFKIN"] = "next of kin";
  ClaimantRepresentativeType2["UNKNOWN"] = "unknown";
  return ClaimantRepresentativeType2;
})(ClaimantRepresentativeType || {});
var ClaimantRepresentativeRelationshipType = /* @__PURE__ */ ((ClaimantRepresentativeRelationshipType2) => {
  ClaimantRepresentativeRelationshipType2["SPOUSE"] = "spouse";
  ClaimantRepresentativeRelationshipType2["PARENT"] = "parent";
  ClaimantRepresentativeRelationshipType2["SIBLING"] = "sibling";
  ClaimantRepresentativeRelationshipType2["CHILD"] = "child";
  ClaimantRepresentativeRelationshipType2["OTHER"] = "other";
  ClaimantRepresentativeRelationshipType2["UNKNOWN"] = "unknown";
  return ClaimantRepresentativeRelationshipType2;
})(ClaimantRepresentativeRelationshipType || {});

// src/Communication/index.ts
var ActivityNoteChannels = /* @__PURE__ */ ((ActivityNoteChannels2) => {
  ActivityNoteChannels2["CLAIMANT_OUTREACH"] = "claimant-outreach";
  ActivityNoteChannels2["CLAIMANT_INBOUND_NOTE"] = "claimant-inbound-note";
  ActivityNoteChannels2["INTAKE_VERIFICATION_ATTEMPT"] = "intake-verification-attempt";
  ActivityNoteChannels2["INTAKE_VERIFICATION_COMPLETE"] = "intake-verification-complete";
  ActivityNoteChannels2["DIGITAL_CLAIMANT_ENGAGEMENT"] = "digital-claimant-engagement";
  return ActivityNoteChannels2;
})(ActivityNoteChannels || {});
var ActivityNoteChannelsPI = /* @__PURE__ */ ((ActivityNoteChannelsPI2) => {
  ActivityNoteChannelsPI2["INSURANCE_COMMUNICATION"] = "insurance-communication";
  ActivityNoteChannelsPI2["ZIPLIENS"] = "zipliens";
  ActivityNoteChannelsPI2["POLICE_DEPARTMENT_OUTREACH"] = "police-department-outreach";
  ActivityNoteChannelsPI2["TREATMENT_UPDATE_COMMUNICATION"] = "treatment-update-communication";
  return ActivityNoteChannelsPI2;
})(ActivityNoteChannelsPI || {});
var CommunicationDirection = /* @__PURE__ */ ((CommunicationDirection2) => {
  CommunicationDirection2["INBOUND"] = "inbound";
  CommunicationDirection2["OUTBOUND"] = "outbound";
  return CommunicationDirection2;
})(CommunicationDirection || {});
var activityNoteDetailPITypeMap = {
  ["Insurance communication" /* INSURANCE_COMMUNICATION */]: {
    channel: "insurance-communication" /* INSURANCE_COMMUNICATION */
  },
  ["Zipliens" /* ZIPLIENS */]: {
    channel: "zipliens" /* ZIPLIENS */
  },
  ["Police department Outreach" /* POLICE_DEPARTMENT_OUTREACH */]: {
    channel: "police-department-outreach" /* POLICE_DEPARTMENT_OUTREACH */
  },
  ["Treatment update communication" /* TREATMENT_UPDATE_COMMUNICATION */]: {
    channel: "treatment-update-communication" /* TREATMENT_UPDATE_COMMUNICATION */
  }
};
var activityNoteDetailTypeMap = {
  ["Claimant outreach" /* CLAIMANT_OUTREACH */]: {
    channel: "claimant-outreach" /* CLAIMANT_OUTREACH */,
    direction: "outbound" /* OUTBOUND */
  },
  ["Claimant inbound note" /* CLAIMANT_INBOUND */]: {
    channel: "claimant-inbound-note" /* CLAIMANT_INBOUND_NOTE */,
    direction: "inbound" /* INBOUND */
  },
  ["Intake verification attempt" /* INTAKE_VERIFICATION_ATTEMPT */]: {
    channel: "intake-verification-attempt" /* INTAKE_VERIFICATION_ATTEMPT */,
    direction: "outbound" /* OUTBOUND */
  },
  ["Intake verification complete" /* INTAKE_VERIFICATION_COMPLETE */]: {
    channel: "intake-verification-complete" /* INTAKE_VERIFICATION_COMPLETE */,
    direction: "outbound" /* OUTBOUND */
  },
  ["Digital claimant engagement" /* DIGITAL_CLAIMANT_ENGAGEMENT */]: {
    channel: "digital-claimant-engagement" /* DIGITAL_CLAIMANT_ENGAGEMENT */,
    direction: "outbound" /* OUTBOUND */
  }
};

// src/Lead/lead-status.ts
var LeadStatus = /* @__PURE__ */ ((LeadStatus2) => {
  LeadStatus2["ON_HOLD"] = "on hold";
  LeadStatus2["RETURNED_TO_LAW_FIRM"] = "returned to law firm";
  LeadStatus2["CANCELED"] = "canceled";
  LeadStatus2["COMPLETE"] = "complete";
  LeadStatus2["DISPROVEN"] = "disproven";
  LeadStatus2["DISQUALIFIED"] = "disqualified";
  LeadStatus2["INTAKE"] = "intake";
  LeadStatus2["INTERNAL_REVIEW"] = "internal review";
  LeadStatus2["LAW_FIRM_REVIEW"] = "law firm review";
  LeadStatus2["MEDICAL_MONITORING"] = "medical monitoring";
  LeadStatus2["PRE_RETRIEVAL"] = "pre-retrieval";
  LeadStatus2["PROVEN"] = "proven";
  LeadStatus2["PROVEN_PHASE_1"] = "proven phase 1";
  LeadStatus2["RETRIEVAL"] = "retrieval";
  LeadStatus2["REVIEW"] = "review";
  LeadStatus2["REVIEW_COMPLETE"] = "review complete";
  LeadStatus2["REVIEW_ERRORS_FIXED"] = "review qc errors fixed";
  LeadStatus2["REVIEW_ERRORS_FOUND"] = "review qc errors found";
  LeadStatus2["REVIEW_KICKBACK"] = "review kickback";
  LeadStatus2["INGESTION_REVIEW"] = "ingestion review";
  LeadStatus2["DEMANDS"] = "demands";
  LeadStatus2["SETTLEMENT"] = "settlement";
  LeadStatus2["ESCALATED_TO_FIRM"] = "escalated to firm";
  LeadStatus2["CASE_SETTLED"] = "case settled";
  LeadStatus2["DEMAND_PREPARATION"] = "demand preparation";
  LeadStatus2["NEGOTIATION"] = "negotiation";
  LeadStatus2["INSURANCE_ANALYSIS"] = "insurance analysis";
  return LeadStatus2;
})(LeadStatus || {});

// src/Lead/lead-status-configuration.ts
var LeadStatusConfiguration = /* @__PURE__ */ ((LeadStatusConfiguration2) => {
  LeadStatusConfiguration2["CASEWISE_CANCELED_CLAIM_STATUS"] = "casewiseCanceledClaimStatus";
  LeadStatusConfiguration2["DOCUMENT_REQUEST_STATUS_EXCLUSION"] = "documentRequestStatusExclusion";
  LeadStatusConfiguration2["DOCUMENT_REQUEST_TRANSFER_EXCLUSION"] = "documentRequestTransferExclusion";
  LeadStatusConfiguration2["EXCLUDED_FROM_FACILITY_AUTOMATED_AGING"] = "excludedFromFacilityAutomatedAging";
  LeadStatusConfiguration2["EXCLUDED_FROM_FACILITY_LAST_TOUCH"] = "excludedFromFacilityLastTouch";
  LeadStatusConfiguration2["EXCLUDED_FROM_REJECTION_BLOCKER"] = "excludedFromRejectionBlocker";
  LeadStatusConfiguration2["FACILITY_DONT_TRANSFER_REQUESTS_FOR_LEAD"] = "facilityDontTransferRequestsForLead";
  LeadStatusConfiguration2["MEDICAL_EVENT_CANT_SKIP"] = "medicalEventCantSkip";
  LeadStatusConfiguration2["MEDICAL_FACILITY_CANT_REQUEST"] = "medicalFacilityCantRequest";
  LeadStatusConfiguration2["ONDER_CPAP_EXPORT_CANCELED"] = "onderCPAPExportCanceled";
  LeadStatusConfiguration2["QUEUES_HANDLER_TASK_HANDLING_NOT_NEEDED"] = "queuesHandlerTaskHandlingNotNeeded";
  LeadStatusConfiguration2["SHOW_BRIEF_SUMMARY"] = "showBriefSummary";
  LeadStatusConfiguration2["STATUS_REASON"] = "statusReason";
  LeadStatusConfiguration2["TEAM_FILTER_OUT"] = "teamFilterOut";
  LeadStatusConfiguration2["TREAT_AS_FINAL"] = "treatAsFinal";
  LeadStatusConfiguration2["TREAT_AS_CANCELED"] = "treatAsCanceled";
  LeadStatusConfiguration2["WAGSTAFF_LITIFY_DONT_EXPORT"] = "wagstaffLitifyDontExport";
  LeadStatusConfiguration2["WELCOME_EMAIL_DONT_SEND"] = "welcomeEmailDontSend";
  LeadStatusConfiguration2["PHILLIPS_LAW_DOCUMENT_EXPORT"] = "phillipsLawDocumentExport";
  LeadStatusConfiguration2["CLAIMANT_PORTAL_NOTIFICATION_EXCLUSION"] = "claimantPortalNotificationExclusion";
  LeadStatusConfiguration2["CLOSE_DOCUMENT_REQUESTS"] = "closeDocumentRequests";
  return LeadStatusConfiguration2;
})(LeadStatusConfiguration || {});
var configMap = /* @__PURE__ */ new Map([
  [
    "canceled" /* CANCELED */,
    {
      ["casewiseCanceledClaimStatus" /* CASEWISE_CANCELED_CLAIM_STATUS */]: true,
      ["documentRequestStatusExclusion" /* DOCUMENT_REQUEST_STATUS_EXCLUSION */]: true,
      ["documentRequestTransferExclusion" /* DOCUMENT_REQUEST_TRANSFER_EXCLUSION */]: true,
      ["excludedFromFacilityAutomatedAging" /* EXCLUDED_FROM_FACILITY_AUTOMATED_AGING */]: true,
      ["excludedFromFacilityLastTouch" /* EXCLUDED_FROM_FACILITY_LAST_TOUCH */]: true,
      ["excludedFromRejectionBlocker" /* EXCLUDED_FROM_REJECTION_BLOCKER */]: true,
      ["facilityDontTransferRequestsForLead" /* FACILITY_DONT_TRANSFER_REQUESTS_FOR_LEAD */]: true,
      ["medicalEventCantSkip" /* MEDICAL_EVENT_CANT_SKIP */]: true,
      ["medicalFacilityCantRequest" /* MEDICAL_FACILITY_CANT_REQUEST */]: true,
      ["onderCPAPExportCanceled" /* ONDER_CPAP_EXPORT_CANCELED */]: true,
      ["queuesHandlerTaskHandlingNotNeeded" /* QUEUES_HANDLER_TASK_HANDLING_NOT_NEEDED */]: true,
      ["showBriefSummary" /* SHOW_BRIEF_SUMMARY */]: true,
      ["treatAsCanceled" /* TREAT_AS_CANCELED */]: true,
      ["welcomeEmailDontSend" /* WELCOME_EMAIL_DONT_SEND */]: true,
      ["statusReason" /* STATUS_REASON */]: true,
      ["treatAsFinal" /* TREAT_AS_FINAL */]: true,
      ["teamFilterOut" /* TEAM_FILTER_OUT */]: true,
      ["phillipsLawDocumentExport" /* PHILLIPS_LAW_DOCUMENT_EXPORT */]: true,
      ["claimantPortalNotificationExclusion" /* CLAIMANT_PORTAL_NOTIFICATION_EXCLUSION */]: true,
      ["closeDocumentRequests" /* CLOSE_DOCUMENT_REQUESTS */]: true
    }
  ],
  [
    "complete" /* COMPLETE */,
    {
      ["welcomeEmailDontSend" /* WELCOME_EMAIL_DONT_SEND */]: true,
      ["phillipsLawDocumentExport" /* PHILLIPS_LAW_DOCUMENT_EXPORT */]: true,
      ["claimantPortalNotificationExclusion" /* CLAIMANT_PORTAL_NOTIFICATION_EXCLUSION */]: true
    }
  ],
  [
    "disproven" /* DISPROVEN */,
    {
      ["documentRequestStatusExclusion" /* DOCUMENT_REQUEST_STATUS_EXCLUSION */]: true,
      ["documentRequestTransferExclusion" /* DOCUMENT_REQUEST_TRANSFER_EXCLUSION */]: true,
      ["excludedFromFacilityAutomatedAging" /* EXCLUDED_FROM_FACILITY_AUTOMATED_AGING */]: true,
      ["excludedFromFacilityLastTouch" /* EXCLUDED_FROM_FACILITY_LAST_TOUCH */]: true,
      ["excludedFromRejectionBlocker" /* EXCLUDED_FROM_REJECTION_BLOCKER */]: true,
      ["facilityDontTransferRequestsForLead" /* FACILITY_DONT_TRANSFER_REQUESTS_FOR_LEAD */]: true,
      ["medicalEventCantSkip" /* MEDICAL_EVENT_CANT_SKIP */]: true,
      ["medicalFacilityCantRequest" /* MEDICAL_FACILITY_CANT_REQUEST */]: true,
      ["onderCPAPExportCanceled" /* ONDER_CPAP_EXPORT_CANCELED */]: true,
      ["queuesHandlerTaskHandlingNotNeeded" /* QUEUES_HANDLER_TASK_HANDLING_NOT_NEEDED */]: true,
      ["showBriefSummary" /* SHOW_BRIEF_SUMMARY */]: true,
      ["welcomeEmailDontSend" /* WELCOME_EMAIL_DONT_SEND */]: true,
      ["statusReason" /* STATUS_REASON */]: true,
      ["treatAsFinal" /* TREAT_AS_FINAL */]: true,
      ["claimantPortalNotificationExclusion" /* CLAIMANT_PORTAL_NOTIFICATION_EXCLUSION */]: true
    }
  ],
  [
    "disqualified" /* DISQUALIFIED */,
    {
      ["casewiseCanceledClaimStatus" /* CASEWISE_CANCELED_CLAIM_STATUS */]: true,
      ["documentRequestStatusExclusion" /* DOCUMENT_REQUEST_STATUS_EXCLUSION */]: true,
      ["documentRequestTransferExclusion" /* DOCUMENT_REQUEST_TRANSFER_EXCLUSION */]: true,
      ["excludedFromFacilityAutomatedAging" /* EXCLUDED_FROM_FACILITY_AUTOMATED_AGING */]: true,
      ["excludedFromFacilityLastTouch" /* EXCLUDED_FROM_FACILITY_LAST_TOUCH */]: true,
      ["excludedFromRejectionBlocker" /* EXCLUDED_FROM_REJECTION_BLOCKER */]: true,
      ["facilityDontTransferRequestsForLead" /* FACILITY_DONT_TRANSFER_REQUESTS_FOR_LEAD */]: true,
      ["medicalEventCantSkip" /* MEDICAL_EVENT_CANT_SKIP */]: true,
      ["medicalFacilityCantRequest" /* MEDICAL_FACILITY_CANT_REQUEST */]: true,
      ["onderCPAPExportCanceled" /* ONDER_CPAP_EXPORT_CANCELED */]: true,
      ["queuesHandlerTaskHandlingNotNeeded" /* QUEUES_HANDLER_TASK_HANDLING_NOT_NEEDED */]: true,
      ["showBriefSummary" /* SHOW_BRIEF_SUMMARY */]: true,
      ["treatAsCanceled" /* TREAT_AS_CANCELED */]: true,
      ["welcomeEmailDontSend" /* WELCOME_EMAIL_DONT_SEND */]: true,
      ["statusReason" /* STATUS_REASON */]: true,
      ["treatAsFinal" /* TREAT_AS_FINAL */]: true,
      ["teamFilterOut" /* TEAM_FILTER_OUT */]: true,
      ["phillipsLawDocumentExport" /* PHILLIPS_LAW_DOCUMENT_EXPORT */]: true,
      ["claimantPortalNotificationExclusion" /* CLAIMANT_PORTAL_NOTIFICATION_EXCLUSION */]: true
    }
  ],
  [
    "ingestion review" /* INGESTION_REVIEW */,
    {
      ["medicalFacilityCantRequest" /* MEDICAL_FACILITY_CANT_REQUEST */]: true,
      ["claimantPortalNotificationExclusion" /* CLAIMANT_PORTAL_NOTIFICATION_EXCLUSION */]: true
    }
  ],
  [
    "law firm review" /* LAW_FIRM_REVIEW */,
    {
      ["documentRequestStatusExclusion" /* DOCUMENT_REQUEST_STATUS_EXCLUSION */]: true,
      ["documentRequestTransferExclusion" /* DOCUMENT_REQUEST_TRANSFER_EXCLUSION */]: true,
      ["excludedFromFacilityAutomatedAging" /* EXCLUDED_FROM_FACILITY_AUTOMATED_AGING */]: true,
      ["excludedFromFacilityLastTouch" /* EXCLUDED_FROM_FACILITY_LAST_TOUCH */]: true,
      ["excludedFromRejectionBlocker" /* EXCLUDED_FROM_REJECTION_BLOCKER */]: true,
      ["facilityDontTransferRequestsForLead" /* FACILITY_DONT_TRANSFER_REQUESTS_FOR_LEAD */]: true,
      ["medicalFacilityCantRequest" /* MEDICAL_FACILITY_CANT_REQUEST */]: true,
      ["claimantPortalNotificationExclusion" /* CLAIMANT_PORTAL_NOTIFICATION_EXCLUSION */]: true
    }
  ],
  [
    "medical monitoring" /* MEDICAL_MONITORING */,
    {
      ["documentRequestTransferExclusion" /* DOCUMENT_REQUEST_TRANSFER_EXCLUSION */]: true,
      ["excludedFromFacilityAutomatedAging" /* EXCLUDED_FROM_FACILITY_AUTOMATED_AGING */]: true,
      ["excludedFromRejectionBlocker" /* EXCLUDED_FROM_REJECTION_BLOCKER */]: true,
      ["facilityDontTransferRequestsForLead" /* FACILITY_DONT_TRANSFER_REQUESTS_FOR_LEAD */]: true
    }
  ],
  [
    "on hold" /* ON_HOLD */,
    {
      ["queuesHandlerTaskHandlingNotNeeded" /* QUEUES_HANDLER_TASK_HANDLING_NOT_NEEDED */]: true,
      ["documentRequestTransferExclusion" /* DOCUMENT_REQUEST_TRANSFER_EXCLUSION */]: true,
      ["teamFilterOut" /* TEAM_FILTER_OUT */]: true,
      ["medicalFacilityCantRequest" /* MEDICAL_FACILITY_CANT_REQUEST */]: true,
      ["claimantPortalNotificationExclusion" /* CLAIMANT_PORTAL_NOTIFICATION_EXCLUSION */]: true
    }
  ],
  [
    "proven" /* PROVEN */,
    {
      ["onderCPAPExportCanceled" /* ONDER_CPAP_EXPORT_CANCELED */]: true,
      ["showBriefSummary" /* SHOW_BRIEF_SUMMARY */]: true,
      ["welcomeEmailDontSend" /* WELCOME_EMAIL_DONT_SEND */]: true,
      ["treatAsFinal" /* TREAT_AS_FINAL */]: true,
      ["claimantPortalNotificationExclusion" /* CLAIMANT_PORTAL_NOTIFICATION_EXCLUSION */]: true,
      ["closeDocumentRequests" /* CLOSE_DOCUMENT_REQUESTS */]: true
    }
  ],
  [
    "returned to law firm" /* RETURNED_TO_LAW_FIRM */,
    {
      ["documentRequestStatusExclusion" /* DOCUMENT_REQUEST_STATUS_EXCLUSION */]: true,
      ["documentRequestTransferExclusion" /* DOCUMENT_REQUEST_TRANSFER_EXCLUSION */]: true,
      ["excludedFromFacilityAutomatedAging" /* EXCLUDED_FROM_FACILITY_AUTOMATED_AGING */]: true,
      ["excludedFromFacilityLastTouch" /* EXCLUDED_FROM_FACILITY_LAST_TOUCH */]: true,
      ["excludedFromRejectionBlocker" /* EXCLUDED_FROM_REJECTION_BLOCKER */]: true,
      ["medicalEventCantSkip" /* MEDICAL_EVENT_CANT_SKIP */]: true,
      ["medicalFacilityCantRequest" /* MEDICAL_FACILITY_CANT_REQUEST */]: true,
      ["onderCPAPExportCanceled" /* ONDER_CPAP_EXPORT_CANCELED */]: true,
      ["queuesHandlerTaskHandlingNotNeeded" /* QUEUES_HANDLER_TASK_HANDLING_NOT_NEEDED */]: true,
      ["showBriefSummary" /* SHOW_BRIEF_SUMMARY */]: true,
      ["treatAsCanceled" /* TREAT_AS_CANCELED */]: true,
      ["welcomeEmailDontSend" /* WELCOME_EMAIL_DONT_SEND */]: true,
      ["wagstaffLitifyDontExport" /* WAGSTAFF_LITIFY_DONT_EXPORT */]: true,
      ["statusReason" /* STATUS_REASON */]: true,
      ["treatAsFinal" /* TREAT_AS_FINAL */]: true,
      ["teamFilterOut" /* TEAM_FILTER_OUT */]: true,
      ["phillipsLawDocumentExport" /* PHILLIPS_LAW_DOCUMENT_EXPORT */]: true,
      ["claimantPortalNotificationExclusion" /* CLAIMANT_PORTAL_NOTIFICATION_EXCLUSION */]: true,
      ["closeDocumentRequests" /* CLOSE_DOCUMENT_REQUESTS */]: true
    }
  ],
  [
    "case settled" /* CASE_SETTLED */,
    {
      ["claimantPortalNotificationExclusion" /* CLAIMANT_PORTAL_NOTIFICATION_EXCLUSION */]: true
    }
  ]
]);
var configurationToStatusesMap = /* @__PURE__ */ new Map();
configMap.forEach((config, status) => {
  Object.keys(config).forEach((configurationKey) => {
    var _a;
    const configuration = configurationKey;
    if (config[configuration]) {
      if (!configurationToStatusesMap.has(configuration)) {
        configurationToStatusesMap.set(configuration, []);
      }
      (_a = configurationToStatusesMap.get(configuration)) == null ? void 0 : _a.push(status);
    }
  });
});
function hasLeadStatusConfiguration(status, configuration) {
  const config = configMap.get(status);
  return config ? !!config[configuration] : false;
}
function getStatusesForConfiguration(configuration) {
  return configurationToStatusesMap.get(configuration) || [];
}

// src/Lead/index.ts
var MatterType = /* @__PURE__ */ ((MatterType2) => {
  MatterType2["ACETAMINOPHEN"] = "Acetaminophen";
  MatterType2["AUTO_ACCIDENT"] = "Auto Accident";
  MatterType2["BAIR_HUGGER"] = "Bair Hugger";
  MatterType2["CAMP_LEJEUNE"] = "Camp Lejeune";
  MatterType2["CPAP"] = "CPAP";
  MatterType2["DEPO_PROVERA"] = "Depo-Provera";
  MatterType2["DOG_BITE"] = "Dog Bite";
  MatterType2["EAR_PLUGS"] = "3M EarPlugs";
  MatterType2["ELMIRON"] = "Elmiron";
  MatterType2["FIRE_FOAM"] = "Fire Foam";
  MatterType2["HAIR_RELAXER"] = "Hair Relaxer";
  MatterType2["HERNIA_MESH"] = "Hernia Mesh";
  MatterType2["HIP_IMPLANT"] = "HIP Implant";
  MatterType2["INFANT_FORMULA"] = "Infant Formula";
  MatterType2["INSULIN_PUMP"] = "Insulin Pump";
  MatterType2["JUVENILE_DETENTION"] = "Juvenile Detention";
  MatterType2["KNEE_REPLACEMENT"] = "Knee Replacement";
  MatterType2["OPIOID"] = "Opioid";
  MatterType2["PARAGARD"] = "Paragard";
  MatterType2["PARAQUAT"] = "Paraquat";
  MatterType2["PFAS"] = "PFAS";
  MatterType2["PPI"] = "PPI";
  MatterType2["PREMISES_LIABILITY"] = "Premises Liability";
  MatterType2["RIDESHARE"] = "Rideshare";
  MatterType2["ROBLOX"] = "Roblox";
  MatterType2["ROUNDUP"] = "Roundup";
  MatterType2["SUBOXONE"] = "Suboxone";
  MatterType2["TALCUM_POWDER"] = "Talcum Powder";
  MatterType2["TOXIC_BABY_FOOD"] = "Toxic Baby Food";
  MatterType2["TOXIC_MATTRESS"] = "Toxic Mattress";
  MatterType2["TRUVADA"] = "Truvada";
  MatterType2["TVM"] = "TVM";
  MatterType2["USDA_FARM_LOAN_DISCRIMINATION"] = "USDA Farm Loan Discrimination";
  MatterType2["VALSARTAN"] = "Valsartan";
  MatterType2["ZANTAC"] = "Zantac";
  MatterType2["WILDFIRE"] = "Wildfire";
  return MatterType2;
})(MatterType || {});
var LineOfBusiness = /* @__PURE__ */ ((LineOfBusiness2) => {
  LineOfBusiness2["PERSONAL_INJURY"] = "Personal Injury";
  LineOfBusiness2["MASS_TORT"] = "Mass Tort";
  LineOfBusiness2["SEXUAL_ASSAULT"] = "Sexual Assault";
  LineOfBusiness2["NATURAL_DISASTER"] = "Natural Disaster";
  return LineOfBusiness2;
})(LineOfBusiness || {});
var LeadVerificationStatus = /* @__PURE__ */ ((LeadVerificationStatus2) => {
  LeadVerificationStatus2["NOT_VERIFIED"] = "not verified";
  LeadVerificationStatus2["PENDING_VERIFICATION"] = "pending verification";
  LeadVerificationStatus2["VERIFIED"] = "verified";
  return LeadVerificationStatus2;
})(LeadVerificationStatus || {});
var CaseTouchStatus = /* @__PURE__ */ ((CaseTouchStatus2) => {
  CaseTouchStatus2["AUTOMATED"] = "automated";
  CaseTouchStatus2["MANUAL"] = "manual";
  CaseTouchStatus2["NO_TOUCH_NEEDED"] = "no touch needed";
  return CaseTouchStatus2;
})(CaseTouchStatus || {});
var LeadOwnerRole = /* @__PURE__ */ ((LeadOwnerRole2) => {
  LeadOwnerRole2["OWNER"] = "owner";
  LeadOwnerRole2["SUB_OWNER"] = "subOwner";
  LeadOwnerRole2["LEGAL_PREPARATION_OWNER"] = "legalPreparationOwner";
  LeadOwnerRole2["LEGAL_QC_OWNER"] = "legalQCOwner";
  return LeadOwnerRole2;
})(LeadOwnerRole || {});

// src/Findings/talcum.ts
var SmokingHistoryOptions = /* @__PURE__ */ ((SmokingHistoryOptions2) => {
  SmokingHistoryOptions2["NEVER_SMOKER"] = "Never a smoker";
  SmokingHistoryOptions2["CURRENT_SMOKER"] = "Current Smoker";
  SmokingHistoryOptions2["FORMER_SMOKER"] = "Former Smoker";
  SmokingHistoryOptions2["LESS_THAN_1_PACK_WEEK"] = "Less than 1 pack/week";
  SmokingHistoryOptions2["ONE_PACK_WEEK"] = "1 pack/week";
  SmokingHistoryOptions2["ONE_PACK_DAY"] = "1 pack/day";
  SmokingHistoryOptions2["ONE_TWO_PACKS_DAY"] = "1-2 packs/day";
  SmokingHistoryOptions2["TWO_PLUS_PACKS_DAY"] = "2+ packs/day";
  SmokingHistoryOptions2["CIGARETTES"] = "Cigarettes";
  SmokingHistoryOptions2["OTHER_TOBACCO_PRODUCTS"] = "Other tobacco products";
  return SmokingHistoryOptions2;
})(SmokingHistoryOptions || {});
var SmokingStatusOptions = /* @__PURE__ */ ((SmokingStatusOptions2) => {
  SmokingStatusOptions2["NEVER_SMOKER"] = "Never a smoker";
  SmokingStatusOptions2["CURRENT_SMOKER"] = "Current smoker";
  SmokingStatusOptions2["FORMER_SMOKER"] = "Former smoker";
  return SmokingStatusOptions2;
})(SmokingStatusOptions || {});
var SmokingVolumeOptions = /* @__PURE__ */ ((SmokingVolumeOptions2) => {
  SmokingVolumeOptions2["LESS_THAN_1_PACK_WEEK"] = "Less than 1 pack/week";
  SmokingVolumeOptions2["ONE_PACK_WEEK"] = "1 pack/week";
  SmokingVolumeOptions2["ONE_PACK_DAY"] = "1 pack/day";
  SmokingVolumeOptions2["ONE_TWO_PACKS_DAY"] = "1-2 packs/day";
  SmokingVolumeOptions2["TWO_PLUS_PACKS_DAY"] = "2+ packs/day";
  return SmokingVolumeOptions2;
})(SmokingVolumeOptions || {});
var TobaccoTypeOptions = /* @__PURE__ */ ((TobaccoTypeOptions2) => {
  TobaccoTypeOptions2["CIGARETTES"] = "Cigarettes";
  TobaccoTypeOptions2["OTHER_TOBACCO_PRODUCTS"] = "Other tobacco products";
  return TobaccoTypeOptions2;
})(TobaccoTypeOptions || {});

// src/Findings/shared/qualifiedFindingSource.ts
var QUALIFIED_FINDING_SOURCE_OPTIONS = [
  "Cancer noted",
  "Death certificate only",
  "Not initial diagnosis",
  "Noted pathology",
  "Original pathology",
  "Weak mention"
];

// src/Findings/display-names.ts
import startCase from "lodash/startCase";
function getFindingDisplayName(params) {
  const { type, matterType, proofType, surgeryType = "" } = params;
  if (matterType === "3M EarPlugs" || matterType === "3M EarPlugs" /* EAR_PLUGS */) {
    return "Hearing Injury";
  }
  if (matterType === "Hernia Mesh" && surgeryType === "Revision")
    return "Revision Surgery";
  if (matterType === "Hernia Mesh" && surgeryType === "Implant")
    return "Surgery";
  const typeHeadings = {
    infant_formula_damages: "Injury",
    infant_formula_feeding: "Feeding",
    infant_formula_mother: "Mother's Medical History",
    infant_formula_mothers_tobacco_use: "Mother's Tobacco Use",
    infant_formula_nec: "NEC and NEC treatment",
    infant_formula_pre_nec: "Baby notes and Pre-NEC Health",
    toxic_baby_food_child_medical_history: "Child's Medical History",
    toxic_baby_food_mother_medical_history: "Mother's Medical History",
    toxic_baby_food_mother_tobacco_use: "Mother's Tobacco Use",
    pfas_use: "PFAS Proof of Use",
    pfas_injury: "PFAS Proof of Injury",
    sexual_assault_rideshare_receipt: "Rideshare Receipt",
    sexual_assault_rideshare_incident_report: "Rideshare Report",
    sexual_assault_police_report: "Incident Report",
    sexual_assault_medical_records: "Injury",
    sexual_assault_treatment: "Treatment",
    primary_care_physician: "Primary Care Physician",
    camp_lejeune_residency: "Proof of Residency",
    camp_lejeune_injury: "Proof of Injury"
  };
  if (typeHeadings[type]) {
    return typeHeadings[type];
  }
  if (proofType && ["other", "tylenol_mother_use", "camp_lejeune_injury"].includes(type)) {
    return capitalizationFixes(startCase(removePrefixes(proofType)));
  }
  return capitalizationFixes(startCase(removePrefixes(type)));
}
function removePrefixes(s) {
  return s.replace("talc_", "").replace("insulin_pump_", "").replace("infant_formula_", "").replace("fire_foam_", "").replace("hernia_mesh_", "").replace("tylenol_", "").replace("_finding", "").replace("hair_relaxer_", "");
}
function capitalizationFixes(s) {
  return s.replace("Nec", "NEC").replace("Cpap", "CPAP").replace("Of", "of");
}
function getProofTypeDisplayName(proofType) {
  switch (proofType) {
    case "proof_of_use" /* PROOF_OF_USE */:
      return "Use";
    case "general" /* GENERAL */:
      return "General";
    case "proof_of_injury" /* PROOF_OF_INJURY */:
      return "Injury";
    default:
      return (proofType == null ? void 0 : proofType.trim()) ? startCase(proofType) : "Injury";
  }
}

// src/Findings/injury-field-names.ts
var InjuryFieldNamesByFindingType = {
  ["depo_provera_proof_of_injury" /* DEPO_PROVERA_PROOF_OF_INJURY */]: [{ value: "symptoms", label: "Symptoms" }],
  ["roblox_forensic_exam" /* ROBLOX_FORENSIC_EXAM */]: [
    { value: "abuse", label: "Forms of Abuse" },
    { value: "injury", label: "Identified Injuries" }
  ],
  ["roblox_proof_of_injury" /* ROBLOX_PROOF_OF_INJURY */]: [
    { value: "abuse", label: "Forms of Abuse" },
    { value: "death", label: "Cause of Death" },
    { value: "injury", label: "Injuries" }
  ],
  ["roundup_medical_history" /* ROUNDUP_MEDICAL_HISTORY */]: [
    { value: "autoimmune", label: "Autoimmune Disorder" },
    { value: "cancer", label: "Cancer Diagnosis" },
    { value: "other", label: "Other Diagnosis" }
  ]
};
function getFieldNamesForFindingType(findingType) {
  if (!findingType)
    return [];
  return InjuryFieldNamesByFindingType[findingType] || [];
}

// src/Findings/index.ts
var FindingProofType = /* @__PURE__ */ ((FindingProofType2) => {
  FindingProofType2["GENERAL"] = "general";
  FindingProofType2["PROOF_OF_INJURY"] = "proof_of_injury";
  FindingProofType2["PROOF_OF_TREATMENT"] = "proof_of_treatment";
  FindingProofType2["PROOF_OF_USE"] = "proof_of_use";
  return FindingProofType2;
})(FindingProofType || {});
var FindingType = /* @__PURE__ */ ((FindingType2) => {
  FindingType2["ACCIDENT_INJURY"] = "accident_injury";
  FindingType2["AUTO_ACCIDENT_CRASH_REPORT"] = "auto_accident_crash_report";
  FindingType2["AUTO_ACCIDENT_DIAGNOSIS"] = "auto_accident_diagnosis";
  FindingType2["AUTO_ACCIDENT_MEDICAL_HISTORY"] = "auto_accident_medical_history";
  FindingType2["AUTO_ACCIDENT_POLICE_REPORT"] = "auto_accident_police_report";
  FindingType2["AUTO_ACCIDENT_PROPERTY_DAMAGE"] = "auto_accident_property_damage";
  FindingType2["AUTO_ACCIDENT_TREATMENT"] = "auto_accident_treatment";
  FindingType2["CAMP_LEJEUNE_INJURY"] = "camp_lejeune_injury";
  FindingType2["CAMP_LEJEUNE_RESIDENCY"] = "camp_lejeune_residency";
  FindingType2["CAMP_LEJEUNE_TOBACCO_USE"] = "camp_lejeune_tobacco_use";
  FindingType2["CAMP_LEJEUNE_TREATMENT"] = "camp_lejeune_treatment";
  FindingType2["CONSULTATION"] = "consultation";
  FindingType2["CONSULTATION_SUMMARY"] = "consultation_summary";
  FindingType2["CPAP_MEDICAL_HISTORY"] = "cpap_medical_history";
  FindingType2["CPAP_USE"] = "cpap_use";
  FindingType2["DEPO_PROVERA_MEDICAL_HISTORY"] = "depo_provera_medical_history";
  FindingType2["DEPO_PROVERA_PROOF_OF_INJURY"] = "depo_provera_proof_of_injury";
  FindingType2["DEPO_PROVERA_PROOF_OF_USE"] = "depo_provera_proof_of_use";
  FindingType2["DEPO_PROVERA_TREATMENT"] = "depo_provera_treatment";
  FindingType2["DEVICE_FINDING"] = "device_finding";
  FindingType2["DEVICE_IMPLANTED"] = "device_implanted";
  FindingType2["DEVICE_USAGE"] = "device_usage";
  FindingType2["DIABETES_TREATMENT"] = "diabetes_treatment";
  FindingType2["FIRE_FOAM_INJURIES"] = "fire_foam_injuries";
  FindingType2["HAIR_RELAXER_FAMILY_MEDICAL_HISTORY"] = "hair_relaxer_family_medical_history";
  FindingType2["HAIR_RELAXER_INJURY"] = "hair_relaxer_injury";
  FindingType2["HAIR_RELAXER_MEDICAL_HISTORY"] = "hair_relaxer_medical_history";
  FindingType2["HAIR_RELAXER_TREATMENT"] = "hair_relaxer_treatment";
  FindingType2["HAIR_RELAXER_USE"] = "hair_relaxer_use";
  FindingType2["HEARING_INJURY"] = "hearing_injury";
  FindingType2["HERNIA_MESH_INJURIES"] = "hernia_mesh_injuries";
  FindingType2["HERNIA_MESH_SURGERY"] = "hernia_mesh_surgery";
  FindingType2["INFANT_FORMULA_DAMAGES"] = "infant_formula_damages";
  FindingType2["INFANT_FORMULA_FEEDING"] = "infant_formula_feeding";
  FindingType2["INFANT_FORMULA_GENERAL"] = "infant_formula_general";
  FindingType2["INFANT_FORMULA_INJURY"] = "infant_formula_injury";
  FindingType2["INFANT_FORMULA_MOTHER"] = "infant_formula_mother";
  FindingType2["INFANT_FORMULA_MOTHERS_TOBACCO_USE"] = "infant_formula_mothers_tobacco_use";
  FindingType2["INFANT_FORMULA_NEC"] = "infant_formula_nec";
  FindingType2["INFANT_FORMULA_PRE_NEC"] = "infant_formula_pre_nec";
  FindingType2["INSULIN_PUMP_GENERAL"] = "insulin_pump_general";
  FindingType2["INSULIN_PUMP_INJURY"] = "insulin_pump_injury";
  FindingType2["INSULIN_PUMP_USE"] = "insulin_pump_use";
  FindingType2["OTHER"] = "other";
  FindingType2["PARAQUAT_FAMILY_MEDICAL_HISTORY"] = "paraquat_family_medical_history";
  FindingType2["PARAQUAT_INJURY"] = "paraquat_injury";
  FindingType2["PARAQUAT_MEDICAL_HISTORY"] = "paraquat_medical_history";
  FindingType2["PARAQUAT_MEDICATION"] = "paraquat_medication";
  FindingType2["PARAQUAT_TOBACCO_USE"] = "paraquat_tobacco_use";
  FindingType2["PARAQUAT_USE"] = "paraquat_use";
  FindingType2["PRE_EXISTING_CONDITION"] = "pre_existing_condition";
  FindingType2["PRESCRIPTION_FILLED"] = "prescription_filled";
  FindingType2["PRIMARY_CARE_PHYSICIAN"] = "primary_care_physician";
  FindingType2["PROOF_OF_INJURY"] = "proof_of_injury";
  FindingType2["PROOF_OF_USE"] = "proof_of_use";
  FindingType2["RECALL"] = "recall";
  FindingType2["RELATED_CONDITION"] = "related_condition";
  FindingType2["ROUNDUP_FAMILY_MEDICAL_HISTORY"] = "roundup_family_medical_history";
  FindingType2["ROUNDUP_INJURY"] = "roundup_injury";
  FindingType2["ROUNDUP_MEDICAL_HISTORY"] = "roundup_medical_history";
  FindingType2["ROUNDUP_TOBACCO_USE"] = "roundup_tobacco_use";
  FindingType2["ROUNDUP_TREATMENT"] = "roundup_treatment";
  FindingType2["ROUNDUP_USE"] = "roundup_use";
  FindingType2["PFAS_USE"] = "pfas_use";
  FindingType2["PFAS_INJURY"] = "pfas_injury";
  FindingType2["TALC_FAMILY_MEDICAL_HISTORY"] = "talc_family_medical_history";
  FindingType2["TALC_MEDICAL_HISTORY"] = "talc_medical_history";
  FindingType2["TALC_TREATMENT"] = "talc_treatment";
  FindingType2["TOBACCO_USE"] = "tobacco_use";
  FindingType2["TOXIC_BABY_FOOD_FAMILY_MEDICAL_HISTORY"] = "toxic_baby_food_family_medical_history";
  FindingType2["TOXIC_BABY_FOOD_INJURY"] = "toxic_baby_food_injury";
  FindingType2["TOXIC_BABY_FOOD_CHILD_MEDICAL_HISTORY"] = "toxic_baby_food_child_medical_history";
  FindingType2["TOXIC_BABY_FOOD_MOTHER_MEDICAL_HISTORY"] = "toxic_baby_food_mother_medical_history";
  FindingType2["TOXIC_BABY_FOOD_MOTHER_TOBACCO_USE"] = "toxic_baby_food_mother_tobacco_use";
  FindingType2["TOXIC_BABY_FOOD_TREATMENT"] = "toxic_baby_food_treatment";
  FindingType2["TOXIC_BABY_FOOD_USE"] = "toxic_baby_food_use";
  FindingType2["TYLENOL_CHILD_INJURY"] = "tylenol_child_injury";
  FindingType2["TYLENOL_CHILD_MEDICAL_HISTORY"] = "tylenol_child_medical_history";
  FindingType2["TYLENOL_CHILDS_MEDICATION"] = "childs_medication";
  FindingType2["TYLENOL_EARLY_INTERVENTION"] = "early_intervention";
  FindingType2["TYLENOL_FAMILY_MEDICAL_HISTORY"] = "tylenol_family_medical_history";
  FindingType2["TYLENOL_MOTHER_USE"] = "tylenol_mother_use";
  FindingType2["TYLENOL_PARENT_MEDICAL_HISTORY"] = "tylenol_parent_medical_history";
  FindingType2["TYLENOL_SCHOOL_ACCOMMODATION"] = "school_accommodation";
  FindingType2["ZANTAC_MEDICAL_HISTORY"] = "zantac_medical_history";
  FindingType2["ZANTAC_TREATMENT"] = "zantac_treatment";
  FindingType2["SUBOXONE_USE"] = "suboxone_use";
  FindingType2["SUBOXONE_INJURY"] = "suboxone_injury";
  FindingType2["SUBOXONE_MEDICAL_HISTORY"] = "suboxone_medical_history";
  FindingType2["SEXUAL_ASSAULT_RIDESHARE_RECEIPT"] = "sexual_assault_rideshare_receipt";
  FindingType2["SEXUAL_ASSAULT_RIDESHARE_INCIDENT_REPORT"] = "sexual_assault_rideshare_incident_report";
  FindingType2["SEXUAL_ASSAULT_POLICE_REPORT"] = "sexual_assault_police_report";
  FindingType2["SEXUAL_ASSAULT_MEDICAL_RECORDS"] = "sexual_assault_medical_records";
  FindingType2["SEXUAL_ASSAULT_TREATMENT"] = "sexual_assault_treatment";
  FindingType2["ROBLOX_PROOF_OF_INJURY"] = "roblox_proof_of_injury";
  FindingType2["ROBLOX_PROOF_OF_USE"] = "roblox_proof_of_use";
  FindingType2["ROBLOX_TREATMENT"] = "roblox_treatment";
  FindingType2["ROBLOX_MEDICAL_HISTORY"] = "roblox_medical_history";
  FindingType2["ROBLOX_FORENSIC_EXAM"] = "roblox_forensic_exam";
  return FindingType2;
})(FindingType || {});
var FindingTypesByMatterType = {
  ["3M EarPlugs" /* EAR_PLUGS */]: ["hearing_injury" /* HEARING_INJURY */, "other" /* OTHER */],
  ["Acetaminophen" /* ACETAMINOPHEN */]: [
    "tylenol_child_injury" /* TYLENOL_CHILD_INJURY */,
    "tylenol_child_medical_history" /* TYLENOL_CHILD_MEDICAL_HISTORY */,
    "childs_medication" /* TYLENOL_CHILDS_MEDICATION */,
    "early_intervention" /* TYLENOL_EARLY_INTERVENTION */,
    "tylenol_family_medical_history" /* TYLENOL_FAMILY_MEDICAL_HISTORY */,
    "tylenol_mother_use" /* TYLENOL_MOTHER_USE */,
    "tylenol_parent_medical_history" /* TYLENOL_PARENT_MEDICAL_HISTORY */,
    "school_accommodation" /* TYLENOL_SCHOOL_ACCOMMODATION */
  ],
  ["Auto Accident" /* AUTO_ACCIDENT */]: [
    "auto_accident_crash_report" /* AUTO_ACCIDENT_CRASH_REPORT */,
    "auto_accident_diagnosis" /* AUTO_ACCIDENT_DIAGNOSIS */,
    "auto_accident_medical_history" /* AUTO_ACCIDENT_MEDICAL_HISTORY */,
    "auto_accident_police_report" /* AUTO_ACCIDENT_POLICE_REPORT */,
    "auto_accident_property_damage" /* AUTO_ACCIDENT_PROPERTY_DAMAGE */,
    "auto_accident_treatment" /* AUTO_ACCIDENT_TREATMENT */
  ],
  ["Camp Lejeune" /* CAMP_LEJEUNE */]: [
    "camp_lejeune_injury" /* CAMP_LEJEUNE_INJURY */,
    "camp_lejeune_residency" /* CAMP_LEJEUNE_RESIDENCY */,
    "camp_lejeune_treatment" /* CAMP_LEJEUNE_TREATMENT */,
    "camp_lejeune_tobacco_use" /* CAMP_LEJEUNE_TOBACCO_USE */
  ],
  ["CPAP" /* CPAP */]: [
    "cpap_medical_history" /* CPAP_MEDICAL_HISTORY */,
    "device_finding" /* DEVICE_FINDING */,
    "primary_care_physician" /* PRIMARY_CARE_PHYSICIAN */,
    "proof_of_injury" /* PROOF_OF_INJURY */,
    "proof_of_use" /* PROOF_OF_USE */,
    "related_condition" /* RELATED_CONDITION */,
    "cpap_use" /* CPAP_USE */
  ],
  ["Depo-Provera" /* DEPO_PROVERA */]: [
    "depo_provera_medical_history" /* DEPO_PROVERA_MEDICAL_HISTORY */,
    "depo_provera_proof_of_use" /* DEPO_PROVERA_PROOF_OF_USE */,
    "depo_provera_proof_of_injury" /* DEPO_PROVERA_PROOF_OF_INJURY */,
    "depo_provera_treatment" /* DEPO_PROVERA_TREATMENT */,
    "tobacco_use" /* TOBACCO_USE */
  ],
  ["Elmiron" /* ELMIRON */]: ["prescription_filled" /* PRESCRIPTION_FILLED */],
  ["Fire Foam" /* FIRE_FOAM */]: ["fire_foam_injuries" /* FIRE_FOAM_INJURIES */],
  ["Hair Relaxer" /* HAIR_RELAXER */]: [
    "hair_relaxer_family_medical_history" /* HAIR_RELAXER_FAMILY_MEDICAL_HISTORY */,
    "hair_relaxer_medical_history" /* HAIR_RELAXER_MEDICAL_HISTORY */,
    "hair_relaxer_treatment" /* HAIR_RELAXER_TREATMENT */,
    "proof_of_injury" /* PROOF_OF_INJURY */,
    "proof_of_use" /* PROOF_OF_USE */
  ],
  ["Hernia Mesh" /* HERNIA_MESH */]: [
    "device_implanted" /* DEVICE_IMPLANTED */,
    "hernia_mesh_injuries" /* HERNIA_MESH_INJURIES */,
    "hernia_mesh_surgery" /* HERNIA_MESH_SURGERY */
  ],
  ["Infant Formula" /* INFANT_FORMULA */]: [
    "infant_formula_damages" /* INFANT_FORMULA_DAMAGES */,
    "infant_formula_feeding" /* INFANT_FORMULA_FEEDING */,
    "infant_formula_mother" /* INFANT_FORMULA_MOTHER */,
    "infant_formula_mothers_tobacco_use" /* INFANT_FORMULA_MOTHERS_TOBACCO_USE */,
    "infant_formula_nec" /* INFANT_FORMULA_NEC */,
    "infant_formula_pre_nec" /* INFANT_FORMULA_PRE_NEC */
  ],
  ["Insulin Pump" /* INSULIN_PUMP */]: [
    "consultation_summary" /* CONSULTATION_SUMMARY */,
    "diabetes_treatment" /* DIABETES_TREATMENT */,
    "insulin_pump_general" /* INSULIN_PUMP_GENERAL */,
    "insulin_pump_injury" /* INSULIN_PUMP_INJURY */,
    "insulin_pump_use" /* INSULIN_PUMP_USE */
  ],
  ["Opioid" /* OPIOID */]: ["other" /* OTHER */, "prescription_filled" /* PRESCRIPTION_FILLED */],
  ["Paraquat" /* PARAQUAT */]: [
    "paraquat_family_medical_history" /* PARAQUAT_FAMILY_MEDICAL_HISTORY */,
    "paraquat_injury" /* PARAQUAT_INJURY */,
    "paraquat_medical_history" /* PARAQUAT_MEDICAL_HISTORY */,
    "paraquat_medication" /* PARAQUAT_MEDICATION */,
    "paraquat_tobacco_use" /* PARAQUAT_TOBACCO_USE */,
    "paraquat_use" /* PARAQUAT_USE */
  ],
  ["Roundup" /* ROUNDUP */]: [
    "other" /* OTHER */,
    "roundup_family_medical_history" /* ROUNDUP_FAMILY_MEDICAL_HISTORY */,
    "roundup_injury" /* ROUNDUP_INJURY */,
    "roundup_medical_history" /* ROUNDUP_MEDICAL_HISTORY */,
    "roundup_tobacco_use" /* ROUNDUP_TOBACCO_USE */,
    "roundup_treatment" /* ROUNDUP_TREATMENT */,
    "roundup_use" /* ROUNDUP_USE */
  ],
  ["Talcum Powder" /* TALCUM_POWDER */]: [
    "proof_of_injury" /* PROOF_OF_INJURY */,
    "proof_of_use" /* PROOF_OF_USE */,
    "talc_family_medical_history" /* TALC_FAMILY_MEDICAL_HISTORY */,
    "talc_medical_history" /* TALC_MEDICAL_HISTORY */,
    "talc_treatment" /* TALC_TREATMENT */,
    "tobacco_use" /* TOBACCO_USE */
  ],
  ["Toxic Baby Food" /* TOXIC_BABY_FOOD */]: [
    "other" /* OTHER */,
    "prescription_filled" /* PRESCRIPTION_FILLED */,
    "toxic_baby_food_child_medical_history" /* TOXIC_BABY_FOOD_CHILD_MEDICAL_HISTORY */,
    "toxic_baby_food_family_medical_history" /* TOXIC_BABY_FOOD_FAMILY_MEDICAL_HISTORY */,
    "toxic_baby_food_injury" /* TOXIC_BABY_FOOD_INJURY */,
    "toxic_baby_food_mother_medical_history" /* TOXIC_BABY_FOOD_MOTHER_MEDICAL_HISTORY */,
    "toxic_baby_food_mother_tobacco_use" /* TOXIC_BABY_FOOD_MOTHER_TOBACCO_USE */,
    "toxic_baby_food_treatment" /* TOXIC_BABY_FOOD_TREATMENT */,
    "toxic_baby_food_use" /* TOXIC_BABY_FOOD_USE */
  ],
  ["Zantac" /* ZANTAC */]: [
    "other" /* OTHER */,
    "prescription_filled" /* PRESCRIPTION_FILLED */,
    "proof_of_use" /* PROOF_OF_USE */,
    "zantac_medical_history" /* ZANTAC_MEDICAL_HISTORY */,
    "zantac_treatment" /* ZANTAC_TREATMENT */
  ],
  ["Suboxone" /* SUBOXONE */]: [
    "suboxone_use" /* SUBOXONE_USE */,
    "suboxone_injury" /* SUBOXONE_INJURY */,
    "suboxone_medical_history" /* SUBOXONE_MEDICAL_HISTORY */
  ],
  ["Rideshare" /* RIDESHARE */]: [
    "sexual_assault_rideshare_receipt" /* SEXUAL_ASSAULT_RIDESHARE_RECEIPT */,
    "sexual_assault_rideshare_incident_report" /* SEXUAL_ASSAULT_RIDESHARE_INCIDENT_REPORT */,
    "sexual_assault_police_report" /* SEXUAL_ASSAULT_POLICE_REPORT */,
    "sexual_assault_medical_records" /* SEXUAL_ASSAULT_MEDICAL_RECORDS */,
    "sexual_assault_treatment" /* SEXUAL_ASSAULT_TREATMENT */
  ],
  ["PFAS" /* PFAS */]: ["proof_of_use" /* PROOF_OF_USE */],
  ["Roblox" /* ROBLOX */]: [
    "roblox_proof_of_injury" /* ROBLOX_PROOF_OF_INJURY */,
    "roblox_proof_of_use" /* ROBLOX_PROOF_OF_USE */,
    "roblox_treatment" /* ROBLOX_TREATMENT */,
    "roblox_medical_history" /* ROBLOX_MEDICAL_HISTORY */,
    "roblox_forensic_exam" /* ROBLOX_FORENSIC_EXAM */
  ],
  ["Bair Hugger" /* BAIR_HUGGER */]: [],
  ["HIP Implant" /* HIP_IMPLANT */]: [],
  ["Juvenile Detention" /* JUVENILE_DETENTION */]: [],
  ["Knee Replacement" /* KNEE_REPLACEMENT */]: [],
  ["Paragard" /* PARAGARD */]: [],
  ["PPI" /* PPI */]: [],
  ["Toxic Mattress" /* TOXIC_MATTRESS */]: [],
  ["Truvada" /* TRUVADA */]: [],
  ["TVM" /* TVM */]: [],
  ["USDA Farm Loan Discrimination" /* USDA_FARM_LOAN_DISCRIMINATION */]: [],
  ["Valsartan" /* VALSARTAN */]: [],
  ["Dog Bite" /* DOG_BITE */]: [],
  ["Premises Liability" /* PREMISES_LIABILITY */]: [],
  ["Wildfire" /* WILDFIRE */]: []
};
var FindingError = /* @__PURE__ */ ((FindingError2) => {
  FindingError2["LAST_QUALIFYING_FINDING_FOR_PROVEN_LEAD"] = "last-qualifying-finding-for-proven-lead";
  return FindingError2;
})(FindingError || {});

// src/Forms/formelements.ts
var FormElementType = /* @__PURE__ */ ((FormElementType2) => {
  FormElementType2["ADDRESS"] = "address";
  FormElementType2["DATE"] = "date";
  FormElementType2["DATE_TO_PRESENT"] = "date-to-present";
  FormElementType2["DATE_RANGE"] = "date-range";
  FormElementType2["DRUG"] = "drug";
  FormElementType2["FREETEXT"] = "freetext";
  FormElementType2["HEADING"] = "heading";
  FormElementType2["INJURY"] = "injury";
  FormElementType2["INSURANCE_COMPANY"] = "insurance-company";
  FormElementType2["MATRIX"] = "matrix";
  FormElementType2["MONTH_DATE"] = "month-date";
  FormElementType2["MULTICHOICE"] = "multichoice";
  FormElementType2["PARAGRAPH"] = "paragraph";
  FormElementType2["PARTIAL_DATE"] = "partial-date";
  FormElementType2["SINGLECHOICE"] = "singlechoice";
  FormElementType2["VIEW_ONLY"] = "view-only";
  FormElementType2["YEAR_DATE"] = "year-date";
  FormElementType2["QUESTION_GROUPING"] = "question-grouping";
  return FormElementType2;
})(FormElementType || {});
var FormMatrixElementType = /* @__PURE__ */ ((FormMatrixElementType2) => {
  FormMatrixElementType2["ADDRESS"] = "address";
  FormMatrixElementType2["DATE_TO_PRESENT"] = "date-to-present";
  FormMatrixElementType2["FREETEXT"] = "freetext";
  FormMatrixElementType2["SINGLECHOICE"] = "singlechoice";
  FormMatrixElementType2["MULTICHOICE"] = "multichoice";
  FormMatrixElementType2["PARTIAL_DATE"] = "partial-date";
  FormMatrixElementType2["VIEW_ONLY"] = "view-only";
  FormMatrixElementType2["INJURY"] = "injury";
  FormMatrixElementType2["DRUG"] = "drug";
  return FormMatrixElementType2;
})(FormMatrixElementType || {});
var ResourceTypeFormElements = /* @__PURE__ */ ((ResourceTypeFormElements2) => {
  ResourceTypeFormElements2["DATE"] = "date" /* DATE */;
  ResourceTypeFormElements2["DRUG"] = "drug" /* DRUG */;
  ResourceTypeFormElements2["INJURY"] = "injury" /* INJURY */;
  ResourceTypeFormElements2["INSURANCE_COMPANY"] = "insurance-company" /* INSURANCE_COMPANY */;
  ResourceTypeFormElements2["MATRIX"] = "matrix" /* MATRIX */;
  ResourceTypeFormElements2["MONTH_DATE"] = "month-date" /* MONTH_DATE */;
  ResourceTypeFormElements2["MULTICHOICE"] = "multichoice" /* MULTICHOICE */;
  return ResourceTypeFormElements2;
})(ResourceTypeFormElements || {});
var RestrictionType = /* @__PURE__ */ ((RestrictionType2) => {
  RestrictionType2["EDIT_ACCESS"] = "Edit access";
  RestrictionType2["VIEW_ONLY"] = "View only";
  return RestrictionType2;
})(RestrictionType || {});

// src/ContextMapping/ContextFieldMapping.ts
var DockitFieldSourceMapping = /* @__PURE__ */ ((DockitFieldSourceMapping2) => {
  DockitFieldSourceMapping2["ClaimantInformation"] = "claimant-information";
  DockitFieldSourceMapping2["EventsAndRequests"] = "events-and-requests";
  DockitFieldSourceMapping2["FormPage"] = "form-page";
  DockitFieldSourceMapping2["Legal"] = "legal";
  DockitFieldSourceMapping2["NoPage"] = "";
  DockitFieldSourceMapping2["Review"] = "review";
  return DockitFieldSourceMapping2;
})(DockitFieldSourceMapping || {});
var ScalarShapes = /* @__PURE__ */ ((ScalarShapes2) => {
  ScalarShapes2["address"] = "address";
  ScalarShapes2["boolean"] = "boolean";
  ScalarShapes2["date"] = "date";
  ScalarShapes2["drug"] = "drug";
  ScalarShapes2["facility"] = "facility";
  ScalarShapes2["injuries"] = "injuries";
  ScalarShapes2["string"] = "string";
  ScalarShapes2["stringArray"] = "stringArray";
  ScalarShapes2["date_range"] = "date-range";
  return ScalarShapes2;
})(ScalarShapes || {});
var ContextFieldMapping = class {
};

// src/ContextMapping/BaseColumnOptions.ts
var baseFindingColumnOptions = [
  {
    label: "Start date",
    path: "startDate",
    shape: "date" /* date */,
    compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
    page: "review" /* Review */
  },
  {
    label: "End date",
    path: "endDate",
    shape: "date" /* date */,
    compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
    page: "review" /* Review */
  },
  {
    label: "Medical facility address",
    path: "medicalFacility.address",
    compatibleFormElementTypes: ["address" /* ADDRESS */, "freetext" /* FREETEXT */],
    page: "events-and-requests" /* EventsAndRequests */,
    shape: "address" /* address */
  },
  {
    label: "Medical facility name",
    path: "medicalFacility.name",
    compatibleFormElementTypes: ["freetext" /* FREETEXT */],
    page: "events-and-requests" /* EventsAndRequests */,
    shape: "string" /* string */
  }
];
var baseEventColumnOptions = [
  {
    label: "Start date",
    path: "date",
    shape: "date" /* date */,
    compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
    page: "events-and-requests" /* EventsAndRequests */
  },
  {
    label: "End date",
    path: "endDate",
    shape: "date" /* date */,
    compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
    page: "events-and-requests" /* EventsAndRequests */
  },
  {
    label: "Date precision",
    path: "datePrecision",
    shape: "string" /* string */,
    compatibleFormElementTypes: ["freetext" /* FREETEXT */],
    page: "events-and-requests" /* EventsAndRequests */
  },
  {
    label: "Medical facility address",
    path: "medicalFacilityAddress",
    compatibleFormElementTypes: ["address" /* ADDRESS */, "freetext" /* FREETEXT */],
    page: "events-and-requests" /* EventsAndRequests */,
    shape: "address" /* address */
  },
  {
    label: "Medical facility name",
    path: "medicalFacilityName",
    compatibleFormElementTypes: ["freetext" /* FREETEXT */],
    page: "events-and-requests" /* EventsAndRequests */,
    shape: "string" /* string */
  }
];

// src/ContextMapping/FindingMapping/FireFoam.ts
var fireFoamInjuryFinding = {
  name: "fireFoamInjuryFinding",
  label: "Fire Foam - Injury",
  description: "The matrix data for the fire foam injury finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "fire_foam_injuries" /* FIRE_FOAM_INJURIES */,
  proofType: "proof_of_injury" /* PROOF_OF_INJURY */,
  matterType: "Fire Foam" /* FIRE_FOAM */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Injuries",
      path: "details.injuryIds",
      shape: "injuries" /* injuries */,
      compatibleFormElementTypes: ["injury" /* INJURY */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var FireFoamFindingContextFieldMapping = {
  fireFoamInjuryFinding
};
var FireFoamFindingContextFieldMappings = Object.values(FireFoamFindingContextFieldMapping);

// src/ContextMapping/FindingMapping/Paraquat.ts
var paraquatInjuryFinding = {
  name: "paraquatInjuryFinding",
  label: "Paraquat - Injury",
  description: "The matrix data for the paraquat injury finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "paraquat_injury" /* PARAQUAT_INJURY */,
  proofType: "proof_of_injury" /* PROOF_OF_INJURY */,
  matterType: "Paraquat" /* PARAQUAT */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Diagnosing facility",
      path: "details.diagnosingFacilityId",
      shape: "facility" /* facility */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Injuries",
      path: "details.injuryIds",
      shape: "injuries" /* injuries */,
      compatibleFormElementTypes: ["injury" /* INJURY */],
      page: "review" /* Review */
    },
    {
      label: "Physician",
      path: "details.physician",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Symptoms",
      path: "details.symptoms",
      shape: "stringArray" /* stringArray */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Symptoms symmetry",
      path: "details.symptomsSymmetry",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var paraquatMedicationFinding = {
  name: "paraquatMedicationFinding",
  label: "Paraquat - Medication",
  description: "The matrix data for the paraquat medication finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "paraquat_medication" /* PARAQUAT_MEDICATION */,
  proofType: "general" /* GENERAL */,
  matterType: "Paraquat" /* PARAQUAT */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Drug",
      path: "details.drugId",
      shape: "drug" /* drug */,
      compatibleFormElementTypes: ["drug" /* DRUG */],
      page: "review" /* Review */
    },
    {
      label: "Record date",
      path: "details.recordDate",
      shape: "date" /* date */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
      page: "review" /* Review */
    },
    {
      label: "Prescriber",
      path: "details.prescriber",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Quantity",
      path: "details.quantity",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Day supply",
      path: "details.daySupply",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Dosage",
      path: "details.dosage",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var paraquatTobaccoFinding = {
  name: "paraquatTobaccoFinding",
  label: "Paraquat - Tobacco use",
  description: "The matrix data for the paraquat tobacco use finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "paraquat_tobacco_use" /* PARAQUAT_TOBACCO_USE */,
  proofType: "general" /* GENERAL */,
  matterType: "Paraquat" /* PARAQUAT */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Tobacco use",
      path: "details.tobaccoUse",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Years smoking",
      path: "details.yearsSmoking",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Record date",
      path: "details.recordDate",
      shape: "date" /* date */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
      page: "review" /* Review */
    },
    {
      label: "Smoker at time of diagnosis",
      path: "details.smokerAtTimeOfDiagnosis",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var paraquatUseFinding = {
  name: "paraquatUseFinding",
  label: "Paraquat - Use",
  description: "The matrix data for the paraquat use finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "paraquat_use" /* PARAQUAT_USE */,
  proofType: "proof_of_use" /* PROOF_OF_USE */,
  matterType: "Paraquat" /* PARAQUAT */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Products",
      path: "details.products",
      shape: "stringArray" /* stringArray */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Purchase location",
      path: "details.purchaseLocation",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Purchase transaction method",
      path: "details.purchaseTransactionMethod",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var paraquatMedicalHistoryFinding = {
  name: "paraquatMedicalHistoryFinding",
  label: "Paraquat - Medical history",
  description: "The matrix data for the paraquat medical history finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "paraquat_medical_history" /* PARAQUAT_MEDICAL_HISTORY */,
  proofType: "general" /* GENERAL */,
  matterType: "Paraquat" /* PARAQUAT */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Diagnosing facility",
      path: "details.diagnosingFacilityId",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Record date",
      path: "details.recordDate",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
      page: "review" /* Review */
    },
    {
      label: "Physician",
      path: "details.physician",
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      shape: "string" /* string */,
      page: "review" /* Review */
    },
    {
      label: "BMI",
      path: "details.bmi",
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      shape: "string" /* string */,
      page: "review" /* Review */
    },
    {
      label: "Diagnosis",
      path: "details.diagnosis",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var paraquatFamilyMedicalHistoryFinding = {
  name: "paraquatFamilyMedicalHistoryFinding",
  label: "Paraquat - Family medical history",
  description: "The matrix data for the paraquat family medical history finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "paraquat_family_medical_history" /* PARAQUAT_FAMILY_MEDICAL_HISTORY */,
  proofType: "general" /* GENERAL */,
  matterType: "Paraquat" /* PARAQUAT */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Relationship",
      path: "details.relationship",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Diagnosis",
      path: "details.diagnosis",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Record Date",
      path: "details.recordDate",
      shape: "date" /* date */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
      page: "review" /* Review */
    },
    {
      label: "Physician",
      path: "details.physician",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var ParaquatFindingContextFieldMapping = {
  paraquatInjuryFinding,
  paraquatMedicationFinding,
  paraquatTobaccoFinding,
  paraquatUseFinding,
  paraquatMedicalHistoryFinding,
  paraquatFamilyMedicalHistoryFinding
};
var ParaquatFindingContextFieldMappings = Object.values(ParaquatFindingContextFieldMapping);

// src/ContextMapping/FindingMapping/Roundup.ts
var roundupUseFinding = {
  name: "roundupUseFinding",
  label: "Roundup - Use",
  description: "The matrix data for the roundup use finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "roundup_use" /* ROUNDUP_USE */,
  proofType: "proof_of_use" /* PROOF_OF_USE */,
  matterType: "Roundup" /* ROUNDUP */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Purchase location",
      path: "details.purchaseLocation",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Purchase transaction method",
      path: "details.purchaseTransactionMethod",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var roundupTreatmentFinding = {
  name: "roundupTreatmentFinding",
  label: "Roundup - Treatment",
  description: "The matrix data for the roundup treatment finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "roundup_treatment" /* ROUNDUP_TREATMENT */,
  proofType: "general" /* GENERAL */,
  matterType: "Roundup" /* ROUNDUP */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Physician",
      path: "details.physician",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Record date",
      path: "details.recordDate",
      shape: "date" /* date */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
      page: "review" /* Review */
    },
    {
      label: "Treatment types",
      path: "details.treatmentTypes",
      shape: "stringArray" /* stringArray */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Treatment course number",
      path: "details.treatmentCourseNumber",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Treatment course completed",
      path: "details.treatmentCourseCompleted",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Cycles",
      path: "details.cycles",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    },
    {
      label: "Medical facility name",
      path: "medicalFacilityName",
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "string" /* string */
    }
  ]
};
var roundupInjuryFinding = {
  name: "roundupInjuryFinding",
  label: "Roundup - Injury",
  description: "The matrix data for the roundup injury finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "roundup_injury" /* ROUNDUP_INJURY */,
  proofType: "proof_of_injury" /* PROOF_OF_INJURY */,
  matterType: "Roundup" /* ROUNDUP */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Injuries",
      path: "details.injuryIds",
      shape: "injuries" /* injuries */,
      compatibleFormElementTypes: ["injury" /* INJURY */],
      page: "review" /* Review */
    },
    {
      label: "Diagnosing facility",
      path: "details.diagnosingFacilityId",
      shape: "facility" /* facility */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Physician",
      path: "details.physician",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Stage of cancer",
      path: "details.stageOfCancer",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Recurrence",
      path: "details.recurrence",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Remission",
      path: "details.remission",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Remission date",
      path: "details.remissionDate",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "review" /* Review */,
      shape: "date" /* date */
    },
    {
      label: "Cause of death",
      path: "details.causeOfDeath",
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */,
      shape: "string" /* string */
    },
    {
      label: "Death related to diagnosis",
      path: "details.deathRelatedToDiagnosis",
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */,
      shape: "string" /* string */
    },
    {
      label: "Qualified Finding Source",
      path: "details.qualifiedFindingSource",
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */,
      shape: "string" /* string */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var roundupMedicalHistoryFinding = {
  name: "roundupMedicalHistoryFinding",
  label: "Roundup - Medical history",
  description: "The matrix data for the roundup medical history finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "roundup_medical_history" /* ROUNDUP_MEDICAL_HISTORY */,
  proofType: "general" /* GENERAL */,
  matterType: "Roundup" /* ROUNDUP */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Record date",
      path: "details.recordDate",
      shape: "date" /* date */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
      page: "review" /* Review */
    },
    {
      label: "Physician",
      path: "details.physician",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Treatment types",
      path: "details.treatmentTypes",
      shape: "stringArray" /* stringArray */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "BMI",
      path: "details.bmi",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Other diagnosis",
      path: "details.otherDiagnoses",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Cancer diagnosis",
      path: "details.cancerDiagnoses",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Autoimmune diagnosis",
      path: "details.autoimmuneDisorders",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Diagnosing facility",
      path: "details.diagnosingFacilityId",
      shape: "facility" /* facility */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var roundupFamilyMedicalHistoryFinding = {
  name: "roundupFamilyMedicalHistoryFinding",
  label: "Roundup - Family medical history",
  description: "The matrix data for the roundup family medical history finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "roundup_family_medical_history" /* ROUNDUP_FAMILY_MEDICAL_HISTORY */,
  proofType: "general" /* GENERAL */,
  matterType: "Roundup" /* ROUNDUP */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Record date",
      path: "details.recordDate",
      shape: "date" /* date */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
      page: "review" /* Review */
    },
    {
      label: "Physician",
      path: "details.physician",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Relationship",
      path: "details.relationship",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Diagnosis",
      path: "details.diagnosis",
      shape: "injuries" /* injuries */,
      compatibleFormElementTypes: ["injury" /* INJURY */],
      page: "review" /* Review */
    },
    {
      label: "Deceased?",
      path: "details.isDeceased",
      shape: "boolean" /* boolean */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var roundupTobaccoFinding = {
  name: "roundupTobaccoFinding",
  label: "Roundup - Tobacco use",
  description: "The matrix data for the roundup tobacco use finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "roundup_tobacco_use" /* ROUNDUP_TOBACCO_USE */,
  proofType: "general" /* GENERAL */,
  matterType: "Roundup" /* ROUNDUP */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Tobacco use",
      path: "details.tobaccoUse",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Years smoking",
      path: "details.yearsSmoking",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Record date",
      path: "details.recordDate",
      shape: "date" /* date */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var RoundupFindingContextFieldMapping = {
  roundupFamilyMedicalHistoryFinding,
  roundupMedicalHistoryFinding,
  roundupInjuryFinding,
  roundupTobaccoFinding,
  roundupTreatmentFinding,
  roundupUseFinding
};
var RoundupFindingContextFieldMappings = Object.values(RoundupFindingContextFieldMapping);

// src/ContextMapping/FindingMapping/TalcumPowder.ts
var talcumPowderUseFindingMapping = {
  name: "talcumPowderUseFindingMapping",
  label: "Talcum Powder - Use",
  description: "The matrix data for the talcum powder use finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "prescription_filled" /* PRESCRIPTION_FILLED */,
  proofType: "proof_of_use" /* PROOF_OF_USE */,
  matterType: "Talcum Powder" /* TALCUM_POWDER */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Product",
      path: "details.drugId",
      shape: "drug" /* drug */,
      compatibleFormElementTypes: ["drug" /* DRUG */],
      page: "review" /* Review */
    },
    {
      label: "Frequency of use",
      path: "details.frequencyOfUse",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "First exposure before menopause",
      path: "details.firstExposureBeforeMenopause",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Exposure was for feminine hygiene",
      path: "details.exposureForFeminineHygiene",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var talcumPowderInjuryFindingMapping = {
  name: "talcumPowderInjuryFindingMapping",
  label: "Talcum Powder - Injury",
  description: "The matrix data for the talcum powder injury finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "proof_of_injury" /* PROOF_OF_INJURY */,
  proofType: "proof_of_injury" /* PROOF_OF_INJURY */,
  matterType: "Talcum Powder" /* TALCUM_POWDER */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Physician",
      path: "details.physician",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Diagnosing facility",
      path: "details.diagnosingFacilityId",
      shape: "facility" /* facility */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Injuries",
      path: "details.injuryIds",
      shape: "injuries" /* injuries */,
      compatibleFormElementTypes: ["injury" /* INJURY */],
      page: "review" /* Review */
    },
    {
      label: "Injury subtype",
      path: "details.injurySubType",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Stage of cancer",
      path: "details.stageOfCancer",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */, "singlechoice" /* SINGLECHOICE */],
      page: "review" /* Review */
    },
    {
      label: "Death related to qualifying cancer",
      path: "details.deathRelatedToQualifyingCancer",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["singlechoice" /* SINGLECHOICE */],
      page: "review" /* Review */
    },
    {
      label: "Recurrence",
      path: "details.recurrence",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "BMI",
      path: "details.bmi",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Cause of death",
      path: "details.causeOfDeath",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Qualified finding source",
      path: "details.qualifiedFindingSource",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["singlechoice" /* SINGLECHOICE */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var talcumPowderMedicalHistoryFindingMapping = {
  name: "talcumPowderMedicalHistoryFindingMapping",
  label: "Talcum Powder - Medical history",
  description: "The matrix data for the talcum powder medical history finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "talc_medical_history" /* TALC_MEDICAL_HISTORY */,
  proofType: "general" /* GENERAL */,
  matterType: "Talcum Powder" /* TALCUM_POWDER */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Physician",
      path: "details.physician",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Previous diagnosis",
      path: "details.previousDiagnosis",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "BRCA gene test",
      path: "details.brcaGeneTest",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Diagnosing facility",
      path: "details.diagnosingFacilityId",
      shape: "facility" /* facility */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var talcumPowderMedicalHistoryV2FindingMapping = {
  name: "talcumPowderMedicalHistoryV2FindingMapping",
  label: "Talcum Powder - Medical history (V2)",
  description: "The matrix data for the talcum powder medical history finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "talc_medical_history" /* TALC_MEDICAL_HISTORY */,
  proofType: "general" /* GENERAL */,
  matterType: "Talcum Powder" /* TALCUM_POWDER */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Physician",
      path: "details.physician",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Previous cancer diagnosis",
      path: "details.previousCancerDiagnosis",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Previous non-cancer diagnosis",
      path: "details.previousNonCancerDiagnosis",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "BRCA gene test",
      path: "details.brcaGeneTest",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Diagnosing facility",
      path: "details.diagnosingFacilityId",
      shape: "facility" /* facility */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var talcumPowderFamilyMedicalHistoryFindingMapping = {
  name: "talcumPowderFamilyMedicalHistoryFindingMapping",
  label: "Talcum Powder - Family Medical History",
  description: "The matrix data for the talcum powder family medical history finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "talc_family_medical_history" /* TALC_FAMILY_MEDICAL_HISTORY */,
  proofType: "general" /* GENERAL */,
  matterType: "Talcum Powder" /* TALCUM_POWDER */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Record date",
      path: "details.recordDate",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
      page: "review" /* Review */
    },
    {
      label: "Cancer diagnosis",
      path: "details.cancerDiagnosis",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Relation",
      path: "details.relation",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var talcumPowderTreatmentFindingMapping = {
  name: "talcumPowderTreatmentFindingMapping",
  label: "Talcum Powder - Treatment",
  description: "The matrix data for the talcum powder treatment finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "talc_treatment" /* TALC_TREATMENT */,
  proofType: "general" /* GENERAL */,
  matterType: "Talcum Powder" /* TALCUM_POWDER */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Physician",
      path: "details.physicianName",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Treatment type",
      path: "details.treatmentType",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Surgery type",
      path: "details.surgeryType",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var talcumPowderTobaccoFindingMapping = {
  name: "talcumPowderTobaccoFindingMapping",
  label: "Talcum Powder - Tobacco Use",
  description: "The matrix data for the talcum powder tobacco use finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "tobacco_use" /* TOBACCO_USE */,
  proofType: "general" /* GENERAL */,
  matterType: "Talcum Powder" /* TALCUM_POWDER */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Tobacco use",
      path: "details.tobaccoUse",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Years smoking",
      path: "details.yearsSmoking",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Date range",
      path: "dateRange",
      compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
      page: "events-and-requests" /* EventsAndRequests */,
      shape: "date-range" /* date_range */
    }
  ]
};
var talcumPowderSharedTobaccoUseFindingMapping = {
  name: "talcumPowderSharedTobaccoUseFindingMapping",
  label: "Talcum Powder - Shared Tobacco Use",
  description: "The matrix data for the talcum powder shared tobacco use finding",
  contextGroup: "findings",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "review" /* Review */,
  findingType: "tobacco_use" /* TOBACCO_USE */,
  proofType: "general" /* GENERAL */,
  matterType: "Talcum Powder" /* TALCUM_POWDER */,
  columnOptions: [
    ...baseFindingColumnOptions,
    {
      label: "Years smoking",
      path: "details.yearsSmoking",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Record date",
      path: "details.recordDate",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Smoking status",
      path: "details.smokingStatus",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Smoking volume",
      path: "details.smokingVolume",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Tobacco type",
      path: "details.tobaccoType",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    },
    {
      label: "Smoker at time of diagnosis",
      path: "details.smokerAtTimeOfDiagnosis",
      shape: "string" /* string */,
      compatibleFormElementTypes: ["freetext" /* FREETEXT */],
      page: "review" /* Review */
    }
  ]
};
var TalcumFindingContextFieldMapping = {
  talcumPowderUseFindingMapping,
  talcumPowderInjuryFindingMapping,
  talcumPowderMedicalHistoryFindingMapping,
  talcumPowderMedicalHistoryV2FindingMapping,
  talcumPowderFamilyMedicalHistoryFindingMapping,
  talcumPowderTreatmentFindingMapping,
  talcumPowderTobaccoFindingMapping,
  talcumPowderSharedTobaccoUseFindingMapping
};
var TalcumFindingContextFieldMappings = Object.values(TalcumFindingContextFieldMapping);

// src/ContextMapping/FindingMapping/index.ts
var FindingContextMapping = {
  ...FireFoamFindingContextFieldMapping,
  ...TalcumFindingContextFieldMapping,
  ...ParaquatFindingContextFieldMapping,
  ...RoundupFindingContextFieldMapping
};
var FindingContextFieldMappings = [
  ...FireFoamFindingContextFieldMappings,
  ...ParaquatFindingContextFieldMappings,
  ...RoundupFindingContextFieldMappings,
  ...TalcumFindingContextFieldMappings
];

// src/ContextMapping/FormMappings.ts
var autoAccidentLocation = {
  name: "autoAccidentLocation",
  label: "Auto Accident - Location",
  description: "The location (state) of the auto accident",
  formKey: "liability",
  elementKey: "accident_location",
  contextGroup: "forms",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "form-page" /* FormPage */
};
var FormContextMapping = {
  autoAccidentLocation
};
var FormContextFieldMappings = Object.values(FormContextMapping);

// src/ContextMapping/MedicalEventMappings.ts
var medicalEventColumnOptions = [
  {
    label: "Event type",
    path: "medicalEventTypeName",
    compatibleFormElementTypes: ["freetext" /* FREETEXT */],
    page: "events-and-requests" /* EventsAndRequests */,
    shape: "string" /* string */
  },
  {
    label: "Date range",
    path: "dateRange",
    compatibleFormElementTypes: ["date-to-present" /* DATE_TO_PRESENT */, "freetext" /* FREETEXT */],
    page: "events-and-requests" /* EventsAndRequests */,
    shape: "date-range" /* date_range */
  }
];
var allMedicalEventsMapping = {
  medicalEventTypeName: "All",
  name: "allMedicalEventsMapping",
  label: "Medical events - All",
  description: "The matrix data for all medical events",
  contextGroup: "medical-events",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "events-and-requests" /* EventsAndRequests */,
  columnOptions: [...medicalEventColumnOptions, ...baseEventColumnOptions]
};
var diagnosisMedicalEventMapping = {
  medicalEventTypeName: "Diagnosis",
  name: "diagnosisMedicalEventMapping",
  label: "Medical event - Diagnosis",
  description: "The matrix data for the diagnosis medical event",
  contextGroup: "medical-events",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "events-and-requests" /* EventsAndRequests */,
  columnOptions: [...medicalEventColumnOptions, ...baseEventColumnOptions]
};
var doctorVisitMedicalEventMapping = {
  medicalEventTypeName: "Doctor Visit (PCP/Specialist)",
  name: "doctorVisitMedicalEventMapping",
  label: "Medical event - Doctor visit (PCP/specialist)",
  description: "The matrix data for the doctor visit medical event",
  contextGroup: "medical-events",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "events-and-requests" /* EventsAndRequests */,
  columnOptions: [...medicalEventColumnOptions, ...baseEventColumnOptions]
};
var obgynMedicalEventMapping = {
  medicalEventTypeName: "OB/GYN",
  name: "obgynMedicalEventMapping",
  label: "Medical event - OB/GYN",
  description: "The matrix data for the OB/GYN medical event",
  contextGroup: "medical-events",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "events-and-requests" /* EventsAndRequests */,
  columnOptions: [...medicalEventColumnOptions, ...baseEventColumnOptions]
};
var pharmacyMedicalEventMapping = {
  medicalEventTypeName: "Pharmacy",
  name: "pharmacyMedicalEventMapping",
  label: "Medical event - Pharmacy",
  description: "The matrix data for the pharmacy medical event",
  contextGroup: "medical-events",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "events-and-requests" /* EventsAndRequests */,
  columnOptions: [...medicalEventColumnOptions, ...baseEventColumnOptions]
};
var purchaseMedicalEventMapping = {
  medicalEventTypeName: "Purchase",
  name: "purchaseMedicalEventMapping",
  label: "Medical event - Purchase",
  description: "The matrix data for the purchase medical event",
  contextGroup: "medical-events",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "events-and-requests" /* EventsAndRequests */,
  columnOptions: [...medicalEventColumnOptions, ...baseEventColumnOptions]
};
var treatmentMedicalEventMapping = {
  medicalEventTypeName: "Treatment",
  name: "treatmentMedicalEventMapping",
  label: "Medical event - Treatment",
  description: "The matrix data for the treatment medical event",
  contextGroup: "medical-events",
  shape: "matrix",
  compatibleFormElementTypes: ["matrix" /* MATRIX */],
  page: "events-and-requests" /* EventsAndRequests */,
  columnOptions: [...medicalEventColumnOptions, ...baseEventColumnOptions]
};
var MedicalEventContextMapping = {
  allMedicalEventsMapping,
  diagnosisMedicalEventMapping,
  doctorVisitMedicalEventMapping,
  obgynMedicalEventMapping,
  pharmacyMedicalEventMapping,
  purchaseMedicalEventMapping,
  treatmentMedicalEventMapping
};
var MedicalEventContextMappings = Object.values(MedicalEventContextMapping);

// src/ContextMapping/ScalarContextMapping.ts
var todaysDate = {
  name: "todaysDate",
  label: "Today's date",
  description: "The current date (MM/DD/YYYY)",
  contextGroup: "lead",
  shape: "date" /* date */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantName = {
  name: "claimantName",
  label: "Claimant name",
  description: "The full name of the claimant",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantFirstName = {
  name: "claimantFirstName",
  label: "Claimant first name",
  description: "The first name of the claimant",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantMiddleInitial = {
  name: "claimantMiddleInitial",
  label: "Claimant middle initial",
  description: "The middle initial of the claimant",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantLastName = {
  name: "claimantLastName",
  label: "Claimant last name",
  description: "The last name of the claimant",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var formCompleterName = {
  name: "formCompleterName",
  label: "Form completer name",
  description: "If the claimant's status is 'available', this will be the full name of the claimant. Otherwise, it will be the full name of the first representative",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var formCompleterFirstName = {
  name: "formCompleterFirstName",
  label: "Form completer first name",
  description: "If the claimant's status is 'available', this will be the first name of the claimant. Otherwise, it will be the first name of the first representative",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var formCompleterMiddleInitial = {
  name: "formCompleterMiddleInitial",
  label: "Form completer middle initial",
  description: "If the claimant's status is 'available', this will be the middle initial of the claimant. Otherwise, it will be the middle initial of the first representative",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var formCompleterLastName = {
  name: "formCompleterLastName",
  label: "Form completer last name",
  description: "If the claimant's status is 'available', this will be the last name of the claimant. Otherwise, it will be the last name of the first representative",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantGender = {
  name: "claimantGender",
  label: "Claimant gender",
  description: "The claimant's gender",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantIsFemale = {
  name: "claimantIsFemale",
  label: "Claimant is female",
  description: "'True' or 'False' based on if the claimant's gender is 'female'",
  contextGroup: "lead",
  shape: "boolean" /* boolean */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantIsMale = {
  name: "claimantIsMale",
  label: "Claimant is male",
  description: "'True' or 'False' based on if the claimant's gender is 'male'",
  contextGroup: "lead",
  shape: "boolean" /* boolean */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var leadOwner = {
  name: "leadOwner",
  label: "Lead owner",
  description: "The full name of the owner of the lead",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantMaidenName = {
  name: "claimantMaidenName",
  label: "Claimant maiden name",
  description: "The maiden name of the claimant",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantMaritalStatus = {
  name: "claimantMaritalStatus",
  label: "Claimant marital status",
  description: "The marital status of the claimant",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantIsMarried = {
  name: "claimantIsMarried",
  label: "Claimant is married",
  description: "'Yes' or 'No' based on if the claimant's marital status is 'married'",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantPrimaryAddress = {
  name: "claimantPrimaryAddress",
  label: "Claimant primary address",
  description: "The primary address of the claimant",
  contextGroup: "lead",
  shape: "address" /* address */,
  compatibleFormElementTypes: ["address" /* ADDRESS */, "freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var repName = {
  name: "repName",
  label: "Representative name",
  description: "The full name of the claimant's representative",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var repRelation = {
  name: "repRelation",
  label: "Representative relation",
  description: "The claimant's relation to the representative",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantSpouseName = {
  name: "claimantSpouseName",
  label: "Claimant spouse name",
  description: "If the claimant's marital status is 'married', this will be the full name of the claimant's spouse which is sourced from either the representatives or the contacts",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantSsn = {
  name: "claimantSsn",
  label: "Claimant SSN",
  description: "The claimant's social security number formatted as XXX-XX-XXXX",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantDob = {
  name: "claimantDob",
  label: "Claimant DOB",
  description: "The claimant's date of birth (MM/DD/YYYY)",
  contextGroup: "lead",
  shape: "date" /* date */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantMonthOfBirth = {
  name: "claimantMonthOfBirth",
  label: "Claimant month of birth",
  description: "The claimant's month of birth (MM)",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantDayOfBirth = {
  name: "claimantDayOfBirth",
  label: "Claimant day of birth",
  description: "The claimant's day of birth (DD)",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantYearOfBirth = {
  name: "claimantYearOfBirth",
  label: "Claimant year of birth",
  description: "The claimant's year of birth (YYYY)",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantDod = {
  name: "claimantDod",
  label: "Claimant DOD",
  contextGroup: "lead",
  description: "The claimant's date of death (MM/DD/YYYY)",
  shape: "date" /* date */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantDodNotApplicable = {
  name: "claimantDodNotApplicable",
  label: "Claimant DOD not applicable",
  description: "'True' or 'False' the claimant's status is 'deceased'",
  contextGroup: "lead",
  shape: "boolean" /* boolean */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantEmploymentStatus = {
  name: "claimantEmploymentStatus",
  label: "Claimant employment status",
  description: "The claimant's employment status",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantOccupation = {
  name: "claimantOccupation",
  label: "Claimant occupation",
  description: "The claimant's occupation",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantIsEmployed = {
  name: "claimantIsEmployed",
  label: "Is claimant employed",
  description: "'Yes' or 'No' the claimant is employed",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var claimantCurrentEmployerAndPosition = {
  name: "claimantCurrentEmployerAndPosition",
  label: "Claimant employer and position",
  description: "The claimant's current employer and position from the employment history",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var dateOfAccident = {
  name: "dateOfAccident",
  label: "Date of accident",
  description: "The date of the accident (MM/DD/YYYY)",
  contextGroup: "lead",
  shape: "date" /* date */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */, "date" /* DATE */],
  page: "claimant-information" /* ClaimantInformation */
};
var accidentLocation = {
  name: "accidentLocation",
  label: "Location of accident",
  description: "The location of the accident",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var atFaultPartyName = {
  name: "atFaultPartyName",
  label: "At fault party name",
  description: "The  name of the person at fault, sourced from the contacts where the relationship is 'at fault party'",
  contextGroup: "lead",
  shape: "string" /* string */,
  compatibleFormElementTypes: ["freetext" /* FREETEXT */],
  page: "claimant-information" /* ClaimantInformation */
};
var ScalarContextFieldMapping = {
  accidentLocation,
  atFaultPartyName,
  claimantCurrentEmployerAndPosition,
  claimantDayOfBirth,
  claimantDob,
  claimantDod,
  claimantDodNotApplicable,
  claimantEmploymentStatus,
  claimantFirstName,
  claimantGender,
  claimantIsEmployed,
  claimantIsFemale,
  claimantIsMale,
  claimantIsMarried,
  claimantLastName,
  claimantMaidenName,
  claimantMaritalStatus,
  claimantMiddleInitial,
  claimantMonthOfBirth,
  claimantName,
  claimantOccupation,
  claimantPrimaryAddress,
  claimantSpouseName,
  claimantSsn,
  claimantYearOfBirth,
  dateOfAccident,
  formCompleterFirstName,
  formCompleterLastName,
  formCompleterMiddleInitial,
  formCompleterName,
  leadOwner,
  repName,
  repRelation,
  todaysDate
};
var ScalarContextFieldMappings = Object.values(ScalarContextFieldMapping);

// src/ContextMapping/FindingContextFieldMapping.ts
var FindingContextFieldMapping = class extends ContextFieldMapping {
};

// src/ContextMapping/MatrixColumnOption.ts
var MatrixColumnOption = class {
};

// src/ContextMapping/FormContextFieldMapping.ts
var FormContextFieldMapping = class extends ContextFieldMapping {
};

// src/ContextMapping/MedicalEventContextFieldMapping.ts
var MedicalEventContextFieldMapping = class extends ContextFieldMapping {
};

// src/ContextMapping/index.ts
var ContextMapping = {
  ...ScalarContextFieldMapping,
  ...FindingContextMapping,
  ...MedicalEventContextMapping,
  ...FormContextMapping
};
var ContextFieldMappings = [
  ...FindingContextFieldMappings,
  ...FormContextFieldMappings,
  ...MedicalEventContextMappings,
  ...ScalarContextFieldMappings
].sort((a, b) => a.label.localeCompare(b.label));

// src/DemandLetter/index.ts
var DemandLetterSectionType = /* @__PURE__ */ ((DemandLetterSectionType2) => {
  DemandLetterSectionType2["HEADER"] = "header";
  DemandLetterSectionType2["LIABILITY"] = "liability";
  DemandLetterSectionType2["VEHICLE_DAMAGES"] = "vehicle-damages";
  DemandLetterSectionType2["LIFE_IMPACT"] = "life-impact";
  DemandLetterSectionType2["TREATMENT_SUMMARY"] = "treatment-summary";
  DemandLetterSectionType2["MEDICAL_BILLS"] = "medical-bills";
  DemandLetterSectionType2["CLOSING_PARAGRAPH"] = "closing-paragraph";
  return DemandLetterSectionType2;
})(DemandLetterSectionType || {});

// src/DiscoveryDocument/index.ts
var DiscoveryDocumentDetailDocumentType = /* @__PURE__ */ ((DiscoveryDocumentDetailDocumentType2) => {
  DiscoveryDocumentDetailDocumentType2["BELLWETHER_FORM"] = "Bellwether Form";
  DiscoveryDocumentDetailDocumentType2["CENSUS_FORM"] = "Census Form";
  DiscoveryDocumentDetailDocumentType2["CLAIMS_FORM"] = "Claims Form";
  DiscoveryDocumentDetailDocumentType2["DAMAGES_QUESTIONNAIRE"] = "Damages Questionnaire";
  DiscoveryDocumentDetailDocumentType2["PLAINTIFF_ASSESSMENT_QUESTIONNAIRE"] = "Plaintiff Assessment Questionnaire (PAQ)";
  DiscoveryDocumentDetailDocumentType2["PLAINTIFF_FACT_SHEET"] = "Plaintiff Fact Sheet";
  DiscoveryDocumentDetailDocumentType2["PLAINTIFF_INFORMATION_SHEET"] = "Plaintiff Information Sheet";
  DiscoveryDocumentDetailDocumentType2["PLAINTIFF_PROFILE_FORM"] = "Plaintiff Profile Form";
  DiscoveryDocumentDetailDocumentType2["TOG_PLAINTIFF_FACT_SHEET"] = "TOG Plaintiff Fact Sheet";
  return DiscoveryDocumentDetailDocumentType2;
})(DiscoveryDocumentDetailDocumentType || {});
var DISCOVERY_DOCUMENT_DETAIL_DOCUMENT_TYPES = Object.values(
  DiscoveryDocumentDetailDocumentType
);
var DiscoveryDocumentDetailDocumentStatus = /* @__PURE__ */ ((DiscoveryDocumentDetailDocumentStatus2) => {
  DiscoveryDocumentDetailDocumentStatus2["AWAITING_SIGNATURES"] = "Awaiting Signatures";
  DiscoveryDocumentDetailDocumentStatus2["COMPLETED_BY_LAW_FIRM"] = "Completed by Law Firm";
  DiscoveryDocumentDetailDocumentStatus2["ESCALATED_TO_LAW_FIRM"] = "Escalated to Law Firm";
  DiscoveryDocumentDetailDocumentStatus2["FINAL_QC"] = "Final QC";
  DiscoveryDocumentDetailDocumentStatus2["FOLLOW_UP_QC"] = "Follow-up QC";
  DiscoveryDocumentDetailDocumentStatus2["IN_PROGRESS"] = "In Progress";
  DiscoveryDocumentDetailDocumentStatus2["INTERNAL_REVISIONS_NEEDED"] = "Internal - Revisions Needed";
  DiscoveryDocumentDetailDocumentStatus2["LAW_FIRM_REVISIONS_NEEDED"] = "Law Firm - Revisions Needed";
  DiscoveryDocumentDetailDocumentStatus2["LAW_FIRM_REVIEW"] = "Law Firm Review";
  DiscoveryDocumentDetailDocumentStatus2["NEED_ADDITIONAL_RECORDS"] = "Need Additional Records";
  DiscoveryDocumentDetailDocumentStatus2["NEEDED"] = "Needed";
  DiscoveryDocumentDetailDocumentStatus2["NO_DISCOVERY_DOC_ORDER"] = "No Discovery Doc Order";
  DiscoveryDocumentDetailDocumentStatus2["NO_DISCOVERY_DOC_REQUIRED"] = "No discovery doc required by law firm";
  DiscoveryDocumentDetailDocumentStatus2["READY_FOR_QC"] = "Ready for QC";
  DiscoveryDocumentDetailDocumentStatus2["READY_FOR_SIGNATURE"] = "Ready for Signature";
  DiscoveryDocumentDetailDocumentStatus2["READY_TO_PRODUCE"] = "Ready to Produce";
  DiscoveryDocumentDetailDocumentStatus2["SUBMITTED_TO_LAW_FIRM"] = "Submitted to Law Firm";
  DiscoveryDocumentDetailDocumentStatus2["SUPPLEMENT_NEEDED"] = "Supplement Needed";
  DiscoveryDocumentDetailDocumentStatus2["SUPPLEMENT_SUBMITTED"] = "Supplement Submitted";
  DiscoveryDocumentDetailDocumentStatus2["UNRESPONSIVE"] = "Unresponsive";
  return DiscoveryDocumentDetailDocumentStatus2;
})(DiscoveryDocumentDetailDocumentStatus || {});
var DISCOVERY_DOCUMENT_DETAIL_DOCUMENT_STATUSES = Object.values(
  DiscoveryDocumentDetailDocumentStatus
);

// src/DockitUsers/index.ts
var DockitUserType = /* @__PURE__ */ ((DockitUserType2) => {
  DockitUserType2["TORTICITY"] = "torticity";
  DockitUserType2["LAW_FIRM"] = "law_firm";
  return DockitUserType2;
})(DockitUserType || {});

// src/Directories/index.ts
var WILDFIRE_DIRECTORY_PATHS = [
  "Admin/Intake",
  "Admin/Engagement Letters",
  "Admin/Client Meeting Notes",
  "Correspondence",
  "Discovery/Fact Discovery",
  "Discovery/Expert Discovery",
  "Evidence/Alternative Living Expenses",
  "Evidence/Drone Imaging",
  "Evidence/Photo and Video from Client",
  "Evidence/Proof of Ownership",
  "Evidence/Emotional Distress",
  "Evidence/Household Inventory",
  "Evidence/Insurance",
  "Evidence/Interviews",
  "Evidence/Medical Records",
  "Docket/Draft Short Form Complaint",
  "Mediation"
];
var DirectoryPaths = {
  ["Wildfire" /* WILDFIRE */]: WILDFIRE_DIRECTORY_PATHS
};

// src/DocumentRequests/index.ts
var DocumentRequestRejectedReason = /* @__PURE__ */ ((DocumentRequestRejectedReason2) => {
  DocumentRequestRejectedReason2["ALTERED_AUTHORIZATION"] = "altered_authorization";
  DocumentRequestRejectedReason2["CANNOT_VERIFY_SIGNATURE"] = "cannot_verify_signature";
  DocumentRequestRejectedReason2["CERTIFICATE_OF_NO_RECORDS"] = "certificate_of_no_records";
  DocumentRequestRejectedReason2["CLAIMANT_ALTERNATE_NAMES"] = "claimant_alternate_names";
  DocumentRequestRejectedReason2["CLARIFY_CLAIMANT_ADDRESS"] = "clarify_claimant_address";
  DocumentRequestRejectedReason2["CLIENT_DENIED_REQUEST"] = "client_denied_request";
  DocumentRequestRejectedReason2["CUSTOM_HIPAA_REQUIRED"] = "custom_hipaa_required";
  DocumentRequestRejectedReason2["DATE_OF_SIGNATURE"] = "date_of_signature";
  DocumentRequestRejectedReason2["DATE_RANGE_OF_REQUEST"] = "date_range_of_request";
  DocumentRequestRejectedReason2["ESIGNATURE_REJECTION"] = "e-signature_rejection";
  DocumentRequestRejectedReason2["EXPIRED_AUTHORIZATION"] = "expired_authorization";
  DocumentRequestRejectedReason2["FACILITY_NONRESPONSIVE"] = "facility_non-responsive";
  DocumentRequestRejectedReason2["FACILITY_SHUTDOWN"] = "facility_shutdown";
  DocumentRequestRejectedReason2["HITECH_REJECTION"] = "hitech_rejection";
  DocumentRequestRejectedReason2["ILLEGIBLE_AUTHORIZATION"] = "illegible_authorization";
  DocumentRequestRejectedReason2["ILLEGIBLE_DEATH_CERTIFICATE"] = "illegible_death_certificate";
  DocumentRequestRejectedReason2["MISSING_AUTHORIZATION"] = "missing_authorization";
  DocumentRequestRejectedReason2["MISSING_MIDDLE_INITIAL"] = "missing_middle_initial";
  DocumentRequestRejectedReason2["NRR_REJECTED"] = "nrr_rejected";
  DocumentRequestRejectedReason2["OTHER"] = "other";
  DocumentRequestRejectedReason2["PHOTO_ID_NEEDED"] = "photo_id_needed";
  DocumentRequestRejectedReason2["POA_DOCUMENTATION_REQUIRED"] = "poa_documentation_required";
  DocumentRequestRejectedReason2["PROVIDER_NOT_IDENTIFIED"] = "provider_not_identified";
  DocumentRequestRejectedReason2["RECORDS_EXCEED_RETENTION_POLICY"] = "records_exceed_retention_policy";
  DocumentRequestRejectedReason2["RECORDS_PURGED"] = "records_purged";
  DocumentRequestRejectedReason2["REPRESENTATIVE_DOCUMENT_NEEDED"] = "representative_document_needed";
  DocumentRequestRejectedReason2["REPRODUCTIVE_HEALTH_ATTESTATION_NEEDED"] = "reproductive_health_attestation_needed";
  DocumentRequestRejectedReason2["UNABLE_TO_FIND_RECORDS_WITH_INFORMATION_PROVIDED"] = "unable_to_find_records_with_information_provided";
  DocumentRequestRejectedReason2["UNABLE_TO_LOCATE_CHART_WITH_DEMOGRAPHICS_PROVIDED"] = "unable_to_locate_chart_with_demographics_provided";
  DocumentRequestRejectedReason2["UNACCEPTABLE_TRANSMISSION_METHOD"] = "unacceptable_transmission_method";
  DocumentRequestRejectedReason2["WRONG_FACILITY"] = "wrong_facility";
  return DocumentRequestRejectedReason2;
})(DocumentRequestRejectedReason || {});
var DocumentRequestStatus = /* @__PURE__ */ ((DocumentRequestStatus2) => {
  DocumentRequestStatus2["CLOSED"] = "closed";
  DocumentRequestStatus2["ESCALATED"] = "escalated";
  DocumentRequestStatus2["FACILITY_PROCESSING"] = "facility_processing";
  DocumentRequestStatus2["FACILITY_REQUIRES_AN_EXTENSION"] = "facility_requires_an_extension";
  DocumentRequestStatus2["FAILED"] = "failed";
  DocumentRequestStatus2["IN_PROGRESS"] = "in_progress";
  DocumentRequestStatus2["INVOICE_PAID_FOR_RECORDS"] = "invoice_paid_for_records";
  DocumentRequestStatus2["NOT_SENT"] = "not_sent";
  DocumentRequestStatus2["OUTREACH"] = "outreach";
  DocumentRequestStatus2["PARTIAL_RECORDS_RECEIVED"] = "partial_records_received";
  DocumentRequestStatus2["PENDING_PRE_PAYMENT"] = "pending_pre_payment";
  DocumentRequestStatus2["PENDING_RESEND"] = "pending_resend";
  DocumentRequestStatus2["PROCESSING"] = "processing";
  DocumentRequestStatus2["RECEIVED"] = "received";
  DocumentRequestStatus2["RECEIVED_CERTIFICATION_NEEDED"] = "received_certification_needed";
  DocumentRequestStatus2["REDUCED_SCOPE_NEEDED"] = "reduced_scope_needed";
  DocumentRequestStatus2["REJECTED"] = "rejected";
  DocumentRequestStatus2["REJECTION_IN_PROGRESS"] = "rejection_in_progress";
  DocumentRequestStatus2["RESEARCH"] = "research";
  DocumentRequestStatus2["TO_BE_REQUESTED"] = "to_be_requested";
  return DocumentRequestStatus2;
})(DocumentRequestStatus || {});
var NON_CANCELABLE_DOCUMENT_REQUEST_STATUSES = [
  "invoice_paid_for_records" /* INVOICE_PAID_FOR_RECORDS */,
  "received" /* RECEIVED */,
  "closed" /* CLOSED */
];
var DocumentRequestRejectedReasonMap = {
  ["altered_authorization" /* ALTERED_AUTHORIZATION */]: "Altered authorization",
  ["cannot_verify_signature" /* CANNOT_VERIFY_SIGNATURE */]: "Cannot verify signature",
  ["certificate_of_no_records" /* CERTIFICATE_OF_NO_RECORDS */]: "Certificate of no records",
  ["claimant_alternate_names" /* CLAIMANT_ALTERNATE_NAMES */]: "Claimant alternate name(s)",
  ["clarify_claimant_address" /* CLARIFY_CLAIMANT_ADDRESS */]: "Clarify claimant address",
  ["client_denied_request" /* CLIENT_DENIED_REQUEST */]: "Client denied request",
  ["custom_hipaa_required" /* CUSTOM_HIPAA_REQUIRED */]: "Custom HIPAA required",
  ["date_of_signature" /* DATE_OF_SIGNATURE */]: "Date of signature",
  ["date_range_of_request" /* DATE_RANGE_OF_REQUEST */]: "Date range of request",
  ["e-signature_rejection" /* ESIGNATURE_REJECTION */]: "E-signature rejection",
  ["expired_authorization" /* EXPIRED_AUTHORIZATION */]: "Expired authorization",
  ["facility_non-responsive" /* FACILITY_NONRESPONSIVE */]: "Facility non-responsive",
  ["facility_shutdown" /* FACILITY_SHUTDOWN */]: "Facility shutdown",
  ["hitech_rejection" /* HITECH_REJECTION */]: "HITECH rejection",
  ["illegible_authorization" /* ILLEGIBLE_AUTHORIZATION */]: "Illegible authorization",
  ["illegible_death_certificate" /* ILLEGIBLE_DEATH_CERTIFICATE */]: "Illegible death certificate",
  ["missing_authorization" /* MISSING_AUTHORIZATION */]: "Missing authorization",
  ["missing_middle_initial" /* MISSING_MIDDLE_INITIAL */]: "Missing middle initial",
  ["nrr_rejected" /* NRR_REJECTED */]: "NRR rejected",
  ["other" /* OTHER */]: "Other",
  ["photo_id_needed" /* PHOTO_ID_NEEDED */]: "Photo ID needed",
  ["poa_documentation_required" /* POA_DOCUMENTATION_REQUIRED */]: "POA documentation required",
  ["provider_not_identified" /* PROVIDER_NOT_IDENTIFIED */]: "Provider not identified",
  ["records_exceed_retention_policy" /* RECORDS_EXCEED_RETENTION_POLICY */]: "Records exceed retention policy",
  ["records_purged" /* RECORDS_PURGED */]: "Records purged",
  ["representative_document_needed" /* REPRESENTATIVE_DOCUMENT_NEEDED */]: "Representative document needed",
  ["reproductive_health_attestation_needed" /* REPRODUCTIVE_HEALTH_ATTESTATION_NEEDED */]: "Reproductive health attestation needed",
  ["unable_to_find_records_with_information_provided" /* UNABLE_TO_FIND_RECORDS_WITH_INFORMATION_PROVIDED */]: "Unable to find records with information provided",
  ["unable_to_locate_chart_with_demographics_provided" /* UNABLE_TO_LOCATE_CHART_WITH_DEMOGRAPHICS_PROVIDED */]: "Unable to locate chart with demographics provided",
  ["unacceptable_transmission_method" /* UNACCEPTABLE_TRANSMISSION_METHOD */]: "Unacceptable transmission method",
  ["wrong_facility" /* WRONG_FACILITY */]: "Wrong facility"
};
var ASSIGN_TO_LEAD_OWNER_REASONS = [
  "altered_authorization" /* ALTERED_AUTHORIZATION */,
  "cannot_verify_signature" /* CANNOT_VERIFY_SIGNATURE */,
  "claimant_alternate_names" /* CLAIMANT_ALTERNATE_NAMES */,
  "clarify_claimant_address" /* CLARIFY_CLAIMANT_ADDRESS */,
  "client_denied_request" /* CLIENT_DENIED_REQUEST */,
  "certificate_of_no_records" /* CERTIFICATE_OF_NO_RECORDS */,
  "date_of_signature" /* DATE_OF_SIGNATURE */,
  "date_range_of_request" /* DATE_RANGE_OF_REQUEST */,
  "e-signature_rejection" /* ESIGNATURE_REJECTION */,
  "expired_authorization" /* EXPIRED_AUTHORIZATION */,
  "facility_non-responsive" /* FACILITY_NONRESPONSIVE */,
  "facility_shutdown" /* FACILITY_SHUTDOWN */,
  "illegible_death_certificate" /* ILLEGIBLE_DEATH_CERTIFICATE */,
  "illegible_authorization" /* ILLEGIBLE_AUTHORIZATION */,
  "missing_authorization" /* MISSING_AUTHORIZATION */,
  "missing_middle_initial" /* MISSING_MIDDLE_INITIAL */,
  "other" /* OTHER */,
  "photo_id_needed" /* PHOTO_ID_NEEDED */,
  "provider_not_identified" /* PROVIDER_NOT_IDENTIFIED */,
  "records_exceed_retention_policy" /* RECORDS_EXCEED_RETENTION_POLICY */,
  "records_purged" /* RECORDS_PURGED */,
  "unable_to_find_records_with_information_provided" /* UNABLE_TO_FIND_RECORDS_WITH_INFORMATION_PROVIDED */,
  "unable_to_locate_chart_with_demographics_provided" /* UNABLE_TO_LOCATE_CHART_WITH_DEMOGRAPHICS_PROVIDED */,
  "wrong_facility" /* WRONG_FACILITY */
];
var ASSIGN_TO_FACILITY_OWNER_REASONS = [
  "custom_hipaa_required" /* CUSTOM_HIPAA_REQUIRED */,
  "hitech_rejection" /* HITECH_REJECTION */,
  "reproductive_health_attestation_needed" /* REPRODUCTIVE_HEALTH_ATTESTATION_NEEDED */,
  "unacceptable_transmission_method" /* UNACCEPTABLE_TRANSMISSION_METHOD */
];
var ASSIGN_TO_REP_DOC_TEAM_OWNER_REASONS = [
  "poa_documentation_required" /* POA_DOCUMENTATION_REQUIRED */,
  "representative_document_needed" /* REPRESENTATIVE_DOCUMENT_NEEDED */
];
var DocumentRequestRecordType = /* @__PURE__ */ ((DocumentRequestRecordType2) => {
  DocumentRequestRecordType2["BILLING"] = "billing";
  DocumentRequestRecordType2["MEDICAL"] = "medical";
  return DocumentRequestRecordType2;
})(DocumentRequestRecordType || {});
var DocumentRequestType = /* @__PURE__ */ ((DocumentRequestType2) => {
  DocumentRequestType2["HIPAA"] = "hipaa";
  DocumentRequestType2["HITECH"] = "hitech";
  DocumentRequestType2["HITECH_V2"] = "hitech v2";
  DocumentRequestType2["TORTICITY_HIPAA"] = "torticity hipaa";
  DocumentRequestType2["TORTICITY_HIPAA_BILLING"] = "torticity hipaa billing";
  DocumentRequestType2["TORTICITY_HIPAA_COMBINED"] = "torticity hipaa combined";
  DocumentRequestType2["TORTICITY_HIPAA_MULTI_SIGNATURE"] = "torticity hipaa multi signature";
  return DocumentRequestType2;
})(DocumentRequestType || {});
var DocumentRequestMethod = /* @__PURE__ */ ((DocumentRequestMethod2) => {
  DocumentRequestMethod2["MAIL"] = "mail";
  DocumentRequestMethod2["EMAIL"] = "email";
  DocumentRequestMethod2["FAX"] = "fax";
  DocumentRequestMethod2["COPY_SERVICE"] = "copy_service";
  DocumentRequestMethod2["THIRD_PARTY"] = "third_party";
  return DocumentRequestMethod2;
})(DocumentRequestMethod || {});
var DocumentRequestClosedReason = /* @__PURE__ */ ((DocumentRequestClosedReason2) => {
  DocumentRequestClosedReason2["RECORDS_NOT_NEEDED"] = "records_not_needed";
  DocumentRequestClosedReason2["REJECTED"] = "rejected";
  DocumentRequestClosedReason2["DUPLICATE"] = "duplicate";
  DocumentRequestClosedReason2["FACILITY_SHUTDOWN"] = "facility_shutdown";
  DocumentRequestClosedReason2["CLAIMANT_OPTED_OUT"] = "claimant_opted_out";
  DocumentRequestClosedReason2["CLAIMANT_UNREACHABLE"] = "claimant_unreachable";
  DocumentRequestClosedReason2["LEAD_CANCELED"] = "lead_canceled";
  DocumentRequestClosedReason2["FACILITY_NON_RESPONSIVE"] = "facility_non_responsive";
  DocumentRequestClosedReason2["WRONG_FACILITY"] = "wrong_facility";
  DocumentRequestClosedReason2["NRR_CLOSED"] = "nrr_closed";
  DocumentRequestClosedReason2["NRR_RECEIVED"] = "nrr_received";
  DocumentRequestClosedReason2["CASE_PROVEN_RECORDS_NOT_NEEDED"] = "case_proven_records_not_needed";
  return DocumentRequestClosedReason2;
})(DocumentRequestClosedReason || {});

// src/DocxTemplate/index.ts
var DocxTemplateType = /* @__PURE__ */ ((DocxTemplateType2) => {
  DocxTemplateType2["BI_LOR"] = "BI LOR";
  DocxTemplateType2["UM_UIM_LOR"] = "UM/UIM LOR";
  DocxTemplateType2["LOP"] = "LOP";
  DocxTemplateType2["DEMAND_LETTER"] = "Demand Letter";
  DocxTemplateType2["FOIA"] = "FOIA";
  DocxTemplateType2["TA_LETTER"] = "TA Letter";
  return DocxTemplateType2;
})(DocxTemplateType || {});

// src/Entity.enum.ts
var Entity = /* @__PURE__ */ ((Entity2) => {
  Entity2["ACTION_REQUESTS"] = "action-requests";
  Entity2["ACTIVITY"] = "activity";
  Entity2["ADDRESSES"] = "addresses";
  Entity2["ANSWERS"] = "answers";
  Entity2["API_USERS"] = "api-users";
  Entity2["BRIEF_USER_INVITES"] = "brief-user-invites";
  Entity2["CAMPAIGN_FINDING_INJURIES"] = "campaign-finding-injuries";
  Entity2["CALENDLY_EVENTS"] = "calendly-events";
  Entity2["CAMPAIGN_TARGETS"] = "campaign-targets";
  Entity2["CAMPAIGNS"] = "campaigns";
  Entity2["CASE_SOURCES"] = "case-sources";
  Entity2["CLAIMANT_ADDRESSES"] = "claimant-addresses";
  Entity2["CLAIMANT_CONTACT_TEMPLATES"] = "claimant-contact-templates";
  Entity2["CLAIMANT_CONTACTS"] = "claimant-contacts";
  Entity2["CLAIMANT_EMAIL_ADDRESSES"] = "claimant-email-addresses";
  Entity2["CLAIMANT_PHONE_NUMBERS"] = "claimant-phone-numbers";
  Entity2["CLAIMANT_PORTAL_INVITES"] = "claimant-portal-invites";
  Entity2["CLAIMANT_PORTAL_USERS"] = "claimant-portal-users";
  Entity2["CLAIMANT_REPRESENTATIVES"] = "claimant-representatives";
  Entity2["CLAIMANTS"] = "claimants";
  Entity2["CLAIMS"] = "claims";
  Entity2["CONTACTS"] = "contacts";
  Entity2["CONVERSATIONS"] = "conversations";
  Entity2["COPY_SERVICES"] = "copy-services";
  Entity2["CRM_CREDENTIALS"] = "crm-credentials";
  Entity2["CRM_INTEGRATIONS"] = "crm-integrations";
  Entity2["DEVICES"] = "devices";
  Entity2["DOCUMENT_REQUEST_INVOICES"] = "document-request-invoices";
  Entity2["DOCUMENT_REQUESTS"] = "document-requests";
  Entity2["DOCUMENT_SEND"] = "document-send";
  Entity2["DOCUMENTS"] = "documents";
  Entity2["DRUGS"] = "drugs";
  Entity2["EMAIL_ADDRESSES"] = "email-addresses";
  Entity2["EMPLOYMENT_HISTORY"] = "employment-history";
  Entity2["FINDING_TYPES"] = "finding-types";
  Entity2["FINDINGS"] = "findings";
  Entity2["FORM_PAGES"] = "form-pages";
  Entity2["FORMS"] = "forms";
  Entity2["INJURIES"] = "injuries";
  Entity2["INSURANCE_POLICIES"] = "insurance-policies";
  Entity2["INVOICE_PAYMENTS"] = "invoice-payments";
  Entity2["INVOICES"] = "invoices";
  Entity2["JOB_TASKS"] = "job-tasks";
  Entity2["JOBS"] = "jobs";
  Entity2["KEY_PHRASES"] = "key-phrases";
  Entity2["LAW_FIRM_TRANSMISSION"] = "law-firm-transmission";
  Entity2["LAW_FIRM_TRANSMISSIONS"] = "law-firm-transmissions";
  Entity2["LAW_FIRMS"] = "law-firms";
  Entity2["LEAD_CASE_PAYOUT"] = "lead-case-payout";
  Entity2["LEAD_FORMS"] = "lead-forms";
  Entity2["LEAD_GROUPS"] = "lead-groups";
  Entity2["LEAD_LIEN_SUMMARY"] = "lead-lien-summary";
  Entity2["LEAD_LISTS"] = "lead-lists";
  Entity2["LEAD_SUMMARY"] = "lead-summary";
  Entity2["LEAD_TASK_EVENTS"] = "lead-task-events";
  Entity2["LEAD_TASKS"] = "lead-tasks";
  Entity2["LEADS"] = "leads";
  Entity2["LEADS_CHECKS"] = "lead-checks";
  Entity2["MAIL_DOCUMENT"] = "mail-document";
  Entity2["MANUFACTURERS"] = "manufacturers";
  Entity2["MATTER_TYPES"] = "matter-types";
  Entity2["MEDICAL_BILLS"] = "medical-bills";
  Entity2["MEDICAL_EVENT_TYPES"] = "medical-event-types";
  Entity2["MEDICAL_EVENTS"] = "medical-events";
  Entity2["MEDICAL_EVENTS_RETRIEVAL_CHECK"] = "medical-events-retrieval-check";
  Entity2["MEDICAL_FACILITIES"] = "medical-facilities";
  Entity2["MEDICAL_FACILITIES_NEEDING_ATTENTION"] = "medical-facilities-needing-attention";
  Entity2["MILESTONES"] = "milestones";
  Entity2["NEGOTIATION_EVENTS"] = "negotiation-events";
  Entity2["NEGOTIATIONS"] = "negotiations";
  Entity2["NEXT_ACTIONS"] = "next-actions";
  Entity2["NOTARIZATIONS"] = "notarizations";
  Entity2["OBJECTIVES"] = "objectives";
  Entity2["ORGANIZATIONS"] = "organizations";
  Entity2["PERSONS"] = "persons";
  Entity2["PHONE_NUMBERS"] = "phone-numbers";
  Entity2["QUESTION_SETS"] = "question-sets";
  Entity2["REVIEWS"] = "reviews";
  Entity2["SIGNATURE_REQUESTS"] = "signature-requests";
  Entity2["SIGNNOW_DOCUMENTS"] = "signnow-documents";
  Entity2["STRIPE_TRANSACTIONS"] = "stripe-transactions";
  Entity2["SUB_STATUSES"] = "sub-statuses";
  Entity2["TASK_BLOCKER_EVENTS"] = "task-blocker-events";
  Entity2["TASK_BLOCKERS"] = "task-blockers";
  Entity2["TASKS"] = "tasks";
  Entity2["TEAMS"] = "teams";
  Entity2["USERS"] = "users";
  return Entity2;
})(Entity || {});

// src/Finance/index.ts
var RateType = /* @__PURE__ */ ((RateType2) => {
  RateType2["INGESTION"] = "ingestion";
  RateType2["VERIFICATION"] = "verification";
  RateType2["TORTICITY_SETTLEMENT"] = "torticity-settlement";
  RateType2["LAW_FIRM_SETTLEMENT"] = "law-firm-settlement";
  RateType2["LIEN_RESOLUTION"] = "lien-resolution";
  RateType2["SOW_SETUP"] = "sow-setup";
  RateType2["PROVEN_CASE"] = "proven-case";
  RateType2["PROVEN_CASE_TIMELINE"] = "proven-case-timeline";
  RateType2["PROVEN_CASE_DECEASED"] = "proven-case-deceased";
  RateType2["STALE_CASE"] = "stale-case";
  RateType2["DISCOVERY_DOCUMENT"] = "discovery-document";
  RateType2["RECORD_RETRIEVAL"] = "record-retrieval";
  RateType2["RECORD_REVIEW_SUMMARY"] = "record-review-summary";
  RateType2["DECEASED_INCAPACITATED"] = "deceased-incapacitated";
  RateType2["PROVEN_TIER"] = "proven-tier";
  RateType2["POSTAL_MAIL"] = "postal-mail";
  RateType2["PHAXIO"] = "phaxio";
  RateType2["NOTARIZATION"] = "notarization";
  RateType2["DOCUMENT_REQUEST_INVOICE"] = "document-request-invoice";
  RateType2["CASE_CREATION_MILESTONE"] = "case-creation-milestone";
  RateType2["INTAKE_COMPLETION_MILESTONE"] = "intake-completion-milestone";
  RateType2["RETRIEVAL_IN_PROGRESS_MILESTONE"] = "retrieval-in-progress-milestone";
  RateType2["MEDICAL_RECORDS_RECEIVED_MILESTONE"] = "medical-records-received-milestone";
  RateType2["MEDICAL_REVIEW_IN_PROGRESS_MILESTONE"] = "medical-review-in-progress-milestone";
  RateType2["POI_CONFIRMED_MILESTONE"] = "poi-confirmed-milestone";
  RateType2["PROVEN_STATUS_MILESTONE"] = "proven-status-milestone";
  RateType2["MILESTONE_TRUE_UP"] = "milestone-true-up";
  RateType2["RETURNED_TO_LAW_FIRM"] = "returned-to-law-firm";
  RateType2["MINIMUM_VOLUME_THRESHOLD"] = "minimum-volume-threshold";
  return RateType2;
})(RateType || {});
var PassThroughRateTypes = [
  "postal-mail" /* POSTAL_MAIL */,
  "phaxio" /* PHAXIO */,
  "notarization" /* NOTARIZATION */,
  "document-request-invoice" /* DOCUMENT_REQUEST_INVOICE */
];
var MilestoneRateTypes = [
  "case-creation-milestone" /* CASE_CREATION_MILESTONE */,
  "intake-completion-milestone" /* INTAKE_COMPLETION_MILESTONE */,
  "retrieval-in-progress-milestone" /* RETRIEVAL_IN_PROGRESS_MILESTONE */,
  "medical-records-received-milestone" /* MEDICAL_RECORDS_RECEIVED_MILESTONE */,
  "medical-review-in-progress-milestone" /* MEDICAL_REVIEW_IN_PROGRESS_MILESTONE */,
  "poi-confirmed-milestone" /* POI_CONFIRMED_MILESTONE */,
  "proven-status-milestone" /* PROVEN_STATUS_MILESTONE */,
  "milestone-true-up" /* MILESTONE_TRUE_UP */
];
var AlaCarteRateTypes = [
  "proven-case-deceased" /* PROVEN_CASE_DECEASED */,
  "sow-setup" /* SOW_SETUP */,
  "discovery-document" /* DISCOVERY_DOCUMENT */,
  "record-retrieval" /* RECORD_RETRIEVAL */,
  "record-review-summary" /* RECORD_REVIEW_SUMMARY */,
  "deceased-incapacitated" /* DECEASED_INCAPACITATED */,
  ...PassThroughRateTypes
];
var SexualAssaultRateTypes = [
  "proven-case-deceased" /* PROVEN_CASE_DECEASED */,
  "proven-case-timeline" /* PROVEN_CASE_TIMELINE */,
  "proven-case" /* PROVEN_CASE */,
  "sow-setup" /* SOW_SETUP */,
  "stale-case" /* STALE_CASE */,
  ...PassThroughRateTypes
];
var PersonalInjuryRateTypes = [
  "ingestion" /* INGESTION */,
  "law-firm-settlement" /* LAW_FIRM_SETTLEMENT */,
  "lien-resolution" /* LIEN_RESOLUTION */,
  "sow-setup" /* SOW_SETUP */,
  "torticity-settlement" /* TORTICITY_SETTLEMENT */,
  "verification" /* VERIFICATION */,
  "returned-to-law-firm" /* RETURNED_TO_LAW_FIRM */,
  "minimum-volume-threshold" /* MINIMUM_VOLUME_THRESHOLD */,
  ...PassThroughRateTypes
];
var MassTortRateTypes = [
  "proven-case-deceased" /* PROVEN_CASE_DECEASED */,
  "proven-case" /* PROVEN_CASE */,
  "proven-tier" /* PROVEN_TIER */,
  "proven-case-timeline" /* PROVEN_CASE_TIMELINE */,
  "stale-case" /* STALE_CASE */,
  "deceased-incapacitated" /* DECEASED_INCAPACITATED */,
  "sow-setup" /* SOW_SETUP */,
  ...PassThroughRateTypes,
  ...MilestoneRateTypes
];
var NaturalDisasterRateTypes = [
  ...PassThroughRateTypes,
  "sow-setup" /* SOW_SETUP */,
  "proven-case" /* PROVEN_CASE */,
  "minimum-volume-threshold" /* MINIMUM_VOLUME_THRESHOLD */
];
var MultipleChargeRateTypes = [
  ...PassThroughRateTypes,
  "record-retrieval" /* RECORD_RETRIEVAL */,
  "record-review-summary" /* RECORD_REVIEW_SUMMARY */,
  "proven-case-timeline" /* PROVEN_CASE_TIMELINE */,
  "milestone-true-up" /* MILESTONE_TRUE_UP */,
  "document-request-invoice" /* DOCUMENT_REQUEST_INVOICE */
];
var MilestoneRateTypeMap = {
  "Milestone 1.1": "Case Creation",
  "Milestone 1.2": "Intake Complete",
  "Milestone 2.1": "Retrieval in Progress",
  "Milestone 2.2": "Medical Records Received",
  "Milestone 3.1": "Medical Review in Progress",
  "Milestone 3.2": "POI Confirmed",
  "Milestone 4.1": "Proven"
};
var BillingEventStatus = /* @__PURE__ */ ((BillingEventStatus2) => {
  BillingEventStatus2["ACTIVE"] = "active";
  BillingEventStatus2["VOIDED"] = "voided";
  return BillingEventStatus2;
})(BillingEventStatus || {});
var BillingEventType = /* @__PURE__ */ ((BillingEventType2) => {
  BillingEventType2["CHARGE"] = "charge";
  BillingEventType2["CREDIT"] = "credit";
  return BillingEventType2;
})(BillingEventType || {});
var BillingEventInvoiceStatus = /* @__PURE__ */ ((BillingEventInvoiceStatus2) => {
  BillingEventInvoiceStatus2["BILLED"] = "billed";
  BillingEventInvoiceStatus2["PAID"] = "paid";
  BillingEventInvoiceStatus2["OMITTED"] = "omitted";
  BillingEventInvoiceStatus2["NOT_BILLED"] = "not billed";
  return BillingEventInvoiceStatus2;
})(BillingEventInvoiceStatus || {});
var BillingSummary = class {
};
var DocumentRequestBillingSummary = class {
};

// src/ImmediateActionLetters/index.ts
var ImmediateActionLetterType = /* @__PURE__ */ ((ImmediateActionLetterType2) => {
  ImmediateActionLetterType2["Medical"] = "Medical";
  ImmediateActionLetterType2["NoContact"] = "No contact";
  ImmediateActionLetterType2["Unresponsive"] = "Unresponsive";
  ImmediateActionLetterType2["NonCompliant"] = "Non-compliant";
  return ImmediateActionLetterType2;
})(ImmediateActionLetterType || {});
var ImmediateActionLetterStatus = /* @__PURE__ */ ((ImmediateActionLetterStatus2) => {
  ImmediateActionLetterStatus2["AwaitingResponse"] = "awaiting response";
  ImmediateActionLetterStatus2["NoResponse"] = "no response";
  ImmediateActionLetterStatus2["Received"] = "received";
  return ImmediateActionLetterStatus2;
})(ImmediateActionLetterStatus || {});
var ImmediateActionLetterCreateDTO = class {
};
var ImmediateActionLetterUpdateDTO = class {
};

// src/InsurancePolicies/auto.ts
var AutoCoverageType = /* @__PURE__ */ ((AutoCoverageType2) => {
  AutoCoverageType2["PIP"] = "PIP";
  AutoCoverageType2["UM_UIM"] = "UM/UIM";
  AutoCoverageType2["BI"] = "BI";
  AutoCoverageType2["MedPay"] = "MedPay";
  AutoCoverageType2["OTHER"] = "Other";
  return AutoCoverageType2;
})(AutoCoverageType || {});
var AUTO_COVERAGE_TYPES = [
  "PIP" /* PIP */,
  "UM/UIM" /* UM_UIM */,
  "BI" /* BI */,
  "MedPay" /* MedPay */,
  "Other" /* OTHER */
];
var HEALTH_COVERAGE_TYPES = [
  "PIP" /* PIP */,
  "UM/UIM" /* UM_UIM */,
  "BI" /* BI */,
  "Other" /* OTHER */
];
var BI_COVERAGE_AMOUNTS = [
  "$0.00",
  "$15,000.00",
  "$25,000.00",
  "$50,000.00",
  "$100,000.00",
  "Greater than $100,000.01"
];
var UI_UIM_COMBINED_SINGLE_LIMIT_AMOUNTS = [
  "$0.00",
  "$15,000.00",
  "$25,000.00",
  "$40,000.00",
  "$50,000.00",
  "$60,000.00",
  "$100,000.00",
  "$250,000.00",
  "$300,000.00",
  "$500,000.00",
  "$1,000,000.00",
  "$3,000,000.00",
  "$5,000,000.00",
  "$5,000,000.01+"
];
var UI_UIM_SPLIT_LIMIT_PERSON_AMOUNTS = [
  "$0.00",
  "$10,000.00",
  "$15,000.00",
  "$20,000.00",
  "$25,000.00",
  "$30,000.00",
  "$50,000.00",
  "$80,000.00",
  "$100,000.00",
  "$250,000.00",
  "$500,000.00",
  "$1,000,000.00+"
];
var UI_UIM_SPLIT_LIMIT_INCIDENT_AMOUNTS = [
  "$0.00",
  "$20,000.00",
  "$30,000.00",
  "$40,000.00",
  "$50,000.00",
  "$60,000.00",
  "$100,000.00",
  "$300,000.00",
  "$500,000.00"
];
var BI_COMBINED_SINGLE_LIMIT_AMOUNTS = [
  "$0.00",
  "$15,000.00",
  "$25,000.00",
  "$40,000.00",
  "$50,000.00",
  "$60,000.00",
  "$100,000.00",
  "$250,000.00",
  "$300,000.00",
  "$500,000.00",
  "$1,000,000.00",
  "$3,000,000.00",
  "$5,000,000.00",
  "$5,000,000.01+",
  "Self-insured"
];
var BI_SPLIT_LIMIT_PERSON_AMOUNTS = [
  "$0.00",
  "$10,000.00",
  "$15,000.00",
  "$20,000.00",
  "$25,000.00",
  "$30,000.00",
  "$50,000.00",
  "$80,000.00",
  "$100,000.00",
  "$250,000.00",
  "$500,000.00",
  "$1,000,000.00+"
];
var BI_SPLIT_LIMIT_INCIDENT_AMOUNTS = [
  "$0.00",
  "$15,000.00",
  "$20,000.00",
  "$25,000.00",
  "$30,000.00",
  "$40,000.00",
  "$50,000.00",
  "$60,000.00",
  "$100,000.00",
  "$300,000.00"
];
var MED_PAY_BENEFIT_AMOUNTS = ["$0.00", "$500.00", "$1,000.00", "$5,000.00", "$10,000.00"];
var PIP_BENEFIT_AMOUNTS = [
  "$0.00",
  "$1,000.00",
  "$2,000.00",
  "$2,500.00",
  "$3,000.00",
  "$4,500.00",
  "$5,000.00",
  "$8,000.00",
  "$10,000.00",
  "$15,000.00",
  "$20,000.00",
  "$25,000.00",
  "$30,000.00",
  "$40,000.00",
  "$50,000.00",
  "$75,000.00",
  "$100,000.00",
  "$250,000.00",
  "Unlimited"
];
var BENEFIT_AMOUNTS = [
  "$0.00",
  "$15,000.00",
  "$25,000.00",
  "$50,000.00",
  "$100,000.00",
  "$250,000.00+",
  "Unlimited"
];
var AutoBIliabilityStatus = /* @__PURE__ */ ((AutoBIliabilityStatus2) => {
  AutoBIliabilityStatus2["Accepted"] = "Accepted";
  AutoBIliabilityStatus2["NotAccepted"] = "Not accepted";
  AutoBIliabilityStatus2["NotDetermined"] = "Not determined";
  return AutoBIliabilityStatus2;
})(AutoBIliabilityStatus || {});
var AUTO_BI_LIABILITY_STATUS_OPTIONS = [
  "Accepted" /* Accepted */,
  "Not accepted" /* NotAccepted */,
  "Not determined" /* NotDetermined */
];
var AutoCoverageSubType = /* @__PURE__ */ ((AutoCoverageSubType2) => {
  AutoCoverageSubType2["Personal"] = "Personal";
  AutoCoverageSubType2["Household"] = "Household";
  AutoCoverageSubType2["Host_Vehicle"] = "Host Vehicle";
  AutoCoverageSubType2["MACP"] = "MACP";
  AutoCoverageSubType2["Multiple_Pro_rata"] = "Multiple (Pro-rata)";
  return AutoCoverageSubType2;
})(AutoCoverageSubType || {});
var PIP_COVERAGE_SUB_TYPES = [
  "Personal" /* Personal */,
  "Household" /* Household */,
  "Host Vehicle" /* Host_Vehicle */,
  "MACP" /* MACP */
];
var UM_UIM_COVERAGE_SUB_TYPES = [
  "Personal" /* Personal */,
  "Household" /* Household */,
  "Host Vehicle" /* Host_Vehicle */,
  "Multiple (Pro-rata)" /* Multiple_Pro_rata */
];
var LimitType = /* @__PURE__ */ ((LimitType2) => {
  LimitType2["Combined_Single_Limit"] = "Combined Single Limit";
  LimitType2["Split_Limit"] = "Split Limit";
  return LimitType2;
})(LimitType || {});
var LIMIT_TYPES = ["Combined Single Limit" /* Combined_Single_Limit */, "Split Limit" /* Split_Limit */];

// src/InsurancePolicies/index.ts
var InsurancePolicyType = /* @__PURE__ */ ((InsurancePolicyType2) => {
  InsurancePolicyType2["AUTO"] = "auto";
  InsurancePolicyType2["HEALTH"] = "health";
  InsurancePolicyType2["HOMEOWNERS"] = "homeowners";
  InsurancePolicyType2["UMBRELLA"] = "umbrella";
  return InsurancePolicyType2;
})(InsurancePolicyType || {});
var CoverageStatus = /* @__PURE__ */ ((CoverageStatus2) => {
  CoverageStatus2["INSURED"] = "Insured";
  CoverageStatus2["NOT_INSURED"] = "Not insured";
  return CoverageStatus2;
})(CoverageStatus || {});
var COVERAGE_STATUSES = ["Insured" /* INSURED */, "Not insured" /* NOT_INSURED */];
var InsuranceClaimStatus = /* @__PURE__ */ ((InsuranceClaimStatus2) => {
  InsuranceClaimStatus2["PENDING_CLAIM_SETUP_APPROVAL"] = "Pending claim setup approval";
  InsuranceClaimStatus2["CLAIM_SETUP_REQUIRED"] = "Claim setup required";
  InsuranceClaimStatus2["CLAIM_SETUP_NOT_REQUIRED"] = "Claim setup not required";
  InsuranceClaimStatus2["CLAIM_PENDING_ADDITIONAL_INFORMATION"] = "Claim pending additional information";
  InsuranceClaimStatus2["CLAIM_SETUP_COMPLETE"] = "Claim setup complete";
  return InsuranceClaimStatus2;
})(InsuranceClaimStatus || {});
var INSURANCE_CLAIM_STATUSES = [
  "Pending claim setup approval" /* PENDING_CLAIM_SETUP_APPROVAL */,
  "Claim setup required" /* CLAIM_SETUP_REQUIRED */,
  "Claim setup not required" /* CLAIM_SETUP_NOT_REQUIRED */,
  "Claim pending additional information" /* CLAIM_PENDING_ADDITIONAL_INFORMATION */,
  "Claim setup complete" /* CLAIM_SETUP_COMPLETE */
];

// src/LawFirm/index.ts
var IntegrationType = /* @__PURE__ */ ((IntegrationType2) => {
  IntegrationType2["SmartAdvocate"] = "SmartAdvocate";
  IntegrationType2["Filevine"] = "Filevine";
  IntegrationType2["Litify"] = "Litify";
  return IntegrationType2;
})(IntegrationType || {});
var LawFirmStaffRole = /* @__PURE__ */ ((LawFirmStaffRole2) => {
  LawFirmStaffRole2["ATTORNEY"] = "attorney";
  LawFirmStaffRole2["PARALEGAL"] = "paralegal";
  LawFirmStaffRole2["OTHER"] = "other";
  return LawFirmStaffRole2;
})(LawFirmStaffRole || {});

// src/Lien/index.ts
var LienResolutionPartners = /* @__PURE__ */ ((LienResolutionPartners2) => {
  LienResolutionPartners2["ZipLiens"] = "ZipLiens";
  return LienResolutionPartners2;
})(LienResolutionPartners || {});
var LienType = /* @__PURE__ */ ((LienType2) => {
  LienType2["FMC_EVALUATION_SERVICE"] = "fmc_evaluation_service";
  LienType2["MEDICAID_TORT"] = "medicaid_tort";
  LienType2["MEDICAL_PAYMENTS_PIP"] = "medical_payments_pip";
  LienType2["MEDICARE_PARTS_AB"] = "medicare_parts_ab";
  LienType2["MEDICARE_PARTS_CD"] = "medicare_parts_cd";
  LienType2["MEDICARE_WAIVER_COMPROMISE"] = "medicare_waiver_compromise";
  LienType2["OTHER_GOVERNMENT_PLAN_INDIAN_HEALTH"] = "other_government_plan_indian_health";
  LienType2["OTHER_GOVERNMENT_PLAN_TRICARE"] = "other_government_plan_tricare";
  LienType2["OTHER_GOVERNMENT_PLAN_VA"] = "other_government_plan_va";
  LienType2["PRIVATE_HEALTH_PLAN"] = "private_health_plan";
  LienType2["PROVIDER_BILL"] = "provider_bill";
  LienType2["PROVIDER_DIRECT"] = "provider_direct";
  LienType2["PROVIDER_DIRECT_NON_HOSPITAL"] = "provider_direct_non_hospital";
  LienType2["SHORT_TERM_DISABILITY"] = "short_term_disability";
  LienType2["SSDI"] = "ssdi";
  LienType2["SSI"] = "ssi";
  LienType2["WORKERS_COMP"] = "workers_comp";
  return LienType2;
})(LienType || {});
var LienStatus = /* @__PURE__ */ ((LienStatus2) => {
  LienStatus2["PENDING_DOCOUMENTS_FROM_LIENHOLDER"] = "Pending Documents from Lienholder";
  LienStatus2["PENDING_CASE_SETTLEMENT"] = "Pending Case Settlement";
  LienStatus2["NEW_LIEN"] = "New Lien";
  LienStatus2["PENDING_CLIENT_DOCUMENTS"] = "Pending Client Documents";
  LienStatus2["PAID"] = "Paid";
  LienStatus2["IN_NEGOTIATION"] = "In Negotiation";
  LienStatus2["INITIAL_LIEN_REVIEW"] = "Initial Lien Review";
  LienStatus2["INVOICED"] = "Invoiced";
  LienStatus2["LIEN_RESOLVED"] = "Lien Resolved";
  LienStatus2["REPORTING_CASE_TO_LIENHOLDER"] = "Reporting Case to Lienholder";
  LienStatus2["REVIEWING_LIEN_AND_RECOVERY_RIGHTS"] = "Reviewing Lien & Recovery Rights";
  return LienStatus2;
})(LienStatus || {});
var LienSubType = /* @__PURE__ */ ((LienSubType2) => {
  LienSubType2["ERISA"] = "erisa";
  LienSubType2["FULLY_INSURED"] = "fully_insured";
  LienSubType2["FEHBA"] = "fehba";
  return LienSubType2;
})(LienSubType || {});
var TypeToNameMap = {
  medicare_parts_ab: "Medicare parts A&B",
  medicare_parts_cd: "Medicare parts C&D",
  medicare_waiver_compromise: "Medicare waiver compromise",
  fmc_evaluation_service: "FMC evaluation service",
  medicaid_tort: "Medicaid tort",
  private_health_plan: "Private health plan",
  provider_bill: "Provider bill",
  provider_direct: "Provider direct",
  provider_direct_non_hospital: "Provider direct non-hospital",
  other_government_plan_va: "Government plan - VA",
  other_government_plan_tricare: "Government plan - TRICARE",
  other_government_plan_indian_health: "Government plan - IHS",
  ssdi: "SSDI",
  ssi: "SSI",
  workers_comp: "Workers' Compensation",
  short_term_disability: "Short term disability",
  medical_payments_pip: "Medical payment PIP"
};
var SubTypeToNameMap = {
  erisa: "ERISA",
  fehba: "FEHBA",
  "fully-insured": "Fully insured"
};

// src/MedicalBill/index.ts
var MEDICAL_RECORDS_DOCUMENT_TYPES = [
  "Unredacted Medical Records" /* UNREDACTED_MEDICAL_RECORDS */,
  "Medical Records" /* MEDICAL_RECORDS */,
  "Medical Chronology" /* MEDICAL_CHRONOLOGY */,
  "Partial Medical Records" /* PARTIAL_MEDICAL_RECORDS */
];
var BILLING_RECORDS_DOCUMENT_TYPES = [
  "Billing Records" /* BILLING_RECORDS */,
  "Partial Billing Records" /* PARTIAL_BILLING_RECORDS */,
  "Certified Billing Records" /* CERTIFIED_BILLING_RECORDS */,
  "Billing Record Certificate" /* BILLING_RECORD_CERTIFICATE */,
  "Fee Reduction" /* FEE_REDUCTION */,
  "Billing Reduction" /* BILLING_REDUCTION */
];
var BILLING_DOCUMENT_TYPES = [
  ...MEDICAL_RECORDS_DOCUMENT_TYPES,
  ...BILLING_RECORDS_DOCUMENT_TYPES
];
var MedicalBillType = /* @__PURE__ */ ((MedicalBillType2) => {
  MedicalBillType2["COPAY_DEDUCTIBLE"] = "Copay/Deductible";
  MedicalBillType2["BALANCE_OUTSTANDING"] = "Balance outstanding";
  MedicalBillType2["TOTAL_BILL_OUTSTANDING"] = "Total bill outstanding";
  return MedicalBillType2;
})(MedicalBillType || {});
var SometimesNotApplicableBoolean = /* @__PURE__ */ ((SometimesNotApplicableBoolean2) => {
  SometimesNotApplicableBoolean2["YES"] = "yes";
  SometimesNotApplicableBoolean2["NO"] = "no";
  SometimesNotApplicableBoolean2["NA"] = "n/a";
  return SometimesNotApplicableBoolean2;
})(SometimesNotApplicableBoolean || {});
var MedBillLineItemType = /* @__PURE__ */ ((MedBillLineItemType2) => {
  MedBillLineItemType2["CHARGE"] = "charge";
  MedBillLineItemType2["INSURANCE"] = "paid_by_health_insurance";
  MedBillLineItemType2["AUTO_INSURANCE"] = "paid_by_auto_insurance";
  MedBillLineItemType2["CLAIMANT"] = "paid_by_claimant";
  MedBillLineItemType2["CONTRACTUAL_ADJUSTMENT"] = "contractual_adjustment";
  MedBillLineItemType2["WORKERS_COMPENSATION"] = "paid_by_workers_compensation";
  MedBillLineItemType2["REDUCTION"] = "reduction";
  return MedBillLineItemType2;
})(MedBillLineItemType || {});
var MedBillLineItemStatus = /* @__PURE__ */ ((MedBillLineItemStatus2) => {
  MedBillLineItemStatus2["NEW"] = "new";
  MedBillLineItemStatus2["POTENTIAL_DUPLICATE"] = "potential_duplicate";
  MedBillLineItemStatus2["CONFIRMED_DUPLICATE"] = "confirmed_duplicate";
  MedBillLineItemStatus2["CONFIRMED_NEW"] = "confirmed_new";
  return MedBillLineItemStatus2;
})(MedBillLineItemStatus || {});
var MedBillExtractionStatus = /* @__PURE__ */ ((MedBillExtractionStatus2) => {
  MedBillExtractionStatus2["PROCESSING"] = "processing";
  MedBillExtractionStatus2["COMPLETED"] = "completed";
  MedBillExtractionStatus2["FAILED"] = "failed";
  return MedBillExtractionStatus2;
})(MedBillExtractionStatus || {});
var MedBillStatus = /* @__PURE__ */ ((MedBillStatus2) => {
  MedBillStatus2["DRAFT"] = "draft";
  MedBillStatus2["PUBLISHED"] = "published";
  return MedBillStatus2;
})(MedBillStatus || {});

// src/MedicalFacility/index.ts
var MedicalFacilityAddressType = /* @__PURE__ */ ((MedicalFacilityAddressType2) => {
  MedicalFacilityAddressType2["PHYSICAL"] = "physical";
  MedicalFacilityAddressType2["PHYSICAL_BILLING"] = "physical_billing";
  MedicalFacilityAddressType2["PHYSICAL_MEDICAL"] = "physical_medical";
  MedicalFacilityAddressType2["MAILING"] = "mailing";
  MedicalFacilityAddressType2["MAILING_BILLING"] = "mailing_billing";
  MedicalFacilityAddressType2["MAILING_MEDICAL"] = "mailing_medical";
  return MedicalFacilityAddressType2;
})(MedicalFacilityAddressType || {});
var MedicalFacilityAddressTypeLabel = {
  ["physical" /* PHYSICAL */]: "General physical",
  ["physical_billing" /* PHYSICAL_BILLING */]: "Billing physical",
  ["physical_medical" /* PHYSICAL_MEDICAL */]: "Medical physical",
  ["mailing" /* MAILING */]: "General mailing",
  ["mailing_billing" /* MAILING_BILLING */]: "Billing mailing",
  ["mailing_medical" /* MAILING_MEDICAL */]: "Medical mailing"
};
var MedicalFacilityEmailType = /* @__PURE__ */ ((MedicalFacilityEmailType2) => {
  MedicalFacilityEmailType2["GENERAL"] = "General";
  MedicalFacilityEmailType2["RECORDS_DEPARTMENT"] = "Records department";
  MedicalFacilityEmailType2["BILLING_DEPARTMENT"] = "Billing department";
  MedicalFacilityEmailType2["STATUS_CHECK"] = "Status check";
  MedicalFacilityEmailType2["BILL_REDUCTION_CONTACT"] = "Bill reduction contact";
  return MedicalFacilityEmailType2;
})(MedicalFacilityEmailType || {});
var MedicalFacilityPhoneNumberType = /* @__PURE__ */ ((MedicalFacilityPhoneNumberType2) => {
  MedicalFacilityPhoneNumberType2["OFFICE"] = "office";
  MedicalFacilityPhoneNumberType2["FAX"] = "fax";
  MedicalFacilityPhoneNumberType2["RECORDS_DEPARTMENT_FAX"] = "records_department_fax";
  MedicalFacilityPhoneNumberType2["RECORDS_DEPARTMENT_PHONE"] = "records_department_phone";
  MedicalFacilityPhoneNumberType2["BILLING_DEPARTMENT_PHONE"] = "billing_department_phone";
  MedicalFacilityPhoneNumberType2["BILLING_DEPARTMENT_FAX"] = "billing_department_fax";
  MedicalFacilityPhoneNumberType2["BILL_REDUCTION_CONTACT"] = "bill_reduction_contact";
  return MedicalFacilityPhoneNumberType2;
})(MedicalFacilityPhoneNumberType || {});
var MedicalFacilityPhoneNumberTypeLabel = {
  ["office" /* OFFICE */]: "General Office",
  ["fax" /* FAX */]: "General Fax",
  ["records_department_phone" /* RECORDS_DEPARTMENT_PHONE */]: "Records Department Phone",
  ["records_department_fax" /* RECORDS_DEPARTMENT_FAX */]: "Records Department Fax",
  ["billing_department_phone" /* BILLING_DEPARTMENT_PHONE */]: "Billing Department Phone",
  ["billing_department_fax" /* BILLING_DEPARTMENT_FAX */]: "Billing Department Fax",
  ["bill_reduction_contact" /* BILL_REDUCTION_CONTACT */]: "Bill Reduction Contact"
};

// src/Message/index.ts
var ConversationChannel = /* @__PURE__ */ ((ConversationChannel2) => {
  ConversationChannel2["SMS"] = "sms";
  ConversationChannel2["EMAIL"] = "email";
  return ConversationChannel2;
})(ConversationChannel || {});
var MessageDeliveryStatus = /* @__PURE__ */ ((MessageDeliveryStatus2) => {
  MessageDeliveryStatus2["QUEUED"] = "queued";
  MessageDeliveryStatus2["FAILED"] = "failed";
  MessageDeliveryStatus2["SENT"] = "sent";
  MessageDeliveryStatus2["DELIVERED"] = "delivered";
  MessageDeliveryStatus2["UNDELIVERED"] = "undelivered";
  return MessageDeliveryStatus2;
})(MessageDeliveryStatus || {});
var MessageDirection = /* @__PURE__ */ ((MessageDirection2) => {
  MessageDirection2["INBOUND"] = "inbound";
  MessageDirection2["OUTBOUND"] = "outbound";
  return MessageDirection2;
})(MessageDirection || {});
var MessageSource = /* @__PURE__ */ ((MessageSource2) => {
  MessageSource2["ITERABLE"] = "iterable";
  return MessageSource2;
})(MessageSource || {});

// src/Negotiation/index.ts
var NegotiationEventStatus = /* @__PURE__ */ ((NegotiationEventStatus2) => {
  NegotiationEventStatus2["NEGOTIATION_ONGOING"] = "Negotiation ongoing";
  NegotiationEventStatus2["NEGOTIATION_FAILED"] = "Negotiation failed";
  NegotiationEventStatus2["PENDING_OFFER"] = "Pending offer";
  NegotiationEventStatus2["PENDING_AUTHORITY"] = "Pending authority";
  NegotiationEventStatus2["OFFER_ACCEPTED"] = "Offer accepted";
  NegotiationEventStatus2["RELEASE_PENDING"] = "Release pending";
  NegotiationEventStatus2["RELEASE_EXECUTED"] = "Release executed";
  NegotiationEventStatus2["INITIAL_REQUEST_FOR_SETTLEMENT_STATEMENT"] = "Initial request for settlement statement";
  NegotiationEventStatus2["FINAL_REQUEST_FOR_SETTLEMENT_STATEMENT"] = "Final request for settlement statement";
  return NegotiationEventStatus2;
})(NegotiationEventStatus || {});

// src/Organization/index.ts
var OrganizationType = /* @__PURE__ */ ((OrganizationType2) => {
  OrganizationType2["INSURANCE_PROVIDER"] = "insurance_provider";
  OrganizationType2["BUSINESS"] = "business";
  OrganizationType2["MUNICIPALITY"] = "municipality";
  OrganizationType2["LAW_ENFORCEMENT"] = "law_enforcement";
  OrganizationType2["INSTITUTION"] = "institution";
  OrganizationType2["OTHER"] = "other";
  return OrganizationType2;
})(OrganizationType || {});
var ContactInfoType = /* @__PURE__ */ ((ContactInfoType2) => {
  ContactInfoType2["PHONE"] = "phone";
  ContactInfoType2["FAX"] = "fax";
  ContactInfoType2["EMAIL"] = "email";
  ContactInfoType2["ADDRESS"] = "address";
  ContactInfoType2["PORTAL"] = "portal";
  return ContactInfoType2;
})(ContactInfoType || {});
var OrganizationAddressType = /* @__PURE__ */ ((OrganizationAddressType2) => {
  OrganizationAddressType2["PHYSICAL"] = "physical";
  OrganizationAddressType2["MAILING"] = "mailing";
  OrganizationAddressType2["OTHER"] = "other";
  return OrganizationAddressType2;
})(OrganizationAddressType || {});

// src/PdfTemplate/index.ts
var FieldValueDescription = /* @__PURE__ */ ((FieldValueDescription2) => {
  FieldValueDescription2["TodaysDate"] = "Today's date";
  FieldValueDescription2["TalcumClaimInformation"] = "Talcum Claim information";
  FieldValueDescription2["TalcumMedicalEventInformation"] = "Talcum Medical Event Information";
  FieldValueDescription2["TalcumIsCurrentSmoker"] = "Talcum is current smoker";
  FieldValueDescription2["TalcumIsPastSmoker"] = "Talcum is past smoker";
  FieldValueDescription2["TalcumSmokingStartDate"] = "Talcum smoking start date";
  FieldValueDescription2["TalcumSmokingStopDate"] = "Talcum smoking stop date";
  FieldValueDescription2["TalcumSmokingQuantity"] = "Talcum smoking quantity";
  FieldValueDescription2["TalcumYearsSmoking"] = "Talcum years smoking";
  FieldValueDescription2["TalcumPowderUsed"] = "Talcum powder used";
  FieldValueDescription2["TalcumPowderFirstYearOfUse"] = "Talcum powder first year of use";
  FieldValueDescription2["TalcumPowderLastYearOfUse"] = "Talcum powder last year of use";
  FieldValueDescription2["TalcumPowderUseFrequency"] = "Talcum powder use frequency";
  FieldValueDescription2["TalcumPowderShowerUsed"] = "Talcum powder Shower to Shower used";
  FieldValueDescription2["TalcumPowderShowerFirstYearOfUse"] = "Talcum powder Shower to Shower first year of use";
  FieldValueDescription2["TalcumPowderShowerLastYearOfUse"] = "Talcum powder Shower to Shower last year of use";
  FieldValueDescription2["TalcumPowderShowerUseFrequency"] = "Talcum powder Shower to Shower use frequency";
  FieldValueDescription2["TalcumPowderOtherProductsUsed"] = "Talcum powder other products used on genitals";
  FieldValueDescription2["TalcumPowderOtherProducts"] = "Talcum powder other products used";
  FieldValueDescription2["TalcumMedicalHistory"] = "Talcum medical history";
  FieldValueDescription2["TalcumFamilyMedicalHistory"] = "Talcum family medical history";
  FieldValueDescription2["TalcumTubalLigation"] = "Talcum tubal ligation";
  FieldValueDescription2["TalcumTubalLigationDate"] = "Talcum tubal ligation date";
  FieldValueDescription2["TalcumGeneticTesting"] = "Talcum genetic testing";
  FieldValueDescription2["TalcumGeneticTestingProvider"] = "Talcum genetic testing provider";
  FieldValueDescription2["CaseId"] = "Case ID";
  FieldValueDescription2["ClaimantCurrentEmployerAndPosition"] = "Claimant employer and position";
  FieldValueDescription2["ClaimantDob"] = "Claimant DOB";
  FieldValueDescription2["ClaimantDod"] = "Claimant DOD";
  FieldValueDescription2["ClaimantDodNotApplicable"] = "Claimant DOD not applicable";
  FieldValueDescription2["ClaimantEmploymentStatus"] = "Claimant employment status";
  FieldValueDescription2["ClaimantFirstName"] = "Claimant first name";
  FieldValueDescription2["ClaimantLastFourSsn"] = "Claimant last 4 ssn";
  FieldValueDescription2["ClaimantLastName"] = "Claimant last name";
  FieldValueDescription2["ClaimantMiddleInitial"] = "Claimant middle initial";
  FieldValueDescription2["ClaimantName"] = "Claimant name";
  FieldValueDescription2["ClaimantOccupation"] = "Claimant occupation";
  FieldValueDescription2["ClaimantSsn"] = "Claimant SSN";
  FieldValueDescription2["ClaimantYearOfBirth"] = "Claimant year of birth";
  FieldValueDescription2["CoCounsel"] = "Co-counsel";
  FieldValueDescription2["ExternalId"] = "External ID";
  FieldValueDescription2["FormCompleterFirstName"] = "Form completer first name";
  FieldValueDescription2["FormCompleterLastName"] = "Form completer last name";
  FieldValueDescription2["FormCompleterMiddleInitial"] = "Form completer middle initial";
  FieldValueDescription2["FormCompleterName"] = "Form completer name";
  FieldValueDescription2["Gender"] = "Claimant gender";
  FieldValueDescription2["IsClaimantEmployed"] = "Is claimant employed";
  FieldValueDescription2["LeadOwner"] = "Lead owner";
  FieldValueDescription2["MaidenName"] = "Maiden name";
  FieldValueDescription2["MaritalStatus"] = "Marital status";
  FieldValueDescription2["MatterType"] = "Matter type";
  FieldValueDescription2["PreExistingInjuries"] = "Pre-existing injuries";
  FieldValueDescription2["PrimaryAddress"] = "Primary address";
  FieldValueDescription2["RepName"] = "Rep name";
  FieldValueDescription2["RepRelation"] = "Rep relation to claimant";
  FieldValueDescription2["SpouseName"] = "Spouse name";
  FieldValueDescription2["StatedInjuries"] = "Stated injuries";
  FieldValueDescription2["DateOfAccident"] = "Date of accident";
  FieldValueDescription2["AccidentLocation"] = "Location of accident";
  FieldValueDescription2["AtFaultPartyName"] = "At fault party name";
  FieldValueDescription2["BIClaimNumber"] = "BI Claim number";
  FieldValueDescription2["BIPolicyHolderName"] = "BI Policy holder name";
  FieldValueDescription2["BIPolicyNumber"] = "BI Policy number";
  FieldValueDescription2["BIAdjusterEmail"] = "BI adjuster email";
  FieldValueDescription2["BIAdjusterFax"] = "BI adjuster fax";
  FieldValueDescription2["BIAdjusterName"] = "BI adjuster name";
  FieldValueDescription2["BIAdjusterPhone"] = "BI adjuster phone";
  FieldValueDescription2["BIInsuranceCompanyName"] = "BI Insurance company Name";
  FieldValueDescription2["UMUIMClaimNumber"] = "UM/UIM Claim number";
  FieldValueDescription2["UMUIMPolicyHolderName"] = "UM/UIM Policy holder name";
  FieldValueDescription2["UMUIMPolicyNumber"] = "UM/UIM Policy number";
  FieldValueDescription2["UMUIMAdjusterEmail"] = "UM/UIM adjuster email";
  FieldValueDescription2["UMUIMAdjusterFax"] = "UM/UIM adjuster fax";
  FieldValueDescription2["UMUIMAdjusterName"] = "UM/UIM adjuster name";
  FieldValueDescription2["UMUIMAdjusterPhone"] = "UM/UIM adjuster phone";
  FieldValueDescription2["UMUIMInsuranceCompanyName"] = "UM/UIM Insurance company Name";
  FieldValueDescription2["MedicalFacilityName"] = "Medical facility name";
  FieldValueDescription2["MedicalFacilityPhysicalMedicalAddressLine1"] = "Physical medical address line 1";
  FieldValueDescription2["MedicalFacilityPhysicalMedicalAddressLine2"] = "Physical medical address line 2";
  FieldValueDescription2["MedicalFacilityPhysicalMedicalCity"] = "Physical medical city";
  FieldValueDescription2["MedicalFacilityPhysicalMedicalState"] = "Physical medical state";
  FieldValueDescription2["MedicalFacilityPhysicalMedicalZipcode"] = "Physical medical zipcode";
  FieldValueDescription2["MedicalFacilityPhysicalBillingAddressLine1"] = "Physical billing address line 1";
  FieldValueDescription2["MedicalFacilityPhysicalBillingAddressLine2"] = "Physical billing address line 2";
  FieldValueDescription2["MedicalFacilityPhysicalBillingCity"] = "Physical billing city";
  FieldValueDescription2["MedicalFacilityPhysicalBillingState"] = "Physical billing state";
  FieldValueDescription2["MedicalFacilityPhysicalBillingZipcode"] = "Physical billing zipcode";
  FieldValueDescription2["MedicalFacilityMailingMedicalAddressLine1"] = "Mailing medical address line 1";
  FieldValueDescription2["MedicalFacilityMailingMedicalAddressLine2"] = "Mailing medical address line 2";
  FieldValueDescription2["MedicalFacilityMailingMedicalCity"] = "Mailing medical city";
  FieldValueDescription2["MedicalFacilityMailingMedicalState"] = "Mailing medical state";
  FieldValueDescription2["MedicalFacilityMailingMedicalZipcode"] = "Mailing medical zipcode";
  FieldValueDescription2["MedicalFacilityMailingBillingAddressLine1"] = "Mailing billing address line 1";
  FieldValueDescription2["MedicalFacilityMailingBillingAddressLine2"] = "Mailing billing address line 2";
  FieldValueDescription2["MedicalFacilityMailingBillingCity"] = "Mailing billing city";
  FieldValueDescription2["MedicalFacilityMailingBillingState"] = "Mailing billing state";
  FieldValueDescription2["MedicalFacilityMailingBillingZipcode"] = "Mailing billing zipcode";
  FieldValueDescription2["Signature"] = "Signature";
  return FieldValueDescription2;
})(FieldValueDescription || {});
var PdfTemplateType = /* @__PURE__ */ ((PdfTemplateType2) => {
  PdfTemplateType2["Addendum"] = "Addendum";
  PdfTemplateType2["Authorization"] = "Authorization";
  PdfTemplateType2["BILOR"] = "BI LOR";
  PdfTemplateType2["CarrierDeclinationLetter"] = "Carrier declination letter";
  PdfTemplateType2["CensusForm"] = "Census form";
  PdfTemplateType2["ClaimantDeclinationLetter"] = "Claimant declination letter";
  PdfTemplateType2["DiscoveryDocument"] = "Discovery document";
  PdfTemplateType2["FOIA"] = "FOIA";
  PdfTemplateType2["ImmediateActionLetter"] = "Immediate action letter";
  PdfTemplateType2["LetterOfProtection"] = "Letter of protection";
  PdfTemplateType2["MedpayRecordRequest"] = "Medpay Record Request";
  PdfTemplateType2["PIPLedger"] = "PIP Ledger";
  PdfTemplateType2["PipLor"] = "PIP LOR";
  PdfTemplateType2["PreservationOfEvidence"] = "Preservation of evidence";
  PdfTemplateType2["ProviderDeclinationLetter"] = "Provider declination letter";
  PdfTemplateType2["TurnaroundLetter"] = "Turnaround letter";
  PdfTemplateType2["UMUIMLOR"] = "UM/UIM LOR";
  PdfTemplateType2["ZipLiens"] = "ZipLiens";
  PdfTemplateType2["ZipliensBCBS"] = "Zipliens BCBS";
  PdfTemplateType2["ZipliensHIPAAMedicare"] = "Zipliens HIPAA/Medicare";
  return PdfTemplateType2;
})(PdfTemplateType || {});
var PdfTemplateStatus = /* @__PURE__ */ ((PdfTemplateStatus2) => {
  PdfTemplateStatus2["DRAFT"] = "draft";
  PdfTemplateStatus2["COMPLETED"] = "completed";
  PdfTemplateStatus2["VISIBLE"] = "visible";
  return PdfTemplateStatus2;
})(PdfTemplateStatus || {});
var PdfTemplateFonts = /* @__PURE__ */ ((PdfTemplateFonts2) => {
  PdfTemplateFonts2["Courier"] = "Courier";
  PdfTemplateFonts2["CourierBold"] = "Courier-Bold";
  PdfTemplateFonts2["CourierOblique"] = "Courier-Oblique";
  PdfTemplateFonts2["CourierBoldOblique"] = "Courier-BoldOblique";
  PdfTemplateFonts2["Helvetica"] = "Helvetica";
  PdfTemplateFonts2["HelveticaBold"] = "Helvetica-Bold";
  PdfTemplateFonts2["HelveticaOblique"] = "Helvetica-Oblique";
  PdfTemplateFonts2["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
  PdfTemplateFonts2["TimesRoman"] = "Times-Roman";
  PdfTemplateFonts2["TimesRomanBold"] = "Times-Bold";
  PdfTemplateFonts2["TimesRomanItalic"] = "Times-Italic";
  PdfTemplateFonts2["TimesRomanBoldItalic"] = "Times-BoldItalic";
  return PdfTemplateFonts2;
})(PdfTemplateFonts || {});
var FieldKeyToPdfKeyMap = {
  TodaysDate: { key: "todaysDate", page: "" /* NoPage */ },
  LeadOwner: { key: "leadOwner", page: "claimant-information" /* ClaimantInformation */ },
  ClaimantName: { key: "claimantName", page: "claimant-information" /* ClaimantInformation */ },
  ClaimantFirstName: {
    key: "claimantFirstName",
    page: "claimant-information" /* ClaimantInformation */
  },
  ClaimantMiddleInitial: {
    key: "claimantMiddleInitial",
    page: "claimant-information" /* ClaimantInformation */
  },
  ClaimantLastName: { key: "claimantLastName", page: "claimant-information" /* ClaimantInformation */ },
  FormCompleterName: {
    key: "formCompleterName",
    page: "claimant-information" /* ClaimantInformation */
  },
  FormCompleterFirstName: {
    key: "formCompleterFirstName",
    page: "claimant-information" /* ClaimantInformation */
  },
  FormCompleterMiddleInitial: {
    key: "formCompleterMiddleInitial",
    page: "claimant-information" /* ClaimantInformation */
  },
  FormCompleterLastName: {
    key: "formCompleterLastName",
    page: "claimant-information" /* ClaimantInformation */
  },
  DateOfAccident: { key: "dateOfAccident", page: "claimant-information" /* ClaimantInformation */ },
  AccidentLocation: { key: "accidentLocation", page: "" /* NoPage */ },
  AtFaultPartyName: { key: "atFaultPartyName", page: "" /* NoPage */ },
  TalcumClaimInformation: { key: "talcumClaimInformation", page: "review" /* Review */ },
  TalcumMedicalEventInformation: {
    key: "talcumMedicalEventInformation",
    page: "events-and-requests" /* EventsAndRequests */
  },
  TalcumIsCurrentSmoker: { key: "talcumIsCurrentSmoker", page: "review" /* Review */ },
  TalcumIsPastSmoker: { key: "talcumIsPastSmoker", page: "review" /* Review */ },
  TalcumSmokingStartDate: { key: "talcumSmokingStartDate", page: "review" /* Review */ },
  TalcumSmokingStopDate: { key: "talcumSmokingStopDate", page: "review" /* Review */ },
  TalcumSmokingQuantity: { key: "talcumSmokingQuantity", page: "review" /* Review */ },
  TalcumYearsSmoking: { key: "talcumYearsSmoking", page: "review" /* Review */ },
  TalcumPowderUsed: { key: "talcumPowderUsed", page: "review" /* Review */ },
  TalcumPowderFirstYearOfUse: {
    key: "talcumPowderFirstYearOfUse",
    page: "review" /* Review */
  },
  TalcumPowderLastYearOfUse: {
    key: "talcumPowderLastYearOfUse",
    page: "review" /* Review */
  },
  TalcumPowderUseFrequency: {
    key: "talcumPowderUseFrequency",
    page: "review" /* Review */
  },
  TalcumPowderShowerUsed: {
    key: "talcumPowderShowerUsed",
    page: "review" /* Review */
  },
  TalcumPowderShowerFirstYearOfUse: {
    key: "talcumPowderShowerFirstYearOfUse",
    page: "review" /* Review */
  },
  TalcumPowderShowerLastYearOfUse: {
    key: "talcumPowderShowerLastYearOfUse",
    page: "review" /* Review */
  },
  TalcumPowderShowerUseFrequency: {
    key: "talcumPowderShowerUseFrequency",
    page: "review" /* Review */
  },
  TalcumPowderOtherProductsUsed: {
    key: "talcumPowderOtherProductsUsed",
    page: "review" /* Review */
  },
  TalcumPowderOtherProducts: {
    key: "talcumPowderOtherProducts",
    page: "review" /* Review */
  },
  TalcumMedicalHistory: { key: "talcumDiagnosisHistory", page: "review" /* Review */ },
  TalcumFamilyMedicalHistory: {
    key: "talcumFamilyMedicalHistory",
    page: "review" /* Review */
  },
  TalcumTubalLigation: { key: "talcumTubalLigation", page: "review" /* Review */ },
  TalcumTubalLigationDate: {
    key: "talcumTubalLigationDate",
    page: "review" /* Review */
  },
  TalcumGeneticTesting: { key: "talcumGeneticTesting", page: "review" /* Review */ },
  TalcumGeneticTestingProvider: {
    key: "talcumGeneticTestingProvider",
    page: "review" /* Review */
  },
  Gender: { key: "gender", page: "claimant-information" /* ClaimantInformation */ },
  MaidenName: { key: "maidenName", page: "claimant-information" /* ClaimantInformation */ },
  MaritalStatus: { key: "maritalStatus", page: "claimant-information" /* ClaimantInformation */ },
  PrimaryAddress: { key: "primaryAddress", page: "claimant-information" /* ClaimantInformation */ },
  RepName: { key: "repName", page: "claimant-information" /* ClaimantInformation */ },
  RepRelation: { key: "repRelation", page: "claimant-information" /* ClaimantInformation */ },
  SpouseName: { key: "spouseName", page: "claimant-information" /* ClaimantInformation */ },
  ClaimantSsn: { key: "claimantSsn", page: "claimant-information" /* ClaimantInformation */ },
  ClaimantDob: { key: "claimantDob", page: "claimant-information" /* ClaimantInformation */ },
  ClaimantYearOfBirth: {
    key: "claimantYearOfBirth",
    page: "claimant-information" /* ClaimantInformation */
  },
  ClaimantDod: { key: "claimantDod", page: "claimant-information" /* ClaimantInformation */ },
  ClaimantDodNotApplicable: {
    key: "claimantDodNotApplicable",
    page: "claimant-information" /* ClaimantInformation */
  },
  ClaimantEmploymentStatus: {
    key: "claimantEmploymentStatus",
    page: "claimant-information" /* ClaimantInformation */
  },
  ClaimantOccupation: {
    key: "claimantOccupation",
    page: "claimant-information" /* ClaimantInformation */
  },
  IsClaimantEmployed: {
    key: "isClaimantEmployed",
    page: "claimant-information" /* ClaimantInformation */
  },
  ClaimantCurrentEmployerAndPosition: {
    key: "claimantCurrentEmployerAndPosition",
    page: "claimant-information" /* ClaimantInformation */
  },
  BIClaimNumber: { key: "biClaimNumber", page: "claimant-information" /* ClaimantInformation */ },
  BIPolicyHolderName: {
    key: "biPolicyHolderName",
    page: "claimant-information" /* ClaimantInformation */
  },
  BIPolicyNumber: { key: "biPolicyNumber", page: "claimant-information" /* ClaimantInformation */ },
  BIAdjusterEmail: { key: "biAdjusterEmail", page: "claimant-information" /* ClaimantInformation */ },
  BIAdjusterFax: { key: "biAdjusterFax", page: "claimant-information" /* ClaimantInformation */ },
  BIAdjusterName: { key: "biAdjusterName", page: "claimant-information" /* ClaimantInformation */ },
  BIAdjusterPhone: { key: "biAdjusterPhone", page: "claimant-information" /* ClaimantInformation */ },
  BIInsuranceCompanyName: {
    key: "biInsuranceCompanyName",
    page: "claimant-information" /* ClaimantInformation */
  },
  UMUIMClaimNumber: { key: "umuimClaimNumber", page: "claimant-information" /* ClaimantInformation */ },
  UMUIMPolicyHolderName: {
    key: "umuimPolicyHolderName",
    page: "claimant-information" /* ClaimantInformation */
  },
  UMUIMPolicyNumber: {
    key: "umuimPolicyNumber",
    page: "claimant-information" /* ClaimantInformation */
  },
  UMUIMAdjusterEmail: {
    key: "umuimAdjusterEmail",
    page: "claimant-information" /* ClaimantInformation */
  },
  UMUIMAdjusterFax: { key: "umuimAdjusterFax", page: "claimant-information" /* ClaimantInformation */ },
  UMUIMAdjusterName: {
    key: "umuimAdjusterName",
    page: "claimant-information" /* ClaimantInformation */
  },
  UMUIMAdjusterPhone: {
    key: "umuimAdjusterPhone",
    page: "claimant-information" /* ClaimantInformation */
  },
  UMUIMInsuranceCompanyName: {
    key: "umuimInsuranceCompanyName",
    page: "claimant-information" /* ClaimantInformation */
  },
  MedicalFacilityName: {
    key: "medicalFacilityName",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityPhysicalMedicalAddressLine1: {
    key: "medicalFacilityPhysicalMedicalAddressLine1",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityPhysicalMedicalAddressLine2: {
    key: "medicalFacilityPhysicalMedicalAddressLine2",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityPhysicalMedicalCity: {
    key: "medicalFacilityPhysicalMedicalCity",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityPhysicalMedicalState: {
    key: "medicalFacilityPhysicalMedicalState",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityPhysicalMedicalZipcode: {
    key: "medicalFacilityPhysicalMedicalZipcode",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityPhysicalBillingAddressLine1: {
    key: "medicalFacilityPhysicalBillingAddressLine1",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityPhysicalBillingAddressLine2: {
    key: "medicalFacilityPhysicalBillingAddressLine2",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityPhysicalBillingCity: {
    key: "medicalFacilityPhysicalBillingCity",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityPhysicalBillingState: {
    key: "medicalFacilityPhysicalBillingState",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityPhysicalBillingZipcode: {
    key: "medicalFacilityPhysicalBillingZipcode",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityMailingMedicalAddressLine1: {
    key: "medicalFacilityMailingMedicalAddressLine1",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityMailingMedicalAddressLine2: {
    key: "medicalFacilityMailingMedicalAddressLine2",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityMailingMedicalCity: {
    key: "medicalFacilityMailingMedicalCity",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityMailingMedicalState: {
    key: "medicalFacilityMailingMedicalState",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityMailingMedicalZipcode: {
    key: "medicalFacilityMailingMedicalZipcode",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityMailingBillingAddressLine1: {
    key: "medicalFacilityMailingBillingAddressLine1",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityMailingBillingAddressLine2: {
    key: "medicalFacilityMailingBillingAddressLine2",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityMailingBillingCity: {
    key: "medicalFacilityMailingBillingCity",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityMailingBillingState: {
    key: "medicalFacilityMailingBillingState",
    page: "events-and-requests" /* EventsAndRequests */
  },
  MedicalFacilityMailingBillingZipcode: {
    key: "medicalFacilityMailingBillingZipcode",
    page: "events-and-requests" /* EventsAndRequests */
  },
  Signature: {
    key: "signature",
    page: "" /* NoPage */
  },
  CaseId: { key: "caseId", page: "" /* NoPage */ },
  ClaimantLastFourSsn: {
    key: "claimantLastFourSsn",
    page: "claimant-information" /* ClaimantInformation */
  },
  CoCounsel: {
    key: "coCounsel",
    page: "legal" /* Legal */
  },
  ExternalId: { key: "externalId", page: "" /* NoPage */ },
  MatterType: { key: "matterType", page: "" /* NoPage */ },
  PreExistingInjuries: { key: "preExistingInjuries", page: "review" /* Review */ },
  StatedInjuries: { key: "statedInjuries", page: "review" /* Review */ }
};
var BIIteratorKeys = /* @__PURE__ */ ((BIIteratorKeys2) => {
  BIIteratorKeys2["BIAdjusterName"] = "biAdjusterName";
  BIIteratorKeys2["BIAdjusterFax"] = "biAdjusterFax";
  BIIteratorKeys2["BIAdjusterEmail"] = "biAdjusterEmail";
  BIIteratorKeys2["BIAdjusterPhone"] = "biAdjusterPhone";
  BIIteratorKeys2["BIPolicyHolderName"] = "biPolicyHolderName";
  BIIteratorKeys2["BIPolicyNumber"] = "biPolicyNumber";
  BIIteratorKeys2["BIClaimNumber"] = "biClaimNumber";
  BIIteratorKeys2["BIInsuranceCompanyName"] = "biInsuranceCompanyName";
  return BIIteratorKeys2;
})(BIIteratorKeys || {});
var UMUIMIteratorKeys = /* @__PURE__ */ ((UMUIMIteratorKeys2) => {
  UMUIMIteratorKeys2["UMUIMAdjusterName"] = "umuimAdjusterName";
  UMUIMIteratorKeys2["UMUIMAdjusterFax"] = "umuimAdjusterFax";
  UMUIMIteratorKeys2["UMUIMAdjusterEmail"] = "umuimAdjusterEmail";
  UMUIMIteratorKeys2["UMUIMAdjusterPhone"] = "umuimAdjusterPhone";
  UMUIMIteratorKeys2["UMUIMPolicyHolderName"] = "umuimPolicyHolderName";
  UMUIMIteratorKeys2["UMUIMPolicyNumber"] = "umuimPolicyNumber";
  UMUIMIteratorKeys2["UMUIMClaimNumber"] = "umuimClaimNumber";
  UMUIMIteratorKeys2["UMUIMInsuranceCompanyName"] = "umuimInsuranceCompanyName";
  return UMUIMIteratorKeys2;
})(UMUIMIteratorKeys || {});
var MedicalFacilityIteratorKeys = /* @__PURE__ */ ((MedicalFacilityIteratorKeys2) => {
  MedicalFacilityIteratorKeys2["MedicalFacilityName"] = "medicalFacilityName";
  MedicalFacilityIteratorKeys2["MedicalFacilityPhysicalMedicalAddressLine1"] = "medicalFacilityPhysicalMedicalAddressLine1";
  MedicalFacilityIteratorKeys2["MedicalFacilityPhysicalMedicalAddressLine2"] = "medicalFacilityPhysicalMedicalAddressLine2";
  MedicalFacilityIteratorKeys2["MedicalFacilityPhysicalMedicalCity"] = "medicalFacilityPhysicalMedicalCity";
  MedicalFacilityIteratorKeys2["MedicalFacilityPhysicalMedicalState"] = "medicalFacilityPhysicalMedicalState";
  MedicalFacilityIteratorKeys2["MedicalFacilityPhysicalMedicalZipcode"] = "medicalFacilityPhysicalMedicalZipcode";
  MedicalFacilityIteratorKeys2["MedicalFacilityPhysicalBillingAddressLine1"] = "medicalFacilityPhysicalBillingAddressLine1";
  MedicalFacilityIteratorKeys2["MedicalFacilityPhysicalBillingAddressLine2"] = "medicalFacilityPhysicalBillingAddressLine2";
  MedicalFacilityIteratorKeys2["MedicalFacilityPhysicalBillingCity"] = "medicalFacilityPhysicalBillingCity";
  MedicalFacilityIteratorKeys2["MedicalFacilityPhysicalBillingState"] = "medicalFacilityPhysicalBillingState";
  MedicalFacilityIteratorKeys2["MedicalFacilityPhysicalBillingZipcode"] = "medicalFacilityPhysicalBillingZipcode";
  MedicalFacilityIteratorKeys2["MedicalFacilityMailingMedicalAddressLine1"] = "medicalFacilityMailingMedicalAddressLine1";
  MedicalFacilityIteratorKeys2["MedicalFacilityMailingMedicalAddressLine2"] = "medicalFacilityMailingMedicalAddressLine2";
  MedicalFacilityIteratorKeys2["MedicalFacilityMailingMedicalCity"] = "medicalFacilityMailingMedicalCity";
  MedicalFacilityIteratorKeys2["MedicalFacilityMailingMedicalState"] = "medicalFacilityMailingMedicalState";
  MedicalFacilityIteratorKeys2["MedicalFacilityMailingMedicalZipcode"] = "medicalFacilityMailingMedicalZipcode";
  MedicalFacilityIteratorKeys2["MedicalFacilityMailingBillingAddressLine1"] = "medicalFacilityMailingBillingAddressLine1";
  MedicalFacilityIteratorKeys2["MedicalFacilityMailingBillingAddressLine2"] = "medicalFacilityMailingBillingAddressLine2";
  MedicalFacilityIteratorKeys2["MedicalFacilityMailingBillingCity"] = "medicalFacilityMailingBillingCity";
  MedicalFacilityIteratorKeys2["MedicalFacilityMailingBillingState"] = "medicalFacilityMailingBillingState";
  MedicalFacilityIteratorKeys2["MedicalFacilityMailingBillingZipcode"] = "medicalFacilityMailingBillingZipcode";
  return MedicalFacilityIteratorKeys2;
})(MedicalFacilityIteratorKeys || {});
var PdfTemplatePacketStatus = /* @__PURE__ */ ((PdfTemplatePacketStatus2) => {
  PdfTemplatePacketStatus2["DRAFT"] = "draft";
  PdfTemplatePacketStatus2["VISIBLE"] = "visible";
  return PdfTemplatePacketStatus2;
})(PdfTemplatePacketStatus || {});

// src/Person/index.ts
var PersonContactRelationshipType = /* @__PURE__ */ ((PersonContactRelationshipType2) => {
  PersonContactRelationshipType2["ADJUSTER"] = "adjuster";
  PersonContactRelationshipType2["ATTORNEY"] = "attorney";
  PersonContactRelationshipType2["AUTO_SHOP"] = "auto_shop";
  PersonContactRelationshipType2["AT_FAULT_PARTY"] = "at_fault_party";
  PersonContactRelationshipType2["BI_ADJUSTER"] = "bi_adjuster";
  PersonContactRelationshipType2["BI_CLAIMS_DEPARTAMENT"] = "bi_claims_department";
  PersonContactRelationshipType2["BUSINESS_OWNER"] = "business_owner";
  PersonContactRelationshipType2["CHILD"] = "child";
  PersonContactRelationshipType2["CO_CLAIMANT"] = "co_claimant";
  PersonContactRelationshipType2["DEFENDANT_VEHICLE_OWNER"] = "defendant_vehicle_owner";
  PersonContactRelationshipType2["DOG_OWNER"] = "dog_owner";
  PersonContactRelationshipType2["DRIVER"] = "driver";
  PersonContactRelationshipType2["EXTENDED_FAMILY"] = "extended_family";
  PersonContactRelationshipType2["GOVERNMENT_ENTITY"] = "government_entity";
  PersonContactRelationshipType2["HOMEOWNER"] = "homeowner";
  PersonContactRelationshipType2["INVESTIGATOR"] = "investigator";
  PersonContactRelationshipType2["LAW_FIRM_REPRESENTATIVE"] = "law_firm_representative";
  PersonContactRelationshipType2["LESSEE"] = "lessee";
  PersonContactRelationshipType2["LESSOR"] = "lessor";
  PersonContactRelationshipType2["LIEN_PROVIDER"] = "lien_provider";
  PersonContactRelationshipType2["LIFE_PARTNER"] = "life_partner";
  PersonContactRelationshipType2["MEDICAL_FACILITY"] = "medical_facility";
  PersonContactRelationshipType2["MEDICAL_FACILITY_BILLING_DEPARTAMENT"] = "medical_facility_billing_department";
  PersonContactRelationshipType2["MEDPAY_ADJUSTER"] = "medpay_adjuster";
  PersonContactRelationshipType2["MILITARY_SPONSOR"] = "military_sponsor";
  PersonContactRelationshipType2["OTHER"] = "other";
  PersonContactRelationshipType2["PARENT"] = "parent";
  PersonContactRelationshipType2["PASSENGER"] = "passenger";
  PersonContactRelationshipType2["PD_ADJUSTER"] = "pd_adjuster";
  PersonContactRelationshipType2["PIP_ADJUSTER"] = "pip_adjuster";
  PersonContactRelationshipType2["PLANTIFFF_VEHICLE_OWNER"] = "plaintiff_vehicle_owner";
  PersonContactRelationshipType2["POLICE"] = "police";
  PersonContactRelationshipType2["POLICE_DEPARTMENT"] = "police_department";
  PersonContactRelationshipType2["PRE_LITIGATION_FUNDING"] = "pre_litigation_funding";
  PersonContactRelationshipType2["SIBLING"] = "sibling";
  PersonContactRelationshipType2["SPOUSE"] = "spouse";
  PersonContactRelationshipType2["SUBROGATION"] = "subrogation";
  PersonContactRelationshipType2["TOW_TRUCK"] = "tow_truck";
  PersonContactRelationshipType2["UM_UI_CLAIMS_DEPARTMENT"] = "um_uim_claims_department";
  PersonContactRelationshipType2["UM_UIM_ADJUSTER"] = "um_uim_adjuster";
  PersonContactRelationshipType2["VEHICLE_OWNER"] = "vehicle_owner";
  PersonContactRelationshipType2["WITNESS"] = "witness";
  PersonContactRelationshipType2["WORKERS_COMPENSATION"] = "workers_compensation";
  PersonContactRelationshipType2["ZIPLIENS_ANALYST"] = "zipliens_analyst";
  PersonContactRelationshipType2["ZIPLIENS_GENERAL"] = "zipliens_general";
  return PersonContactRelationshipType2;
})(PersonContactRelationshipType || {});
var PersonContactRelationshipTypeToNameMap = /* @__PURE__ */ ((PersonContactRelationshipTypeToNameMap2) => {
  PersonContactRelationshipTypeToNameMap2["adjuster"] = "Adjuster";
  PersonContactRelationshipTypeToNameMap2["attorney"] = "Attorney";
  PersonContactRelationshipTypeToNameMap2["auto_shop"] = "Auto Shop";
  PersonContactRelationshipTypeToNameMap2["at_fault_party"] = "At fault party";
  PersonContactRelationshipTypeToNameMap2["bi_adjuster"] = "BI Adjuster";
  PersonContactRelationshipTypeToNameMap2["bi_claims_department"] = "BI Claims department";
  PersonContactRelationshipTypeToNameMap2["business_owner"] = "Business Owner";
  PersonContactRelationshipTypeToNameMap2["child"] = "Child";
  PersonContactRelationshipTypeToNameMap2["co_claimant"] = "Co-Claimant";
  PersonContactRelationshipTypeToNameMap2["defendant_vehicle_owner"] = "Defendant vehicle owner";
  PersonContactRelationshipTypeToNameMap2["dog_owner"] = "Dog Owner";
  PersonContactRelationshipTypeToNameMap2["driver"] = "Driver";
  PersonContactRelationshipTypeToNameMap2["extended_family"] = "Extended family";
  PersonContactRelationshipTypeToNameMap2["government_entity"] = "Government entity";
  PersonContactRelationshipTypeToNameMap2["homeowner"] = "Homeowner";
  PersonContactRelationshipTypeToNameMap2["investigator"] = "Investigator";
  PersonContactRelationshipTypeToNameMap2["law_firm_representative"] = "Law firm representative";
  PersonContactRelationshipTypeToNameMap2["lessee"] = "Lessee";
  PersonContactRelationshipTypeToNameMap2["lessor"] = "Lessor";
  PersonContactRelationshipTypeToNameMap2["lien_provider"] = "Lien provider";
  PersonContactRelationshipTypeToNameMap2["life_partner"] = "Life partner";
  PersonContactRelationshipTypeToNameMap2["medical_facility"] = "Medical facility";
  PersonContactRelationshipTypeToNameMap2["medical_facility_billing_department"] = "Medical facility billing department";
  PersonContactRelationshipTypeToNameMap2["medpay_adjuster"] = "Medpay adjuster";
  PersonContactRelationshipTypeToNameMap2["military_sponsor"] = "Military sponsor";
  PersonContactRelationshipTypeToNameMap2["other"] = "Other";
  PersonContactRelationshipTypeToNameMap2["parent"] = "Parent";
  PersonContactRelationshipTypeToNameMap2["passenger"] = "Passenger";
  PersonContactRelationshipTypeToNameMap2["pd_adjuster"] = "PD Adjuster";
  PersonContactRelationshipTypeToNameMap2["pip_adjuster"] = "PIP Adjuster";
  PersonContactRelationshipTypeToNameMap2["plaintiff_vehicle_owner"] = "Plaintiff vehicle owner";
  PersonContactRelationshipTypeToNameMap2["police"] = "Police";
  PersonContactRelationshipTypeToNameMap2["police_department"] = "Police department";
  PersonContactRelationshipTypeToNameMap2["pre_litigation_funding"] = "Pre-Litigation funding";
  PersonContactRelationshipTypeToNameMap2["sibling"] = "Sibling";
  PersonContactRelationshipTypeToNameMap2["spouse"] = "Spouse";
  PersonContactRelationshipTypeToNameMap2["subrogation"] = "Subrogation";
  PersonContactRelationshipTypeToNameMap2["tow_truck"] = "Tow truck";
  PersonContactRelationshipTypeToNameMap2["um_uim_adjuster"] = "UM/UIM Adjuster";
  PersonContactRelationshipTypeToNameMap2["um_uim_claims_department"] = "UM/UIM Claims department";
  PersonContactRelationshipTypeToNameMap2["vehicle_owner"] = "Vehicle owner";
  PersonContactRelationshipTypeToNameMap2["witness"] = "Witness";
  PersonContactRelationshipTypeToNameMap2["workers_compensation"] = "Workers compensation";
  PersonContactRelationshipTypeToNameMap2["zipliens_analyst"] = "Zipliens analyst";
  PersonContactRelationshipTypeToNameMap2["zipliens_general"] = "Zipliens general contact";
  return PersonContactRelationshipTypeToNameMap2;
})(PersonContactRelationshipTypeToNameMap || {});
var ClaimantStatus = /* @__PURE__ */ ((ClaimantStatus2) => {
  ClaimantStatus2["AVAILABLE"] = "available";
  ClaimantStatus2["MINOR"] = "minor";
  ClaimantStatus2["DECEASED"] = "deceased";
  ClaimantStatus2["INCAPACITATED"] = "incapacitated";
  ClaimantStatus2["FOREIGNTRAVEL"] = "foreign travel";
  ClaimantStatus2["INCARCERATED"] = "incarcerated";
  ClaimantStatus2["OTHER"] = "other";
  return ClaimantStatus2;
})(ClaimantStatus || {});
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["MALE"] = "male";
  Gender2["FEMALE"] = "female";
  Gender2["NON_BINARY"] = "non-binary";
  Gender2["OTHER"] = "other";
  return Gender2;
})(Gender || {});
var EmploymentStatus = /* @__PURE__ */ ((EmploymentStatus2) => {
  EmploymentStatus2["FULLTIME"] = "full_time";
  EmploymentStatus2["PARTTIME"] = "part_time";
  EmploymentStatus2["RETIRED"] = "retired";
  EmploymentStatus2["DISABILITY"] = "disability";
  EmploymentStatus2["UNEMPLOYEDORFURLOUGHED"] = "unemployed_or_furloughed";
  EmploymentStatus2["SELFEMPLOYED"] = "self_employed";
  return EmploymentStatus2;
})(EmploymentStatus || {});
var MaritalStatus = /* @__PURE__ */ ((MaritalStatus2) => {
  MaritalStatus2["MARRIED"] = "married";
  MaritalStatus2["WIDOWED"] = "widowed";
  MaritalStatus2["SEPARATED"] = "separated";
  MaritalStatus2["DIVORCED"] = "divorced";
  MaritalStatus2["SINGLE"] = "single";
  return MaritalStatus2;
})(MaritalStatus || {});
var PreferredContactChannel = /* @__PURE__ */ ((PreferredContactChannel2) => {
  PreferredContactChannel2["EMAIL"] = "email";
  PreferredContactChannel2["SMS"] = "sms";
  PreferredContactChannel2["VOICE"] = "voice";
  return PreferredContactChannel2;
})(PreferredContactChannel || {});
var PostProvenOutreachFrequency = /* @__PURE__ */ ((PostProvenOutreachFrequency2) => {
  PostProvenOutreachFrequency2["THIRTY_DAYS"] = "30 days";
  PostProvenOutreachFrequency2["SIXTY_DAYS"] = "60 days";
  PostProvenOutreachFrequency2["NINETY_DAYS"] = "90 days";
  return PostProvenOutreachFrequency2;
})(PostProvenOutreachFrequency || {});
var PersonAddressType = /* @__PURE__ */ ((PersonAddressType2) => {
  PersonAddressType2["HOME"] = "home";
  PersonAddressType2["OFFICE"] = "office";
  PersonAddressType2["OTHER"] = "other";
  return PersonAddressType2;
})(PersonAddressType || {});

// src/Phone/index.ts
var PhoneNumberType = /* @__PURE__ */ ((PhoneNumberType2) => {
  PhoneNumberType2["OFFICE"] = "office";
  PhoneNumberType2["FAX"] = "fax";
  PhoneNumberType2["HOME"] = "home";
  PhoneNumberType2["MOBILE"] = "mobile";
  return PhoneNumberType2;
})(PhoneNumberType || {});

// src/Snapshot/index.ts
var ObjectiveStatus = /* @__PURE__ */ ((ObjectiveStatus2) => {
  ObjectiveStatus2["TO_DO"] = "To do";
  ObjectiveStatus2["IN_PROGRESS"] = "In progress";
  ObjectiveStatus2["BLOCKED"] = "Blocked";
  ObjectiveStatus2["COMPLETED"] = "Completed";
  ObjectiveStatus2["NOT_NEEDED"] = "Not needed";
  return ObjectiveStatus2;
})(ObjectiveStatus || {});
var MilestoneStatus = /* @__PURE__ */ ((MilestoneStatus2) => {
  MilestoneStatus2["TO_DO"] = "To do";
  MilestoneStatus2["IN_PROGRESS"] = "In progress";
  MilestoneStatus2["BLOCKED"] = "Blocked";
  MilestoneStatus2["COMPLETED"] = "Completed";
  return MilestoneStatus2;
})(MilestoneStatus || {});
var MilestoneType = /* @__PURE__ */ ((MilestoneType2) => {
  MilestoneType2["MANUAL"] = "manual";
  MilestoneType2["AUTOMATIC"] = "automatic";
  return MilestoneType2;
})(MilestoneType || {});
var ObjectiveOwnedBy = /* @__PURE__ */ ((ObjectiveOwnedBy2) => {
  ObjectiveOwnedBy2["CampaignManager"] = "Campaign Manager";
  ObjectiveOwnedBy2["CaseCoordinator"] = "Case Coordinator";
  ObjectiveOwnedBy2["CaseManager"] = "Case Manager";
  ObjectiveOwnedBy2["ClientSpecialist"] = "Client Specialist";
  ObjectiveOwnedBy2["LegalSpecialist"] = "Legal Specialist";
  ObjectiveOwnedBy2["RetrievalCoordinator"] = "Retrieval Coordinator";
  ObjectiveOwnedBy2["Review_QC"] = "Review/QC";
  ObjectiveOwnedBy2["SpecialOps"] = "Special Ops";
  return ObjectiveOwnedBy2;
})(ObjectiveOwnedBy || {});
var ObjectiveOwnedByOptions = Object.values(ObjectiveOwnedBy);

// src/StatuteOfLimitations/index.ts
var SolTypes = /* @__PURE__ */ ((SolTypes2) => {
  SolTypes2["CONTACT"] = "Contact";
  SolTypes2["INJURY"] = "Injury";
  SolTypes2["RETAINED"] = "Retained";
  SolTypes2["PIP"] = "Personal Injury Protection";
  return SolTypes2;
})(SolTypes || {});

// src/Tasks/type-entity.ts
var TaskTypeCreationType = /* @__PURE__ */ ((TaskTypeCreationType2) => {
  TaskTypeCreationType2["MANUAL"] = "Manual";
  TaskTypeCreationType2["AUTOMATIC"] = "Automatic";
  TaskTypeCreationType2["BOTH"] = "Both";
  return TaskTypeCreationType2;
})(TaskTypeCreationType || {});
var TaskTypeDueDate = /* @__PURE__ */ ((TaskTypeDueDate2) => {
  TaskTypeDueDate2["IMMEDIATE"] = "Immediate";
  TaskTypeDueDate2["SEVEN_DAYS"] = "7 days";
  TaskTypeDueDate2["TWENTY_ONE_DAYS"] = "21 days";
  TaskTypeDueDate2["TWENTY_EIGHT_DAYS"] = "28 days";
  TaskTypeDueDate2["THIRTY_DAYS"] = "30 days";
  TaskTypeDueDate2["ONE_BUSINESS_DAY"] = "1 business day";
  TaskTypeDueDate2["TWO_BUSINESS_DAYS"] = "2 business days";
  TaskTypeDueDate2["THREE_BUSINESS_DAYS"] = "3 business days";
  TaskTypeDueDate2["TEN_BUSINESS_DAYS"] = "10 business days";
  return TaskTypeDueDate2;
})(TaskTypeDueDate || {});
var TaskOwner = /* @__PURE__ */ ((TaskOwner2) => {
  TaskOwner2["LEAD_OWNER"] = "Lead Owner";
  TaskOwner2["SUB_OWNER"] = "Sub Owner";
  TaskOwner2["LEGAL_PREPARATION_OWNER"] = "Legal Preparation Owner";
  TaskOwner2["LEGAL_QC_OWNER"] = "Legal QC Owner";
  TaskOwner2["CAMPAIGN_MANAGER"] = "Campaign Manager";
  TaskOwner2["LEAD_OWNER_OR_CAMPAIGN_MANAGER"] = "Lead Owner or Campaign Manager (If no lead owner)";
  TaskOwner2["SUB_OWNER_OR_LEAD_OWNER_OR_CAMPAIGN_MANAGER"] = "Sub Owner or Lead Owner (If no sub owner) or Campaign Manager (If no sub owner and no lead owner)";
  TaskOwner2["ROUND_ROBIN_OWNER"] = "Round Robin Owner";
  return TaskOwner2;
})(TaskOwner || {});
function getAtPath(obj, path) {
  if (obj == null || typeof obj !== "object")
    return void 0;
  return path.split(".").reduce((acc, key) => acc == null ? void 0 : acc[key], obj);
}
var OWNER_PATHS = {
  ["Lead Owner" /* LEAD_OWNER */]: [`${"owner" /* OWNER */}Id`],
  ["Sub Owner" /* SUB_OWNER */]: [`${"subOwner" /* SUB_OWNER */}Id`],
  ["Legal Preparation Owner" /* LEGAL_PREPARATION_OWNER */]: [`${"legalPreparationOwner" /* LEGAL_PREPARATION_OWNER */}Id`],
  ["Legal QC Owner" /* LEGAL_QC_OWNER */]: [`${"legalQCOwner" /* LEGAL_QC_OWNER */}Id`],
  ["Campaign Manager" /* CAMPAIGN_MANAGER */]: ["dockitCampaign.campaignManagerId"],
  ["Lead Owner or Campaign Manager (If no lead owner)" /* LEAD_OWNER_OR_CAMPAIGN_MANAGER */]: [
    `${"owner" /* OWNER */}Id`,
    "dockitCampaign.campaignManagerId"
  ],
  ["Sub Owner or Lead Owner (If no sub owner) or Campaign Manager (If no sub owner and no lead owner)" /* SUB_OWNER_OR_LEAD_OWNER_OR_CAMPAIGN_MANAGER */]: [
    `${"subOwner" /* SUB_OWNER */}Id`,
    `${"owner" /* OWNER */}Id`,
    "dockitCampaign.campaignManagerId"
  ]
};
function getTaskAssigneeId(taskOwner, lead) {
  if (!lead)
    return void 0;
  const paths = OWNER_PATHS[taskOwner];
  if (!paths)
    return void 0;
  for (const path of paths) {
    const leadValueAtPath = getAtPath(lead, path);
    if (leadValueAtPath != null) {
      const normalizedValue = String(leadValueAtPath).trim();
      if (normalizedValue !== "") {
        return normalizedValue;
      }
    }
  }
}

// src/Tasks/index.ts
var TaskStatus = /* @__PURE__ */ ((TaskStatus2) => {
  TaskStatus2["BLOCKED"] = "Blocked";
  TaskStatus2["COMPLETED"] = "Completed";
  TaskStatus2["IN_PROGRESS"] = "In progress";
  TaskStatus2["NOT_NEEDED"] = "Not needed";
  TaskStatus2["TO_DO"] = "To do";
  return TaskStatus2;
})(TaskStatus || {});
var TaskStatusGroups = {
  OPEN: ["To do" /* TO_DO */, "In progress" /* IN_PROGRESS */, "Blocked" /* BLOCKED */],
  CLOSED: ["Completed" /* COMPLETED */, "Not needed" /* NOT_NEEDED */]
};
var TaskType = /* @__PURE__ */ ((TaskType2) => {
  TaskType2["Appointment"] = "Appointment";
  TaskType2["AppointmentCanceled"] = "Appointment Canceled";
  TaskType2["AppointmentNoShow"] = "Appointment No Show";
  TaskType2["AppointmentScheduled"] = "Appointment Scheduled";
  TaskType2["AppointmentWelcomeCall"] = "Welcome Call";
  TaskType2["CaseCheckIn"] = "Case Check-in";
  TaskType2["CaseWisePortalSubmission"] = "CaseWise Portal Submission";
  TaskType2["CheckAppointments"] = "Check appointments";
  TaskType2["CreateMedicalEventsAndRequestRecords"] = "Create Medical Events & Request Records";
  TaskType2["DiscoveryDocCallBackNeeded"] = "Discovery Doc Call Back Needed";
  TaskType2["DiscoveryDocRevisionExposureInfoCritical"] = "Discovery Doc Revision: Exposure Info (Critical)";
  TaskType2["DiscoveryDocRevisionGrammaticalMinor"] = "Discovery Doc Revision: Grammatical (Minor)";
  TaskType2["DiscoveryDocRevisionInaccurateMedicalInfoCritical"] = "Discovery Doc Revision: Inaccurate Medical Info (Critical)";
  TaskType2["DiscoveryDocRevisionIncompleteMissingInfoMajor"] = "Discovery Doc Revision: Incomplete/Missing Info (Major)";
  TaskType2["DocumentReceivedBillingRecords"] = "Document Received (Billing Records)";
  TaskType2["DocumentReceivedInsuranceLien"] = "Document Received (Insurance/Lien)";
  TaskType2["DocumentReceivedIntakeQForm"] = "Document Received (IntakeQ Form)";
  TaskType2["DocumentReceivedMedicalRecords"] = "Document Received (Medical Records)";
  TaskType2["DocumentReceivedRepresentativeDocument"] = "Document Received (Rep Doc)";
  TaskType2["DocumentReceivedSignature"] = "Document Received (Signature)";
  TaskType2["DiscoveryDocumentInternalRevisions"] = "Discovery Document Internal Revisions";
  TaskType2["DiscoveryDocumentQC"] = "Discovery Document QC";
  TaskType2["DispositionReview"] = "Disposition Review";
  TaskType2["ImmediateActionLetterProcessing"] = "IAL Processing";
  TaskType2["InvoiceApprovalNeeded"] = "Invoice Approval Needed";
  TaskType2["LawFirmCommunication"] = "Law Firm Communication";
  TaskType2["Mailroom"] = "Mailroom";
  TaskType2["MissingAccidentDetails"] = "Missing Accident Details";
  TaskType2["NewDocumentImported"] = "New document imported.";
  TaskType2["OpenBIClaim"] = "Open BI Claim";
  TaskType2["OpenUMUIMClaim"] = "Open UM/UIM Claim";
  TaskType2["PipSolForm"] = "PIP SOL Form";
  TaskType2["PoliceCrashReportReview"] = "Police/Crash Report Review";
  TaskType2["ReceivedAdditionalRecordsDiscoveryDocs"] = "Received Additional Records - Discovery Docs";
  TaskType2["ReducedScopeNeeded"] = "Reduced Scope Needed";
  TaskType2["Rejection"] = "Rejection";
  TaskType2["ReviewDocuments"] = "Review Documents";
  TaskType2["ReviewForAcceptableSignatureAndSendRequests"] = "Review for Acceptable Signature & Send Requests";
  TaskType2["ReviewPartialRecords"] = "Review Partial Records";
  TaskType2["SoLVerification"] = "SOL Verification";
  TaskType2["StatuteOfLimitationReminder"] = "Statute of Limitation Reminder";
  return TaskType2;
})(TaskType || {});

// src/AI/ask-documents.ts
var AskDocumentQueueStatus = /* @__PURE__ */ ((AskDocumentQueueStatus2) => {
  AskDocumentQueueStatus2["QUEUED"] = "queued";
  AskDocumentQueueStatus2["PROCESSING"] = "processing";
  AskDocumentQueueStatus2["COMPLETED"] = "completed";
  AskDocumentQueueStatus2["FAILED"] = "failed";
  AskDocumentQueueStatus2["PARTIAL"] = "partial";
  AskDocumentQueueStatus2["CANCELLED"] = "cancelled";
  return AskDocumentQueueStatus2;
})(AskDocumentQueueStatus || {});

// src/CaseWiseNotification/index.ts
var CaseWiseNotificationFrequency = /* @__PURE__ */ ((CaseWiseNotificationFrequency2) => {
  CaseWiseNotificationFrequency2["DAILY"] = "daily";
  CaseWiseNotificationFrequency2["WEEKLY"] = "weekly";
  CaseWiseNotificationFrequency2["BI_WEEKLY"] = "bi-weekly";
  return CaseWiseNotificationFrequency2;
})(CaseWiseNotificationFrequency || {});
var CaseWiseNotificationLimitType = /* @__PURE__ */ ((CaseWiseNotificationLimitType2) => {
  CaseWiseNotificationLimitType2["TWO_WEEKS"] = "two-weeks";
  CaseWiseNotificationLimitType2["ONE_MONTH"] = "one-month";
  CaseWiseNotificationLimitType2["CUSTOM"] = "custom";
  CaseWiseNotificationLimitType2["UNLIMITED"] = "unlimited";
  return CaseWiseNotificationLimitType2;
})(CaseWiseNotificationLimitType || {});
export {
  ALLOWED_FIVE9_CAMPAIGN_PREFIXES,
  ASSIGN_TO_FACILITY_OWNER_REASONS,
  ASSIGN_TO_LEAD_OWNER_REASONS,
  ASSIGN_TO_REP_DOC_TEAM_OWNER_REASONS,
  AUTO_BI_LIABILITY_STATUS_OPTIONS,
  AUTO_COVERAGE_TYPES,
  AbbrevToNameMap,
  ActionRequestScreeningStatus,
  ActionRequestStatus,
  ActionRequestSubType,
  ActionRequestType,
  ActivityNoteChannels,
  ActivityNoteChannelsPI,
  ActivityNoteDetailType,
  ActivityNoteDetailTypePI,
  ActivityType,
  AlaCarteRateTypes,
  AppointmentStatus,
  AppointmentType,
  AskDocumentQueueStatus,
  AuditTrailType,
  AutoBIliabilityStatus,
  AutoCoverageSubType,
  AutoCoverageType,
  BENEFIT_AMOUNTS,
  BIIteratorKeys,
  BILLING_DOCUMENT_TYPES,
  BILLING_RECORDS_DOCUMENT_TYPES,
  BI_COMBINED_SINGLE_LIMIT_AMOUNTS,
  BI_COVERAGE_AMOUNTS,
  BI_SPLIT_LIMIT_INCIDENT_AMOUNTS,
  BI_SPLIT_LIMIT_PERSON_AMOUNTS,
  BillingEventInvoiceStatus,
  BillingEventStatus,
  BillingEventType,
  BillingSummary,
  BrandingExperience,
  BrandingTheme,
  BriefUserPermission,
  CASE_COORDINATOR_CAMPAIGN_PREFIXES,
  CLIENT_SPECIALIST_CAMPAIGN_PREFIXES,
  COVERAGE_STATUSES,
  CallService,
  CaseTouchStatus,
  CaseWiseNotificationFrequency,
  CaseWiseNotificationLimitType,
  ClaimantRepresentativeRelationshipType,
  ClaimantRepresentativeType,
  ClaimantStatus,
  CommunicationDirection,
  ContactInfoType,
  ContextFieldMapping,
  ContextFieldMappings,
  ContextMapping,
  ConversationChannel,
  CoverageStatus,
  DISCOVERY_DOCUMENT_DETAIL_DOCUMENT_STATUSES,
  DISCOVERY_DOCUMENT_DETAIL_DOCUMENT_TYPES,
  DemandLetterSectionType,
  DirectoryPaths,
  DiscoveryDocumentDetailDocumentStatus,
  DiscoveryDocumentDetailDocumentType,
  DockitFieldSourceMapping,
  DockitUserType,
  DocumentRequestBillingSummary,
  DocumentRequestClosedReason,
  DocumentRequestMethod,
  DocumentRequestRecordType,
  DocumentRequestRejectedReason,
  DocumentRequestRejectedReasonMap,
  DocumentRequestStatus,
  DocumentRequestType,
  DocumentScreeningRejectionReason,
  DocumentSendMethod,
  DocumentSendStatus,
  DocumentSource,
  DocumentStatus,
  DocumentSubType,
  DocumentType,
  DocxTemplateType,
  EmploymentStatus,
  Entity,
  FIVE9_TEAM_NAME_MAPPING,
  FieldKeyToPdfKeyMap,
  FieldValueDescription,
  FindingContextFieldMapping,
  FindingContextFieldMappings,
  FindingContextMapping,
  FindingError,
  FindingProofType,
  FindingType,
  FindingTypesByMatterType,
  FireFoamFindingContextFieldMapping,
  FireFoamFindingContextFieldMappings,
  FormContextFieldMapping,
  FormElementType,
  FormMatrixElementType,
  Gender,
  HEALTH_COVERAGE_TYPES,
  INSURANCE_CLAIM_STATUSES,
  ImmediateActionLetterCreateDTO,
  ImmediateActionLetterStatus,
  ImmediateActionLetterType,
  ImmediateActionLetterUpdateDTO,
  IneligibleReason,
  InjuryFieldNamesByFindingType,
  InsuranceClaimStatus,
  InsurancePolicyType,
  IntegrationType,
  LEGAL_SPECIALIST_CAMPAIGN_PREFIXES,
  LIMIT_TYPES,
  LawFirmStaffRole,
  LeadOwnerRole,
  LeadStatus,
  LeadStatusConfiguration,
  LeadVerificationStatus,
  LienResolutionPartners,
  LienStatus,
  LienSubType,
  LienType,
  LimitType,
  LineOfBusiness,
  MEDICAL_RECORDS_DOCUMENT_TYPES,
  MED_PAY_BENEFIT_AMOUNTS,
  MaritalStatus,
  MassTortRateTypes,
  MatrixColumnOption,
  MatterType,
  MedBillExtractionStatus,
  MedBillLineItemStatus,
  MedBillLineItemType,
  MedBillStatus,
  MedicalBillType,
  MedicalEventContextFieldMapping,
  MedicalFacilityAddressType,
  MedicalFacilityAddressTypeLabel,
  MedicalFacilityEmailType,
  MedicalFacilityIteratorKeys,
  MedicalFacilityPhoneNumberType,
  MedicalFacilityPhoneNumberTypeLabel,
  MessageDeliveryStatus,
  MessageDirection,
  MessageSource,
  MilestoneRateTypeMap,
  MilestoneRateTypes,
  MilestoneStatus,
  MilestoneType,
  MilitaryStatus,
  MultipleChargeRateTypes,
  NON_CANCELABLE_DOCUMENT_REQUEST_STATUSES,
  NaturalDisasterRateTypes,
  NegotiationEventStatus,
  NotarizationType,
  NotificationFrequency,
  ObjectiveOwnedBy,
  ObjectiveOwnedByOptions,
  ObjectiveStatus,
  OrganizationAddressType,
  OrganizationType,
  PIP_BENEFIT_AMOUNTS,
  PIP_COVERAGE_SUB_TYPES,
  ParaquatFindingContextFieldMapping,
  ParaquatFindingContextFieldMappings,
  PassThroughRateTypes,
  PdfTemplateFonts,
  PdfTemplatePacketStatus,
  PdfTemplateStatus,
  PdfTemplateType,
  PersonAddressType,
  PersonContactRelationshipType,
  PersonContactRelationshipTypeToNameMap,
  PersonalInjuryRateTypes,
  PhoneNumberType,
  PostProvenOutreachFrequency,
  PreferredContactChannel,
  QUALIFIED_FINDING_SOURCE_OPTIONS,
  RateType,
  ResourceTypeFormElements,
  RestrictionType,
  RoundupFindingContextFieldMapping,
  RoundupFindingContextFieldMappings,
  SIGNATURE_RESEND_FEATURE_RELEASE_DATE,
  ScalarShapes,
  SecondaryRelationshipType,
  SexualAssaultRateTypes,
  SignatureReleaseActionRequestStatus,
  SmokingHistoryOptions,
  SmokingStatusOptions,
  SmokingVolumeOptions,
  SolTypes,
  SometimesNotApplicableBoolean,
  State,
  StateMap,
  SubTypeToNameMap,
  TORTICITY_BRANDING_ID,
  TalcumFindingContextFieldMapping,
  TalcumFindingContextFieldMappings,
  TaskOwner,
  TaskStatus,
  TaskStatusGroups,
  TaskType,
  TaskTypeCreationType,
  TaskTypeDueDate,
  TobaccoTypeOptions,
  TypeToNameMap,
  UI_UIM_COMBINED_SINGLE_LIMIT_AMOUNTS,
  UI_UIM_SPLIT_LIMIT_INCIDENT_AMOUNTS,
  UI_UIM_SPLIT_LIMIT_PERSON_AMOUNTS,
  UMUIMIteratorKeys,
  UM_UIM_COVERAGE_SUB_TYPES,
  WILDFIRE_DIRECTORY_PATHS,
  WILDFIRE_DOCUMENT_GROUP_CONFIGS,
  actionRequestMap,
  activityNoteDetailPITypeMap,
  activityNoteDetailTypeMap,
  defaultAddress,
  defaultReturnTo,
  getFieldNamesForFindingType,
  getFindingDisplayName,
  getProofTypeDisplayName,
  getStatusesForConfiguration,
  getTaskAssigneeId,
  hasLeadStatusConfiguration
};
//# sourceMappingURL=index.mjs.map